'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var keymap = require('../keymap/index.js');
var keymap__default = _interopDefault(keymap);
var preact = require('preact');
var throttle = _interopDefault(require('lodash.throttle'));
var index_js = require('../utils/index.js');
var classNames = _interopDefault(require('classnames'));
var index_js$1 = require('../components/index.js');
var prosemirrorState = require('prosemirror-state');
var prosemirrorView = require('prosemirror-view');
var prosemirrorModel = require('prosemirror-model');
var index_js$2 = require('../cursor/index.js');
var prosemirrorTransform = require('prosemirror-transform');

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty = _defineProperty;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var objectSpread = _objectSpread;

var TriangleIcon = (props => preact.h("svg", {
  class: "icon",
  style: "",
  viewBox: "0 0 1638 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  id: "mx_n_1513063069382",
  width: "10.8",
  height: "7.4"
}, preact.h("defs", null, preact.h("style", {
  type: "text/css"
})), preact.h("path", {
  d: "M1595.8016 262.7584a160.5632 160.5632 0 0 0 31.5392-167.936A145.2032 145.2032 0 0 0 1493.4016 0H144.9984a145.408 145.408 0 0 0-133.9392 95.0272A163.0208 163.0208 0 0 0 0 154.0096c0 39.936 14.7456 79.2576 42.3936 108.7488L716.8 978.944c27.2384 28.8768 64.1024 45.056 102.4 45.056 38.5024 0 75.3664-16.384 102.4-45.056l674.2016-716.1856z",
  fill: "#3789A9"
})));

var DashedIcon = (props => preact.h("svg", {
  width: "48px",
  height: "42px",
  viewBox: "0 0 48 42",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, preact.h("title", null, "\u865A\u7EBF\u6846"), preact.h("desc", null, "Created with Sketch."), preact.h("defs", null), preact.h("g", {
  id: "Page-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, preact.h("g", {
  id: "\u8868\u683C\u5C5E\u6027"
}, preact.h("path", {
  d: "M45,16.5 L45,10.5 L48,10.5 L48,16.5 L45,16.5 Z M45,25.5 L48,25.5 L48,31.5 L45,31.5 L45,25.5 Z M45,34.5 L48,34.5 L48,36 C48,39.3137085 45.3137085,42 42,42 L37.4854431,42 L37.4854431,39 L42,39 C43.6568542,39 45,37.6568542 45,36 L45,34.5 Z M34.4854431,39 L34.4854431,42 L28.4854431,42 L28.4854431,39 L34.4854431,39 Z M19.4854431,39 L19.4854431,42 L13.4854431,42 L13.4854431,39 L19.4854431,39 Z M10.4854431,39 L10.4854431,42 L6,42 C2.6862915,42 0,39.3137085 0,36 L0,34.5 L3,34.5 L3,36 C3,37.6568542 4.34314575,39 6,39 L10.4854431,39 Z M3,31.5 L0,31.5 L0,25.5 L3,25.5 L3,31.5 Z M3,16.5 L0,16.5 L0,10.5 L3,10.5 L3,16.5 Z M3,7.5 L0,7.5 L0,6 C0,2.6862915 2.6862915,0 6,0 L10.4854431,0 L10.4854431,3 L6,3 C4.34314575,3 3,4.34314575 3,6 L3,7.5 Z M13.4854431,3 L13.4854431,0 L19.4854431,0 L19.4854431,3 L13.4854431,3 Z M28.4854431,3 L28.4854431,0 L34.4854431,0 L34.4854431,3 L28.4854431,3 Z M37.4854431,3 L37.4854431,0 L42,0 C45.3137085,0 48,2.6862915 48,6 L48,7.5 L45,7.5 L45,6 C45,4.34314575 43.6568542,3 42,3 L37.4854431,3 Z",
  fill: "#6B6B6B",
  "fill-rule": "nonzero"
}), preact.h("path", {
  d: "M25.4854431,22.5 L25.4854431,31.538842 L22.4854431,31.538842 L22.4854431,22.5 L10.2857143,22.5 L10.2857143,19.5 L22.4854431,19.5 L22.4854431,10.461158 L25.4854431,10.461158 L25.4854431,19.5 L37.7142857,19.5 L37.7142857,22.5 L25.4854431,22.5 Z M-2.27373675e-13,22.5 L-2.27373675e-13,19.5 L6.85714286,19.5 L6.85714286,22.5 L-2.27373675e-13,22.5 Z M41.1428571,22.5 L41.1428571,19.5 L48,19.5 L48,22.5 L41.1428571,22.5 Z M22.4854431,1.42108547e-14 L25.4854431,1.42108547e-14 L25.4854431,6.97410534 L22.4854431,6.97410534 L22.4854431,1.42108547e-14 Z M22.4854431,35.0258947 L25.4854431,35.0258947 L25.4854431,42 L22.4854431,42 L22.4854431,35.0258947 Z",
  id: "Combined-Shape",
  fill: "#CCCCCC"
})))));

var SolidIcon = (props => preact.h("svg", {
  width: "48px",
  height: "42px",
  viewBox: "0 0 48 42",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
}, preact.h("title", null, "\u5B9E\u7EBF\u6846"), preact.h("desc", null, "Created with Sketch."), preact.h("defs", null), preact.h("g", {
  id: "Page-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, preact.h("g", {
  id: "Group-9"
}, preact.h("path", {
  d: "M25.4854431,22.5 L25.4854431,31.538842 L22.4854431,31.538842 L22.4854431,22.5 L17.1428571,22.5 L10.2857143,22.5 L10.2857143,19.5 L17.1428571,19.5 L22.4854431,19.5 L22.4854431,10.461158 L25.4854431,10.461158 L25.4854431,19.5 L33.7302246,19.5 L37.7142857,19.5 L37.7142857,22.5 L33.7302246,22.5 L25.4854431,22.5 Z M0,22.5 L0,19.5 L6.85714286,19.5 L6.85714286,22.5 L0,22.5 Z M41.1428571,22.5 L41.1428571,19.5 L48,19.5 L48,22.5 L41.1428571,22.5 Z M22.4854431,0 L25.4854431,0 L25.4854431,6.97410534 L22.4854431,6.97410534 L22.4854431,0 Z M22.4854431,35.0258947 L25.4854431,35.0258947 L25.4854431,42 L22.4854431,42 L22.4854431,35.0258947 Z",
  id: "Combined-Shape",
  fill: "#CCCCCC"
}), preact.h("path", {
  d: "M6,3 C4.34314575,3 3,4.34314575 3,6 L3,36 C3,37.6568542 4.34314575,39 6,39 L42,39 C43.6568542,39 45,37.6568542 45,36 L45,6 C45,4.34314575 43.6568542,3 42,3 L6,3 Z M6,0 L42,0 C45.3137085,0 48,2.6862915 48,6 L48,36 C48,39.3137085 45.3137085,42 42,42 L6,42 C2.6862915,42 0,39.3137085 0,36 L0,6 C0,2.6862915 2.6862915,0 6,0 Z",
  id: "Rectangle-15",
  fill: "#6B6B6B",
  "fill-rule": "nonzero"
})))));

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".toolbar-color-popover-wrapper{display:flex;justify-content:center;align-items:center;position:relative;height:28px;width:40px;font-size:12px;cursor:pointer;transition:all .2s ease}.toolbar-color-popover-wrapper.disabled{cursor:not-allowed}.toolbar-color-popover-wrapper.disabled path{fill:#aaa}.toolbar-color-popover-wrapper .left{width:26px;height:100%}.toolbar-color-popover-wrapper .right{width:14px;height:100%;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='7' height='4' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M.5.5h6l-3 3z' fill='%23AEAEAE' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 50%}.toolbar-color-popover-wrapper.font-color{position:relative}.toolbar-color-popover-wrapper.font-color .left{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='10' height='10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6.62 5.902L5.01 1.484 3.302 5.902H6.62zM4.26 0h1.624l3.844 10H8.156L7.08 7.005H2.89L1.743 10H.272L4.26 0z' fill='%23666' fill-rule='evenodd'/%3E%3C/svg%3E\") no-repeat 7px 7px}.toolbar-color-popover-wrapper.font-color .left .color{position:absolute;left:5px;bottom:7px;width:14px;height:2px;border:1px solid;margin:0 auto}.toolbar-color-popover-wrapper.bg-color .left{position:relative}.toolbar-color-popover-wrapper.bg-color .color{position:absolute;top:18px;left:5px;width:14px;height:2px}.toolbar-color-popover-wrapper.border-color{width:246px}.toolbar-color-popover{display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;position:absolute;width:258px;height:150px;bottom:-152px;left:0;padding:8px;border-radius:2px;background:#fff;border:1px solid #eee;box-shadow:0 1px 4px 0 rgba(111,130,166,.08),0 16px 30px 0 rgba(111,130,166,.14);z-index:2}.toolbar-color-popover .default{position:relative;width:calc(100% - 2px);margin:0 1px 8px;height:24px;border:1px solid #ddd;border-radius:2px;cursor:pointer}.toolbar-color-popover .color-grid{position:absolute;top:5px;left:10px;width:13px;height:13px;border:1px solid}.toolbar-color-popover .text{height:24px;line-height:24px;text-align:center;font-size:12px;color:#333}.toolbar-color-grid{margin:0 2px;width:16px;height:16px;cursor:pointer}.toolbar-color-grid:nth-child(2),.toolbar-color-grid:nth-child(12){border:1px solid #eee}.toolbar-color-grid.selected{z-index:2;border-radius:1px;border:1px solid #fff;box-shadow:0 0 0 2px #999}.toolbar-color-grid:hover{z-index:3;border-radius:1px;border:1px solid #fff}.toolbar-color-grid:hover:nth-child(3){box-shadow:0 0 0 2px #333}.toolbar-color-grid:hover:nth-child(4){box-shadow:0 0 0 2px #f5222d}.toolbar-color-grid:hover:nth-child(5){box-shadow:0 0 0 2px #fa541c}.toolbar-color-grid:hover:nth-child(6){box-shadow:0 0 0 2px #faad14}.toolbar-color-grid:hover:nth-child(7){box-shadow:0 0 0 2px #fadb14}.toolbar-color-grid:hover:nth-child(8){box-shadow:0 0 0 2px #52c41a}.toolbar-color-grid:hover:nth-child(9){box-shadow:0 0 0 2px #13c2c2}.toolbar-color-grid:hover:nth-child(10){box-shadow:0 0 0 2px #1890ff}.toolbar-color-grid:hover:nth-child(11){box-shadow:0 0 0 2px #2f54eb}.toolbar-color-grid:hover:nth-child(12){box-shadow:0 0 0 2px #722ed1}.toolbar-color-grid:hover:nth-child(13){box-shadow:0 0 0 2px #eb2f96}.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #f6f6f6}.toolbar-color-grid:hover:nth-child(15){box-shadow:0 0 0 2px #989898}.toolbar-color-grid:hover:nth-child(16){box-shadow:0 0 0 2px #ffe8e7}.toolbar-color-grid:hover:nth-child(17){box-shadow:0 0 0 2px #ffece0}.toolbar-color-grid:hover:nth-child(18){box-shadow:0 0 0 2px #fff7cb}.toolbar-color-grid:hover:nth-child(19){box-shadow:0 0 0 2px #fcfcca}.toolbar-color-grid:hover:nth-child(20){box-shadow:0 0 0 2px #e5f7d3}.toolbar-color-grid:hover:nth-child(21){box-shadow:0 0 0 2px #cffff7}.toolbar-color-grid:hover:nth-child(22){box-shadow:0 0 0 2px #d4eefc}.toolbar-color-grid:hover:nth-child(23){box-shadow:0 0 0 2px #dfe8fc}.toolbar-color-grid:hover:nth-child(24){box-shadow:0 0 0 2px #efe1fa}.toolbar-color-grid:hover:nth-child(25){box-shadow:0 0 0 2px #fbe1eb}.toolbar-color-grid:hover:nth-child(26){box-shadow:0 0 0 2px #e9e9e9}.toolbar-color-grid:hover:nth-child(27){box-shadow:0 0 0 2px #666}.toolbar-color-grid:hover:nth-child(28){box-shadow:0 0 0 2px #ffa39e}.toolbar-color-grid:hover:nth-child(29){box-shadow:0 0 0 2px #ffbb96}.toolbar-color-grid:hover:nth-child(30){box-shadow:0 0 0 2px #ffe58f}.toolbar-color-grid:hover:nth-child(31){box-shadow:0 0 0 2px #fffb8f}.toolbar-color-grid:hover:nth-child(32){box-shadow:0 0 0 2px #b7eb8f}.toolbar-color-grid:hover:nth-child(33){box-shadow:0 0 0 2px #87e8de}.toolbar-color-grid:hover:nth-child(34){box-shadow:0 0 0 2px #91d5ff}.toolbar-color-grid:hover:nth-child(35){box-shadow:0 0 0 2px #adc6ff}.toolbar-color-grid:hover:nth-child(36){box-shadow:0 0 0 2px #d3adf7}.toolbar-color-grid:hover:nth-child(37){box-shadow:0 0 0 2px #ffadd2}.toolbar-color-grid:hover:nth-child(38){box-shadow:0 0 0 2px #ddd}.toolbar-color-grid:hover:nth-child(39){box-shadow:0 0 0 2px #4b4b4b}.toolbar-color-grid:hover:nth-child(40){box-shadow:0 0 0 2px #ff4d4f}.toolbar-color-grid:hover:nth-child(41){box-shadow:0 0 0 2px #ff7a45}.toolbar-color-grid:hover:nth-child(42){box-shadow:0 0 0 2px #ffc53d}.toolbar-color-grid:hover:nth-child(43){box-shadow:0 0 0 2px #ffec3d}.toolbar-color-grid:hover:nth-child(44){box-shadow:0 0 0 2px #73d13d}.toolbar-color-grid:hover:nth-child(45){box-shadow:0 0 0 2px #36cfc9}.toolbar-color-grid:hover:nth-child(46){box-shadow:0 0 0 2px #40a8ff}.toolbar-color-grid:hover:nth-child(47){box-shadow:0 0 0 2px #597ef7}.toolbar-color-grid:hover:nth-child(48){box-shadow:0 0 0 2px #9254de}.toolbar-color-grid:hover:nth-child(49){box-shadow:0 0 0 2px #f759ab}.toolbar-color-grid:hover:nth-child(50){box-shadow:0 0 0 2px #ccc}.toolbar-color-grid:hover:nth-child(51){box-shadow:0 0 0 2px #262626}.toolbar-color-grid:hover:nth-child(52){box-shadow:0 0 0 2px #cf1322}.toolbar-color-grid:hover:nth-child(53){box-shadow:0 0 0 2px #d4380d}.toolbar-color-grid:hover:nth-child(54){box-shadow:0 0 0 2px #d48806}.toolbar-color-grid:hover:nth-child(55){box-shadow:0 0 0 2px #d4b106}.toolbar-color-grid:hover:nth-child(56){box-shadow:0 0 0 2px #389e0d}.toolbar-color-grid:hover:nth-child(57){box-shadow:0 0 0 2px #08979c}.toolbar-color-grid:hover:nth-child(58){box-shadow:0 0 0 2px #096dd9}.toolbar-color-grid:hover:nth-child(59){box-shadow:0 0 0 2px #1d39c4}.toolbar-color-grid:hover:nth-child(60){box-shadow:0 0 0 2px #531dab}.toolbar-color-grid:hover:nth-child(61){box-shadow:0 0 0 2px #c41d7f}.toolbar-color-grid:hover:nth-child(62){box-shadow:0 0 0 2px #aaa}.toolbar-color-grid:hover:nth-child(63){box-shadow:0 0 0 2px #000}.toolbar-color-grid:hover:nth-child(64){box-shadow:0 0 0 2px #820014}.toolbar-color-grid:hover:nth-child(65){box-shadow:0 0 0 2px #871400}.toolbar-color-grid:hover:nth-child(66){box-shadow:0 0 0 2px #874d00}.toolbar-color-grid:hover:nth-child(67){box-shadow:0 0 0 2px #876800}.toolbar-color-grid:hover:nth-child(68){box-shadow:0 0 0 2px #135200}.toolbar-color-grid:hover:nth-child(69){box-shadow:0 0 0 2px #00474f}.toolbar-color-grid:hover:nth-child(70){box-shadow:0 0 0 2px #003a8c}.toolbar-color-grid:hover:nth-child(71){box-shadow:0 0 0 2px #061178}.toolbar-color-grid:hover:nth-child(72){box-shadow:0 0 0 2px #22075e}.toolbar-color-grid:hover:nth-child(73){box-shadow:0 0 0 2px #780650}.toolbar-color-grid:hover:nth-child(2),.toolbar-color-grid:hover:nth-child(14){box-shadow:0 0 0 2px #aaa}";
styleInject(css);

/** @jsx h */
const colors = ["#fff", "#333", "#f5222d", "#fa541c", "#faad14", "#fadb14", "#52c41a", "#13c2c2", "#1890ff", "#2f54eb", "#722ed1", "#eb2f96", "#f6f6f6", "#989898", "#ffe8e7", "#ffece0", "#fff7cb", "#fcfcca", "#e5f7d3", "#cffff7", "#d4eefc", "#dfe8fc", "#efe1fa", "#fbe1eb", "#e9e9e9", "#666", "#ffa39e", "#ffbb96", "#ffe58f", "#fffb8f", "#b7eb8f", "#87e8de", "#91d5ff", "#adc6ff", "#d3adf7", "#ffadd2", "#ddd", "#4b4b4b", "#ff4d4f", "#ff7a45", "#ffc53d", "#ffec3d", "#73d13d", "#36cfc9", "#40a8ff", "#597ef7", "#9254de", "#f759ab", "#ccc", "#262626", "#cf1322", "#d4380d", "#d48806", "#d4b106", "#389e0d", "#08979c", "#096dd9", "#1d39c4", "#531dab", "#c41d7f", "#aaa", "#000", "#820014", "#871400", "#874d00", "#876800", "#135200", "#00474f", "#003a8c", "#061178", "#22075e", "#780650"];
const colorTypes = [{
  defaultBg: "#333",
  defaultBorder: "#333",
  tip: "文字颜色",
  type: "font"
}, {
  defaultBg: "#fff",
  defaultBorder: "#eee",
  tip: "表格底色",
  type: "bg"
}, {
  defaultBg: "#ccc",
  defaultBorder: "#ccc",
  tip: "边框颜色",
  type: "border"
}];

class Popover extends preact.Component {
  render() {
    const {
      typeInfo,
      select,
      selected,
      displayPos
    } = this.props;
    const colorGrids = colors.map(color => preact.h("div", {
      key: color,
      style: {
        background: color
      },
      onClick: () => select(color),
      className: classNames("toolbar-color-grid", {
        selected: selected === color
      })
    }));
    return preact.h("div", {
      "data-action": `${typeInfo.type}Color`,
      className: "toolbar-color-popover",
      style: displayPos
    }, preact.h("div", {
      onClick: () => select(null),
      className: "default"
    }, preact.h("div", {
      style: {
        background: typeInfo.defaultBg,
        borderColor: typeInfo.defaultBorder
      },
      className: "color-grid"
    }), preact.h("div", {
      className: "text"
    }, "\u6062\u590D\u9ED8\u8BA4")), colorGrids);
  }

}

class ColorPopover extends preact.Component {
  constructor(props) {
    super(props);

    this.onSelect = color => {
      const {
        type,
        setSelected,
        setColor,
        editorCore
      } = this.props;
      const {
        view,
        basicCommands
      } = editorCore;

      if (type === "font") {
        if (color === null) {
          basicCommands.setTextDefaultColor();
        } else {
          basicCommands.setTextColor(color);
        }
      }

      if (setSelected) {
        setSelected(color);
      }

      if (setColor) {
        setColor(color);
      }

      view.focus(); // HACK 异步 setState 以确保 tooltip 关闭

      window.requestAnimationFrame(() => {
        this.setState({
          hasTooltip: false,
          isOpen: false,
          selected: color
        });
      });
    };

    this.hidePopover = e => {
      if (!e || e && e.target && !this.container.contains(e.target)) {
        this.setState({
          hasTooltip: false,
          isOpen: false
        });
        window.removeEventListener("click", this.hidePopover);
      }
    };

    this.setColor = () => {
      const {
        type,
        editorCore,
        setColor
      } = this.props;
      const {
        view,
        basicCommands
      } = editorCore;

      if (type === "font") {
        basicCommands.setTextColor(this.state.selected);
      }

      if (setColor) {
        setColor(this.state.selected);
      }

      view.focus();
    };

    this.handleClick = e => {
      const {
        editorCore,
        disabledHandler
      } = this.props;
      const {
        view
      } = editorCore;
      const disabled = disabledHandler();

      if (view) {
        view.focus();
      }

      if (disabled) {
        return;
      }

      const {
        isOpen
      } = this.state;

      if (!isOpen) {
        this.setState({
          hasTooltip: false,
          isOpen: true
        });
        window.addEventListener("click", this.hidePopover);
      } else {
        this.hidePopover();
      }
    };

    this.handleMouseEnter = () => {
      if (this.state.isOpen) {
        return;
      }

      this.setState({
        hasTooltip: true
      });
    };

    this.state = {
      hasTooltip: false,
      isOpen: false,
      popoverPos: {},
      selected: props.selected || null
    };
  }

  componentDidMount() {
    const popoverPos = {
      left: 0,
      top: `${this.container.offsetHeight}px`
    };
    this.setState({
      popoverPos
    });
  } // 接收来自 Popover 的选中事件后，调用父级 transform 方法


  componentWillUnmount() {
    window.removeEventListener("click", this.hidePopover);
  }

  render() {
    const {
      type,
      disabledHandler,
      children
    } = this.props;
    const disabled = disabledHandler();
    const {
      hasTooltip,
      isOpen,
      selected,
      popoverPos
    } = this.state;
    const typeInfo = colorTypes.find(_ => _.type === type); // 设置表格边框颜色

    if (children && children.length) {
      return preact.h("div", {
        ref: container => this.container = container,
        onMouseEnter: () => {
          if (disabled) {
            return;
          }

          this.handleMouseEnter();
        },
        onMouseLeave: () => this.setState({
          hasTooltip: false
        }),
        onClick: this.handleClick,
        className: `toolbar-color-popover-wrapper ${type}-color${disabled ? " disabled" : ""}`
      }, children, isOpen && preact.h(Popover, {
        typeInfo: typeInfo,
        selected: selected,
        select: this.onSelect,
        displayPos: popoverPos
      }), hasTooltip && preact.h("div", {
        className: "ct-toolbar-tooltip"
      }, typeInfo.tip));
    }

    return preact.h("div", {
      ref: container => this.container = container,
      onMouseEnter: () => {
        if (disabled) {
          return;
        }

        this.handleMouseEnter();
      },
      onMouseLeave: () => this.setState({
        hasTooltip: false
      }),
      className: `toolbar-color-popover-wrapper ${type}-color${disabled ? " disabled" : ""}`
    }, type === "bg" && preact.h("div", {
      "data-action": "bgColor",
      className: "left",
      onClick: this.setColor
    }, preact.h("div", {
      className: "color",
      style: {
        background: selected || "#989898"
      }
    })), type === "font" && preact.h("div", {
      "data-action": "fontColor",
      className: "left",
      onClick: this.setColor
    }, preact.h("div", {
      className: "color",
      style: {
        background: selected || "#333",
        borderColor: selected ? selected === "#FFFFFF" ? "#eee" : selected : "#333"
      }
    })), type !== "border" && preact.h("div", {
      className: "right",
      onClick: this.handleClick
    }), isOpen && preact.h(Popover, {
      typeInfo: typeInfo,
      selected: selected,
      select: this.onSelect
    }), hasTooltip && preact.h("div", {
      className: "ct-toolbar-tooltip"
    }, typeInfo.tip));
  }

}

var css$1 = ".table-modal{text-align:left!important}.table-modal .table-modal-wrapper{width:630px}.table-modal .ct-modal-title{font-weight:500}.table-modal .ant-modal-footer{padding:0 24px 24px;border:none}.table-modal .ant-modal-footer .ant-btn{width:60px;height:32px;padding:0;margin-left:16px;border-radius:2px}.table-modal-content{display:flex;justify-content:flex-start;align-items:baseline;padding:24px}.table-modal-content .left{display:flex;flex-direction:column;justify-content:space-between;width:246px;height:176px;margin-right:30px}.table-modal-content .right{width:300px}.table-modal-content .title{margin-bottom:8px;font-size:14px;color:#333;line-height:22px}.table-modal-content .style-wrapper{display:flex;justify-content:flex-start;align-items:baseline}.table-modal-content .style-item{width:76px;height:70px;text-align:center}.table-modal-content .style-item svg{display:block;margin-top:14px;margin-left:14px}.table-modal-content .solid{margin-left:18px}.table-modal-content .selected{background-color:rgba(0,167,205,.1)}.table-modal-content .color-block{display:flex;justify-content:flex-start;align-items:baseline;width:246px;height:24px;padding:6px 8px;border:1px solid #ddd;border-radius:2px}.table-modal-content .color-block .inner{width:212px;height:10px}.table-modal-content .color-block svg{display:block;margin-left:8px}.table-modal-content .color-block svg path{fill:#b0b0b0}.table-modal-content .width-wrapper{display:flex;justify-content:space-around;align-items:center;flex-wrap:wrap;height:146px;border:1px solid #ddd;border-radius:2px;font-size:12px}.table-modal-content .width-wrapper .width-item{cursor:pointer;width:126px;height:19px;line-height:19px;border-radius:2px;text-align:center;display:flex;align-items:center;justify-content:center}.table-modal-content .width-wrapper .width-item .inner{display:inline-block;vertical-align:middle;width:110px;background:#1c6cdc}.table-modal-content .width-wrapper .width-item:nth-child(2) .inner{height:4px}.table-modal-content .width-wrapper .width-item:nth-child(3) .inner{height:1px}.table-modal-content .width-wrapper .width-item:nth-child(4) .inner{height:5px}.table-modal-content .width-wrapper .width-item:nth-child(5) .inner{height:2px}.table-modal-content .width-wrapper .width-item:nth-child(6) .inner{height:6px}.table-modal-content .width-wrapper .width-item:nth-child(7) .inner{height:3px}.table-modal-content .width-wrapper .width-item:nth-child(8) .inner{height:7px}.border-color .ct-color-pop-wrapper{display:block;width:auto;height:auto;border:none;background:none}";
styleInject(css$1);

class TableModal extends preact.Component {
  constructor(props) {
    super(props);

    this.handleOk = () => {
      const {
        setTableAttrs,
        hideModal
      } = this.props;
      setTableAttrs(objectSpread({}, this.state));
      hideModal();
    };

    this.handleCancel = () => {
      const {
        hideModal
      } = this.props;
      hideModal();
    };

    const {
      borderStyle,
      borderColor,
      borderWidth,
      store
    } = this.props;
    this.state = {
      borderStyle: borderStyle || 'solid',
      borderColor: borderColor || '#cccccc',
      borderWidth: borderWidth === null ? 1 : borderWidth
    };
    this.store = store;
  }

  render() {
    const {
      borderStyle,
      borderColor,
      borderWidth
    } = this.state;
    return preact.h(index_js$1.Modal, {
      wrapClassName: "ct-modal table-modal",
      contentClassName: "table-modal-wrapper",
      width: "620px",
      title: preact.h("div", {
        className: "ct-modal-title"
      }, "\u8868\u683C\u5C5E\u6027"),
      visible: true,
      okText: "\u786E\u5B9A",
      onOk: this.handleOk,
      onCancel: () => {
        this.handleCancel();
      }
    }, preact.h("div", {
      className: "table-modal-content"
    }, preact.h("div", {
      className: "left"
    }, preact.h("div", {
      className: "border-style"
    }, preact.h("div", {
      className: "title"
    }, "\u8FB9\u6846\u6837\u5F0F\uFF1A"), preact.h("div", {
      className: "style-wrapper"
    }, preact.h("div", {
      className: classNames('style-item dashed', {
        selected: borderStyle === 'dashed'
      }),
      onClick: () => this.setState({
        borderStyle: 'dashed'
      })
    }, preact.h(DashedIcon, null)), preact.h("div", {
      className: classNames('style-item solid', {
        selected: borderStyle === 'solid'
      }),
      onClick: () => this.setState({
        borderStyle: 'solid'
      })
    }, preact.h(SolidIcon, null)))), preact.h("div", {
      className: "border-color"
    }, preact.h("div", {
      className: "title"
    }, "\u8FB9\u6846\u989C\u8272\uFF1A"), preact.h(ColorPopover, {
      type: "border",
      store: this.store,
      setColor: color => {
        this.setState({
          borderColor: color
        });
      },
      setDefaultColor: () => {
        this.setState({
          borderColor: '#cccccc'
        });
      },
      disabledHandler: () => false,
      editorCore: this.store,
      setSelected: borderColor => this.setState({
        borderColor
      })
    }, preact.h("div", {
      className: "color-block"
    }, preact.h("div", {
      className: "inner",
      style: {
        background: borderColor
      }
    }), preact.h(TriangleIcon, null))))), preact.h("div", {
      className: "right"
    }, preact.h("div", {
      className: "border-width"
    }, preact.h("div", {
      className: "title"
    }, "\u8FB9\u6846\u5BBD\u5EA6\uFF1A"), preact.h("div", {
      className: "width-wrapper"
    }, preact.h("div", {
      className: classNames('width-item', {
        selected: borderWidth === 0
      }),
      onClick: () => this.setState({
        borderWidth: 0
      })
    }, "\u65E0"), [4, 1, 5, 2, 6, 3, 7].map(_ => preact.h("div", {
      key: _,
      className: classNames('width-item', {
        selected: borderWidth === _
      }),
      onClick: () => this.setState({
        borderWidth: _
      })
    }, preact.h("div", {
      className: "inner",
      style: {
        backgroundColor: borderColor
      }
    }))))))));
  }

}

var css$2 = ".table-headerbar .ct-table-wrapper{margin:0!important;overflow:hidden}.table-headerbar table{margin-top:0!important;overflow:hidden}.table-headerbar table .selectedCell:after{display:none}";
styleInject(css$2);

/** @jsx h */

class HeaderBar extends preact.Component {
  constructor(...args) {
    super(...args);

    this.init = () => {
      const {
        headerTableDOM,
        tableHeader,
        headerParentNode,
        headerPaddingLeft
      } = this.props;
      const headerBarTableDOM = headerTableDOM.cloneNode();
      headerBarTableDOM.className = '';
      headerBarTableDOM.style.width = `${headerTableDOM.clientWidth}px`;
      const headerColgroupDOM = headerTableDOM.firstElementChild.cloneNode(true);
      const headerTbodyDOM = document.createElement('tbody');
      const wrapperDOM = document.createElement('div');
      const colDOMs = [];
      const rowDOM = headerTableDOM.lastElementChild.children[0];

      for (let i = 0; i < rowDOM.childElementCount; i++) {
        const cellDOM = rowDOM.children[i];
        const colspan = parseInt(cellDOM.getAttribute('colspan'), 10) || 1;
        const cellWidth = cellDOM.getBoundingClientRect().width / colspan;

        for (let j = 0; j < colspan; j++) {
          colDOMs.push({
            cellWidth
          });
        }
      }

      if (headerColgroupDOM.children.length === 0) {
        colDOMs.forEach(col => {
          const cellWidth = col.cellWidth || parseInt(col.style && col.style.width, 10);
          headerColgroupDOM.appendChild(document.createElement('col')).style.width = `${cellWidth}px`;
        });
      } // 修正第一个单元格宽度


      const firstCellNode = tableHeader.firstElementChild;
      const colspan = firstCellNode.getAttribute('colspan');

      if (colspan) {
        let width = 0;
        Array.from(headerColgroupDOM.children).some((col, i) => {
          if (i === colspan) return true;
          width += parseInt(col.style.width, 10);
          return false;
        });
        firstCellNode.style.width = `${width}px`;
      }

      wrapperDOM.className = 'ct-table-wrapper';
      headerTbodyDOM.appendChild(tableHeader);
      headerBarTableDOM.appendChild(headerColgroupDOM);
      headerBarTableDOM.appendChild(headerTbodyDOM);
      headerBarTableDOM.style.marginLeft = `${headerPaddingLeft}px`;
      wrapperDOM.appendChild(headerBarTableDOM);
      this.headerBar.innerHTML = '';
      this.headerBar.appendChild(wrapperDOM);
      wrapperDOM.scrollLeft = headerParentNode.scrollLeft;
    };

    this.handleDoubleClick = e => {
      const headerDOM = e.target.closest('th');

      if (headerDOM) {
        const {
          headerTableDOM,
          view,
          $scroll
        } = this.props;
        const {
          state,
          dispatch
        } = view;
        const index = Array.from(headerDOM.parentElement.children).indexOf(headerDOM);
        const trueDOM = headerTableDOM.lastElementChild.firstElementChild.cells[index];
        const pos = view.docView.posFromDOM(trueDOM);
        $scroll.scrollTop -= 90 - trueDOM.getBoundingClientRect().top;
        dispatch(state.tr.setSelection(prosemirrorState.TextSelection.create(state.tr.doc, pos - 1)));
        view.focus();
      }
    };

    this.handleMouseWheel = e => {
      const isInCloneHeader = e.target.closest('.table-headerbar');
      if (!isInCloneHeader) return;
      let direct = 0;

      if (e.wheelDelta) {
        direct = e.wheelDelta > 0 ? 1 : -1;
      } else if (e.detail) {
        direct = e.detail > 0 ? 1 : -1;
      }

      if (direct !== 0) {
        const {
          $scroll
        } = this.props;

        if (direct === 1) {
          $scroll.scrollTop -= 7;
        } else {
          $scroll.scrollTop += 7;
        }
      }
    };
  }

  componentDidMount() {
    const {
      $scroll
    } = this.props;
    $scroll.addEventListener('mousewheel', this.handleMouseWheel);
    this.headerBar.addEventListener('dblclick', this.handleDoubleClick);
    this.init();
  }

  componentDidUpdate() {
    this.init();
  }

  componentWillUnmount() {
    const {
      $scroll
    } = this.props;
    $scroll.removeEventListener('mousewheel', this.handleMouseWheel);
    this.headerBar.removeEventListener('dblclick', this.handleDoubleClick);
  }

  render() {
    const {
      headerParentNode
    } = this.props;
    return preact.h("div", {
      className: "table-headerbar",
      style: {
        width: `${headerParentNode.clientWidth}px`
      },
      ref: refs => {
        this.headerBar = refs;
      }
    });
  }

}

var css$3 = ".ct-table-scrollbar{height:15px;overflow-x:auto;overflow-y:hidden}.ct-table-scrollbar .inner{border:1px solid transparent}";
styleInject(css$3);

/** @jsx h */

class ScrollBar extends preact.Component {
  constructor(...args) {
    super(...args);

    this.handleScroll = () => {
      const {
        scrollParentNode
      } = this.props;
      const scrollLeft = this.scrollBar.scrollLeft;

      if (scrollParentNode.scrollLeft !== scrollLeft) {
        scrollParentNode.scrollLeft = scrollLeft;
      }
    };
  }

  componentDidMount() {
    const {
      scrollParentNode
    } = this.props;
    this.scrollBar.scrollLeft = scrollParentNode.scrollLeft;
    this.scrollBar.onscroll = this.handleScroll;
  }

  componentWillUnmount() {
    this.scrollBar.onscroll = null;
  }

  componentDidUpdate() {
    const {
      scrollParentNode
    } = this.props;
    const scrollLeft = scrollParentNode.scrollLeft;

    if (this.scrollBar.scrollLeft !== scrollLeft) {
      this.scrollBar.scrollLeft = scrollLeft;
    }
  }

  render() {
    const {
      scrollContainerWidth,
      scrollTableWidth
    } = this.props;
    return preact.h("div", {
      className: "ct-table-scrollbar",
      style: {
        width: `${scrollContainerWidth}px`
      },
      ref: refs => {
        this.scrollBar = refs;
      }
    }, preact.h("div", {
      className: "inner",
      style: {
        width: `${scrollTableWidth + 2}px`
      }
    }));
  }

}

var css$4 = ".ct-table-all-selectbar,.ct-table-row-selectbar{height:100%;width:100%}.ct-table-col-selectbar-wrapper{overflow-x:hidden}.ct-table-col-selectbar{height:26px}.visible-wrapper{width:100%;height:100%}.ct-table-col-selectbar{margin-top:20px;pointer-events:all}.ct-table-col-selectbar .ct-table-selectbar-item{float:left;height:100%}.ct-table-col-selectbar .ct-table-selectbar-item:first-child .visible-wrapper.left .visible{border-left:1px solid transparent;border-top-left-radius:2px;border-bottom-left-radius:2px}.ct-table-col-selectbar .ct-table-selectbar-item:last-child .visible-wrapper.right .visible{border-top-right-radius:2px;border-bottom-right-radius:2px}.ct-table-col-selectbar .visible-wrapper{padding-top:8px}.ct-table-col-selectbar .visible{height:10px}.ct-table-col-selectbar .visible-wrapper.left .visible{border-left:1px solid #ddd}.ct-table-row-selectbar .ct-table-selectbar-item:first-child .visible-wrapper.top .visible{border-top-left-radius:2px;border-top-right-radius:2px}.ct-table-row-selectbar .ct-table-selectbar-item:last-child .visible-wrapper.bottom .visible{border-bottom-left-radius:2px;border-bottom-right-radius:2px;border:none}.ct-table-row-selectbar .visible-wrapper{padding-left:8px}.ct-table-row-selectbar .visible{height:100%;width:10px}.ct-table-row-selectbar .visible-wrapper.bottom .visible{border-bottom:1px solid #ddd}.ct-table-all-selectbar .visible{width:10px;height:10px;border-radius:10px;background:#eee;cursor:-webkit-grab}.ct-table-all-selectbar .visible:hover{background:#ccc}.ct-table-all-selectbar .visible.selected{background:rgba(0,167,205,.2)}.ct-table-selectbar-item{cursor:pointer}.ct-table-selectbar-item .visible{background:#eee}.ct-table-selectbar-item:hover .visible{background:#ccc}.ct-table-selectbar-item.selected .visible{background:rgba(0,167,205,.2)}";
styleInject(css$4);

/** @jsx h */
const {
  os
} = index_js.getSystemInfo();
const dragCopyModifier = /MAC/.test(os.toUpperCase()) ? "altKey" : "ctrlKey";
class ColSelectBar extends preact.Component {
  constructor(...args) {
    super(...args);

    this.handleClick = () => {
      const {
        view,
        tablePos,
        reShowPopover
      } = this.props;
      const {
        dispatch,
        state
      } = view;
      const {
        tr,
        doc
      } = state;
      const newSelection = prosemirrorState.NodeSelection.create(doc, tablePos);
      dispatch(tr.setSelection(newSelection));
      view.focus();
      reShowPopover();
    };

    this.handleDragStart = e => {
      const {
        view,
        tablePos,
        tableDOM
      } = this.props;
      const {
        state
      } = view;
      tableDOM.style = 'opacity: 0.9;';
      e.dataTransfer.setDragImage(tableDOM, 0, 0);
      const mouseDown = view.mouseDown;
      if (mouseDown) mouseDown.done();
      const node = state.doc.nodeAt(tablePos);
      const newSelection = prosemirrorState.TextSelection.create(state.doc, tablePos, tablePos + node.nodeSize);
      let slice = newSelection.content();

      if (slice && slice.content && slice.content.content) {
        const {
          type: {
            name
          } = {}
        } = slice.content.content[0];

        if (name === 'blockquote') {
          const nodeSelection = prosemirrorState.NodeSelection.create(state.doc, tablePos, tablePos + node.nodeSize);
          slice = nodeSelection.content();
        }
      }

      view.dragging = {
        slice,
        move: !event[dragCopyModifier]
      };
      view.dispatch(state.tr.setSelection(newSelection));
    };

    this.isSelectedAll = () => {
      const {
        tableDOM,
        colDOMs,
        selectedRowArr,
        selectedColArr
      } = this.props;
      if (!tableDOM) return false;
      const tableRowDOMs = tableDOM.lastElementChild.children;
      return selectedColArr.length === colDOMs.length && selectedRowArr.length === tableRowDOMs.length;
    };
  }

  render() {
    const selected = this.isSelectedAll();
    return preact.h("div", {
      draggable: true,
      className: "ct-table-all-selectbar",
      onClick: this.handleClick,
      onDragStart: this.handleDragStart
    }, preact.h("div", {
      className: `visible${selected ? ' selected' : ''}`
    }));
  }

}

// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let readFromCache, addToCache; // Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.

if (typeof WeakMap !== 'undefined') {
  const cache = new WeakMap();

  readFromCache = key => cache.get(key);

  addToCache = (key, value) => {
    cache.set(key, value);
    return value;
  };
} else {
  let cache = [],
      cacheSize = 10,
      cachePos = 0;

  readFromCache = key => {
    for (let i = 0; i < cache.length; i += 2) {
      if (cache[i] == key) return cache[i + 1];
    }
  };

  addToCache = (key, value) => {
    if (cachePos == cacheSize) cachePos = 0;
    cache[cachePos++] = key;
    return cache[cachePos++] = value;
  };
}

class Rect {
  constructor(left, top, right, bottom) {
    this.left = left;
    this.top = top;
    this.right = right;
    this.bottom = bottom;
  }

} // ::- A table map describes the structore of a given table. To avoid
// recomputing them all the time, they are cached per table node. To
// be able to do that, positions saved in the map are relative to the
// start of the table, rather than the start of the document.

class TableMap {
  constructor(width, height, map, problems) {
    // :: number The width of the table
    this.width = width; // :: number The table's height

    this.height = height; // :: [number] A width * height array with the start position of
    // the cell covering that part of the table in each slot

    this.map = map; // An optional array of problems (cell overlap or non-rectangular
    // shape) for the table, used by the table normalizer.

    this.problems = problems;
  } // :: (number) → Rect
  // Find the dimensions of the cell at the given position.


  findCell(pos) {
    for (let i = 0; i < this.map.length; i++) {
      const curPos = this.map[i];
      if (curPos != pos) continue;
      let left = i % this.width,
          top = i / this.width | 0;
      let right = left + 1,
          bottom = top + 1;

      for (let j = 1; right < this.width && this.map[i + j] == curPos; j++) right++;

      for (let j = 1; bottom < this.height && this.map[i + this.width * j] == curPos; j++) bottom++;

      return new Rect(left, top, right, bottom);
    }

    throw new RangeError(`No cell with offset ${pos} found`);
  } // :: (number) → number
  // Find the left side of the cell at the given position.


  colCount(pos) {
    for (let i = 0; i < this.map.length; i++) {
      if (this.map[i] == pos) return i % this.width;
    }

    throw new RangeError(`No cell with offset ${pos} found`);
  } // :: (number, string, number) → ?number
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.


  nextCell(pos, axis, dir) {
    const {
      left,
      right,
      top,
      bottom
    } = this.findCell(pos);

    if (axis == 'horiz') {
      if (dir < 0 ? left == 0 : right == this.width) return null;
      return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
    }

    if (dir < 0 ? top == 0 : bottom == this.height) return null;
    return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
  } // :: (number, number) → Rect
  // Get the rectangle spanning the two given cells.


  rectBetween(a, b) {
    const {
      left: leftA,
      right: rightA,
      top: topA,
      bottom: bottomA
    } = this.findCell(a);
    const {
      left: leftB,
      right: rightB,
      top: topB,
      bottom: bottomB
    } = this.findCell(b);
    return new Rect(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
  } // :: (Rect) → [number]
  // Return the position of all cells that have the top left corner in
  // the given rectangle.


  cellsInRect(rect) {
    let result = [],
        seen = [];

    for (let row = rect.top; row < rect.bottom; row++) {
      for (let col = rect.left; col < rect.right; col++) {
        let index = row * this.width + col,
            pos = this.map[index];
        if (seen.indexOf(pos) > -1) continue;
        seen.push(pos);

        if ((col != rect.left || !col || this.map[index - 1] != pos) && (row != rect.top || !row || this.map[index - this.width] != pos)) {
          result.push(pos);
        }
      }
    }

    return result;
  } // :: (number, number, Node) → number
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.


  positionAt(row, col, table) {
    for (let i = 0, rowStart = 0;; i++) {
      const rowEnd = rowStart + table.child(i).nodeSize;

      if (i == row) {
        let index = col + row * this.width,
            rowEndIndex = (row + 1) * this.width; // Skip past cells from previous rows (via rowspan)

        while (index < rowEndIndex && this.map[index] < rowStart) index++;

        return index == rowEndIndex ? rowEnd - 1 : this.map[index];
      }

      rowStart = rowEnd;
    }
  } // :: (Node) → TableMap
  // Find the table map for the given table node.


  static get(table) {
    return readFromCache(table) || addToCache(table, computeMap(table));
  }

} // Compute a table map.

function computeMap(table) {
  if (table.type.spec.tableRole != 'table') throw new RangeError(`Not a table node: ${table.type.name}`);
  let width = findWidth(table),
      height = table.childCount;
  let map = [],
      mapPos = 0,
      problems = null,
      colWidths = [];

  for (let i = 0, e = width * height; i < e; i++) map[i] = 0;

  for (let row = 0, pos = 0; row < height; row++) {
    const rowNode = table.child(row);
    pos++;

    for (let i = 0;; i++) {
      while (mapPos < map.length && map[mapPos] != 0) mapPos++;

      if (i == rowNode.childCount) break;
      let cellNode = rowNode.child(i),
          {
        colspan,
        rowspan,
        colwidth
      } = cellNode.attrs;

      for (let h = 0; h < rowspan; h++) {
        if (h + row >= height) {
          (problems || (problems = [])).push({
            type: 'overlong_rowspan',
            pos,
            n: rowspan - h
          });
          break;
        }

        const start = mapPos + h * width;

        for (let w = 0; w < colspan; w++) {
          if (map[start + w] == 0) {
            map[start + w] = pos;
          } else {
            (problems || (problems = [])).push({
              type: 'collision',
              row,
              pos,
              n: colspan - w
            });
          }

          const colW = colwidth && colwidth[w];

          if (colW) {
            let widthIndex = (start + w) % width * 2,
                prev = colWidths[widthIndex];

            if (prev == null || prev != colW && colWidths[widthIndex + 1] == 1) {
              colWidths[widthIndex] = colW;
              colWidths[widthIndex + 1] = 1;
            } else if (prev == colW) {
              colWidths[widthIndex + 1]++;
            }
          }
        }
      }

      mapPos += colspan;
      pos += cellNode.nodeSize;
    }

    let expectedPos = (row + 1) * width,
        missing = 0;

    while (mapPos < expectedPos) if (map[mapPos++] == 0) missing++;

    if (missing) (problems || (problems = [])).push({
      type: 'missing',
      row,
      n: missing
    });
    pos++;
  }

  let tableMap = new TableMap(width, height, map, problems),
      badWidths = false; // For columns that have defined widths, but whose widths disagree
  // between rows, fix up the cells whose width doesn't match the
  // computed one.

  for (let i = 0; !badWidths && i < colWidths.length; i += 2) {
    if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
  }

  if (badWidths) findBadColWidths(tableMap, colWidths, table);
  return tableMap;
}

function findWidth(table) {
  let width = -1,
      hasRowSpan = false;

  for (let row = 0; row < table.childCount; row++) {
    let rowNode = table.child(row),
        rowWidth = 0;

    if (hasRowSpan) {
      for (let j = 0; j < row; j++) {
        const prevRow = table.child(j);

        for (let i = 0; i < prevRow.childCount; i++) {
          const cell = prevRow.child(i);
          if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
        }
      }
    }

    for (let i = 0; i < rowNode.childCount; i++) {
      const cell = rowNode.child(i);
      rowWidth += cell.attrs.colspan;
      if (cell.attrs.rowspan > 1) hasRowSpan = true;
    }

    if (width == -1) {
      width = rowWidth;
    } else if (width != rowWidth) {
      width = Math.max(width, rowWidth);
    }
  }

  return width;
}

function findBadColWidths(map, colWidths, table) {
  if (!map.problems) map.problems = [];

  for (let i = 0, seen = []; i < map.map.length; i++) {
    const pos = map.map[i];
    if (seen.indexOf(pos) > -1) continue;
    seen.push(pos);
    let node = table.nodeAt(pos),
        updated = null;

    for (let j = 0; j < node.attrs.colspan; j++) {
      let col = (i + j) % map.width,
          colWidth = colWidths[col * 2];

      if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] != colWidth)) {
        (updated || (updated = freshColWidth(node.attrs)))[j] = colWidth;
      }
    }

    if (updated) map.problems.unshift({
      type: 'colwidth mismatch',
      pos,
      colwidth: updated
    });
  }
}

function freshColWidth(attrs) {
  if (attrs.colwidth) return attrs.colwidth.slice();
  const result = [];

  for (let i = 0; i < attrs.colspan; i++) result.push(0);

  return result;
}

let isResizing = false; // 是否正处于改变宽度状态

class TableView {
  constructor(_node, _getPos, store, cellMinWidth) {
    this.fixedErrorColumns = (node, getPos) => {
      if (node.attrs.responsive) return;
      const {
        view
      } = this.store;
      const {
        state,
        dispatch
      } = view;
      const {
        tr,
        schema
      } = state;
      const {
        table_header,
        table_cell
      } = schema.nodes;
      const cellTypes = [table_header, table_cell];
      const docView = view.docView;
      const pos = getPos();
      tr.doc.nodesBetween(pos, pos + node.nodeSize, (node, pos) => {
        if (cellTypes.includes(node.type)) {
          const attrs = node.attrs;
          const colwidth = attrs.colwidth;

          if (colwidth.includes(0) || colwidth.includes(NaN) || colwidth.includes(Infinity)) {
            const dom = docView.domFromPos(pos + 1).node;
            const width = dom.clientWidth + 3;
            const len = colwidth.length;
            const newColwidth = new Array(len);
            const divWidth = ~~(width / len);
            newColwidth.fill(divWidth > 50 ? divWidth : 50);

            try {
              tr.setNodeMarkup(pos, null, objectSpread({}, attrs, {
                colwidth: newColwidth
              }));
            } catch (error) {// console.error(error)
            }
          }
        }
      });
      dispatch(tr.setMeta('addToHistory', false));
    };

    this.handleTableScroll = () => {
      const {
        parentNode,
        reShowPopover,
        handleTableScroll
      } = this.store;
      if (parentNode !== this.dom) reShowPopover();
      handleTableScroll();
    };

    isResizing = false;
    this.store = store;
    this.node = _node;
    this.cellMinWidth = cellMinWidth;
    const {
      attrs: {
        dataDiffId
      }
    } = _node;
    this.dom = document.createElement('div');
    this.dom.className = 'ct-table-wrapper';

    if (dataDiffId) {
      this.dom.setAttribute('data-diff-id', dataDiffId);
    }

    this.table = this.dom.appendChild(document.createElement('table'));
    this.colgroup = this.table.appendChild(document.createElement('colgroup'));
    updateColumns(_node, this.colgroup, this.table, cellMinWidth);
    this.contentDOM = this.table.appendChild(document.createElement('tbody'));
    setTimeout(() => this.fixedErrorColumns(_node, _getPos), 100);
    this.dom.addEventListener('scroll', this.handleTableScroll);
  }

  update(node) {
    if (node.type !== this.node.type) return false;
    this.node = node;
    updateColumns(node, this.colgroup, this.table, this.cellMinWidth);
    return true;
  }

  ignoreMutation(record) {
    return record.type === 'attributes' && (record.target === this.table || this.colgroup.contains(record.target));
  }

  destory() {
    this.dom.removeEventListener('scroll', this.handleTableScroll);
  } // 处理异常宽度表格 固定表格宽度


}
function updateColumns(node, colgroup, table, cellMinWidth, isDragged, overrideCol, overrideValue, store) {
  if (isDragged !== undefined) {
    isResizing = isDragged;
    if (!isDragged) return;
  } else if (isResizing && !overrideCol) return false;

  const {
    indent,
    responsive,
    borderStyle,
    borderWidth,
    borderColor
  } = node.attrs;

  if (!responsive) {
    let totalWidth = 0;
    let fixedWidth = true;
    const colgroupFragment = document.createDocumentFragment();
    const row = node.content.content[0];
    let col = 0;

    for (let i = 0; i < row.childCount; i++) {
      const {
        colspan,
        colwidth
      } = row.child(i).attrs;
      const hasWidth = overrideCol === col ? overrideValue : colwidth && colwidth.map(p => parseInt(p)).reduce((prev, cur) => prev + cur);
      totalWidth += hasWidth || cellMinWidth;

      for (let j = 0; j < colspan; j++) {
        let colWidthValue = overrideCol === col ? overrideValue : colwidth && colwidth[j];
        if (!hasWidth) fixedWidth = false;
        colgroupFragment.appendChild(document.createElement('col')).style.width = colWidthValue ? `${colWidthValue}px` : '';
        col++;
      }
    }

    colgroup.innerHTML = '';
    colgroup.appendChild(colgroupFragment);

    if (fixedWidth) {
      table.style.width = `${totalWidth}px`;
      table.style.minWidth = '';
    } else {
      table.style.width = '';
      table.style.minWidth = `${totalWidth}px`;
    }
  } else {
    colgroup.innerHTML = '';
    table.style.width = '';
    table.style.minWidth = '';
  }

  if (store && table === store.tableDOM) {
    store.handleTableWidthChange();
  }

  if (indent >= 0) table.style.marginLeft = `${indent * 20}px`;
  table.className = responsive ? 'responsive' : '';
  table.setAttribute('data-borderstyle', borderStyle);
  table.setAttribute('data-borderwidth', borderWidth);
  table.setAttribute('data-bordercolor', borderColor);
}

const pluginKey = new prosemirrorState.PluginKey('tableColumnResizing');
let preStartX = null; // 上次拖拽起始点

let columnResizingDOM = null; // 拖拽指示线dom节点

let cellDOM = null; // 拖拽触发的单元格

let tableWrapperDOM = null; // 拖拽触发的表格外层

let handleWidth = 0; // 拖拽指示线宽度

let hadMouseDown = false; // 鼠标是否处于按下状态

function columnResizing({
  cellMinWidth = 25
} = {}, store) {
  const plugin = new prosemirrorState.Plugin({
    key: pluginKey,
    state: {
      init(_, state) {
        this.spec.props.nodeViews.table = (node, view, getPos) => new TableView(node, getPos, store, cellMinWidth);

        return new ResizeState(-1, false);
      },

      apply(tr, prev) {
        return prev.apply(tr);
      }

    },
    props: {
      attributes(state) {
        const pluginState = pluginKey.getState(state);
        return pluginState.activeHandle > -1 ? {
          class: 'resize-cursor'
        } : null;
      },

      handleDOMEvents: {
        mousemove(view, event) {
          handleMouseMove(view, event, cellMinWidth, store);
        },

        // mouseleave (view, event) { handleMouseDown(view, event, cellMinWidth) },
        mousedown(view, event) {
          handleMouseDown(view, event, cellMinWidth);
        }

      },

      decorations(state) {
        const pluginState = pluginKey.getState(state);

        if (pluginState.activeHandle > -1) {
          let res = null;

          try {
            res = handleDecorations(state, pluginState.activeHandle, store.view);
          } catch (error) {
            console.error(error);
          }

          return res;
        }

        columnResizingDOM = null;
        updateColumns(0, 0, 0, 0, false);
      },

      nodeViews: {}
    }
  });
  return plugin;
}

class ResizeState {
  constructor(activeHandle, dragging) {
    this.activeHandle = activeHandle;
    this.dragging = dragging;
    preStartX = dragging ? dragging.startX : null;
  }

  apply(tr) {
    let state = this,
        action = tr.getMeta(pluginKey);

    if (action && action.setHandle) {
      return new ResizeState(action.setHandle, null);
    }

    if (action && action.setDragging) {
      return new ResizeState(state.activeHandle, action.setDragging);
    }

    if (state.activeHandle > -1 && tr.docChanged) {
      let $handle = tr.doc.resolve(tr.mapping.map(state.activeHandle, -1));
      if (!($handle.parent.type.spec.tableRole === 'row' && $handle.nodeAfter)) $handle = null;
      state = new ResizeState($handle && $handle.pos, state.dragging);
    }

    return state;
  }

}

function handleMouseMove(view, event, cellMinWidth, store) {
  const pluginState = pluginKey.getState(view.state);

  if (pluginState.dragging && hadMouseDown) {
    const offset = event.clientX - preStartX;
    preStartX = event.clientX;
    window.requestAnimationFrame(() => {
      if (columnResizingDOM) {
        const styleLeft = parseInt(columnResizingDOM.style.left, 10) + offset;
        columnResizingDOM.style.left = `${styleLeft}px`;
      }
    });
    store.checkGlobalTabel();
    displayColumnWidth(view, pluginState.activeHandle, draggedWidth(pluginState.dragging, event, cellMinWidth), cellMinWidth, store);
  } else if (!window.ctImgResizing) {
    // 全局缩放状态，在@utils/decorators/resizer设置
    const target = domCellAround(event.target);
    let cell = -1;

    if (target) {
      const {
        left,
        right
      } = target.getBoundingClientRect();
      const borderWidth = window.getComputedStyle(target, null)['border-left-width'];
      handleWidth = parseInt(borderWidth || 1, 10) + 3;

      if (Math.abs(event.clientX - left) <= handleWidth) {
        cell = edgeCell(view, event, 'left');
      } else if (Math.abs(right - event.clientX) <= handleWidth) {
        cell = edgeCell(view, event, 'right');
      }
    }

    if (cell !== pluginState.activeHandle) updateHandle(view, cell);
  }
}

function handleMouseDown(view, event, cellMinWidth) {
  hadMouseDown = false; // mac下切换应用后，在新应用移动鼠标会触发mousedown

  if (document.hidden) return false;
  const pluginState = pluginKey.getState(view.state);
  if (pluginState.activeHandle === -1 || pluginState.dragging) return false;
  const cell = view.state.doc.nodeAt(pluginState.activeHandle);
  let width = formatWidth(currentColWidth(view, pluginState.activeHandle, cell.attrs));
  const {
    docView,
    state
  } = view;
  const {
    tr,
    schema,
    doc
  } = state;
  const tableDOM = tableWrapperDOM.firstChild; // 拖拽时将自适应表格转换为固定宽度表格

  if (tableDOM.classList.contains('responsive')) {
    const {
      table_header,
      table_cell
    } = schema.nodes;
    const cellTypes = [table_header, table_cell];
    const tablePos = docView.posFromDOM(tableDOM) - 1;
    const tableNode = doc.nodeAt(tablePos);
    doc.nodesBetween(tablePos, tablePos + tableNode.nodeSize, (node, pos) => {
      if (cellTypes.includes(node.type)) {
        const attrs = node.attrs;
        const cellDom = docView.domFromPos(pos + 1).node;
        const colspan = parseInt(cellDom.getAttribute('colspan'), 10) || 1;
        const cellWidth = cellDom.getBoundingClientRect().width / colspan;
        const newColwidth = [];

        for (let i = 0; i < colspan; i++) newColwidth.push(cellWidth);

        const newAttrs = objectSpread({}, attrs, {
          colwidth: newColwidth
        });

        tr.setNodeMarkup(pos, null, newAttrs);
        if (cell === node) width = formatWidth(currentColWidth(view, pluginState.activeHandle, newAttrs));
      }
    });
    tr.setNodeMarkup(tablePos, null, objectSpread({}, tableNode.attrs, {
      responsive: false
    }));
  }

  view.dispatch(tr.setMeta(pluginKey, {
    setDragging: {
      startX: event.clientX,
      startWidth: width
    }
  }));

  function finish(e) {
    hadMouseDown = false;
    window.removeEventListener('mouseup', finish);
    window.removeEventListener('mousemove', move);
    const pluginState = pluginKey.getState(view.state);

    if (pluginState.dragging) {
      try {
        updateColumnWidth(view, pluginState.activeHandle, draggedWidth(pluginState.dragging, e, cellMinWidth));
        view.dispatch(view.state.tr.setMeta(pluginKey, {
          setDragging: null
        }));
      } catch (error) {
        console.warn(error);
      }
    }
  }

  function move(e) {
    if (!e.which) finish(e);
  }

  window.addEventListener('mouseup', finish);
  window.addEventListener('mousemove', move);
  event.preventDefault();
  hadMouseDown = true;
  return true;
}

function currentColWidth(view, cellPos, {
  colspan,
  colwidth
}) {
  const width = colwidth && colwidth[colwidth.length - 1];
  if (width) return width; // Not fixed, read current width from DOM

  let domWidth = view.domAtPos(cellPos + 1).node.offsetWidth,
      parts = colspan;

  if (colwidth) {
    for (let i = 0; i < colspan; i++) {
      if (colwidth[i]) {
        domWidth -= colwidth[i];
        parts--;
      }
    }
  }

  return domWidth / parts;
}

function domCellAround(target) {
  while (target && target.nodeName !== 'TD' && target.nodeName !== 'TH') {
    target = target.classList.contains('ProseMirror') ? null : target.parentNode;
  }

  return target;
}

function edgeCell(view, event, side) {
  const left = side === 'left' ? event.clientX + 1 : event.clientX;
  const posInfo = view.posAtCoords({
    left,
    top: event.clientY
  });
  if (!posInfo) return -1;
  const {
    pos
  } = posInfo;
  const $cell = cellAround(view.state.doc.resolve(pos));
  if (!$cell) return -1;
  if (side === 'right') return $cell.pos;
  let map = TableMap.get($cell.node(-1)),
      start = $cell.start(-1);
  const index = map.map.indexOf($cell.pos - start);
  return index % map.width === 0 ? -1 : start + map.map[index - 1];
}

function draggedWidth(dragging, event, cellMinWidth) {
  const offset = event.clientX - dragging.startX;
  return Math.max(cellMinWidth, dragging.startWidth + offset);
}

function updateHandle(view, value) {
  view.dispatch(view.state.tr.setMeta(pluginKey, {
    setHandle: value
  }));
}

function updateColumnWidth(view, cellPos, width) {
  const $cell = view.state.doc.resolve(cellPos);
  let table = $cell.node(-1),
      map = TableMap.get(table),
      start = $cell.start(-1);
  const col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  const tr = view.state.tr;

  for (let row = 0; row < map.height; row++) {
    const mapIndex = row * map.width + col; // Rowspanning cell that has already been handled

    if (row && map.map[mapIndex] === map.map[mapIndex - map.width]) continue;
    let pos = map.map[mapIndex],
        {
      attrs
    } = table.nodeAt(pos);
    const index = attrs.colspan === 1 ? 0 : col - map.colCount(pos);
    if (attrs.colwidth && attrs.colwidth[index] === width) continue;
    const colwidth = attrs.colwidth ? attrs.colwidth.slice() : zeroes(attrs.colspan);
    colwidth[index] = width;
    tr.setNodeMarkup(start + pos, null, setAttr(attrs, 'colwidth', colwidth));
  }

  if (tr.docChanged) view.dispatch(tr);
}

function displayColumnWidth(view, cell, width, cellMinWidth, store) {
  const $cell = view.state.doc.resolve(cell);
  let table = $cell.node(-1),
      start = $cell.start(-1);
  if (!table) return;
  const col = TableMap.get(table).colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan - 1;
  let dom = view.domAtPos($cell.start(-1)).node;

  while (dom.nodeName !== 'TABLE') dom = dom.parentNode;

  updateColumns(table, dom.firstChild, dom, cellMinWidth, true, col, width, store);
}

function zeroes(n) {
  const result = [];

  for (let i = 0; i < n; i++) result.push(0);

  return result;
}

function handleDecorations(state, cell, view) {
  const decorations = [];
  const $cell = state.doc.resolve(cell);
  let table = $cell.node(-1),
      map = TableMap.get(table),
      start = $cell.start(-1);
  const col = map.colCount($cell.pos - start) + $cell.nodeAfter.attrs.colspan;

  for (let row = 0; row < map.height; row++) {
    const index = col + row * map.width - 1; // For positions that are have either a different cell or the end
    // of the table to their right, and either the top of the table or
    // a different cell above them, add a decoration

    if ((col === map.width || map.map[index] !== map.map[index + 1]) && (row === 0 || map.map[index - 1] !== map.map[index - 1 - map.width])) {
      const cellPos = map.map[index];
      const pos = start + cellPos + table.nodeAt(cellPos).nodeSize - 1;
      const dom = document.createElement('div');
      cellDOM = view.domAtPos(pos).node;
      const tableDOM = cellDOM.parentNode.parentNode.parentNode;
      tableWrapperDOM = tableDOM.parentNode;
      const tableParentOffsetLeft = index_js.getTargetLeft(tableWrapperDOM.parentNode) + parseInt(window.getComputedStyle(tableWrapperDOM.parentNode, null).paddingLeft, 10) + parseInt(window.getComputedStyle(tableDOM, null).marginLeft, 10);
      dom.className = 'column-resize-handler';
      const borderWidth = window.getComputedStyle(cellDOM, null)['border-left-width'];
      handleWidth = parseInt(borderWidth || 1, 10) + 1;
      let styleLeft = index_js.getTargetLeft(cellDOM) + cellDOM.offsetWidth + tableWrapperDOM.scrollLeft - tableParentOffsetLeft - Math.floor(handleWidth / 2) + 1;

      if (!columnResizingDOM && window.navigator.platform === 'Win32') {
        styleLeft -= 1;
      }

      dom.style.left = `${styleLeft - 2}px`;
      dom.style.bottom = `-${Math.floor(handleWidth / 2)}px`;
      columnResizingDOM = dom;
      decorations.push(prosemirrorView.Decoration.widget(view.docView.posFromDOM(cellDOM.parentNode), dom));
      break;
    }
  }

  return prosemirrorView.DecorationSet.create(state.doc, decorations);
}

function insertTable(store) {
  return function (rowCount, colCount, headerData) {
    return function (state, dispatch, view, trigger) {
      const {
        schema
      } = state;
      const {
        table,
        table_row,
        table_cell,
        table_header
      } = schema.nodes;
      const headers = [];

      for (let i = 0; i < colCount; i++) {
        const headerNode = headerData ? table_header.create({
          colwidth: [68]
        }, headerData[i]) : table_header.createAndFill({
          colwidth: [68]
        });
        headers.push(headerNode);
      }

      const rowHeader = table_row.create(null, prosemirrorModel.Fragment.from(headers));
      const rows = [rowHeader];

      for (let i = 0; i < rowCount - 1; i++) {
        const cells = [];

        for (let j = 0; j < colCount; j++) {
          const cellNode = table_cell.createAndFill({
            colwidth: [68]
          });
          cells.push(cellNode);
        }

        const rowNode = table_row.create(null, prosemirrorModel.Fragment.from(cells));
        rows.push(rowNode);
      }

      const tableNode = table.create(null, prosemirrorModel.Fragment.from(rows));
      const {
        transaction,
        newPos
      } = index_js.insertBlock(state, tableNode);
      if (!transaction) return false;
      dispatch(transaction.scrollIntoView());
      let tableDOM = view.docView.domFromPos(newPos).node.parentNode.parentNode.parentNode;
      if (tableDOM.tagName.toUpperCase() === 'TBODY') tableDOM = tableDOM.parentNode;
      store.showPopover(tableDOM);
      trigger && trigger('afterInsert', {
        draggable: true
      });
      view.focus();
      return true;
    };
  };
} // 是否为表头列

function columnIsHeader(map, table, col) {
  const headerCell = table.type.schema.nodes.table_header;

  for (let row = 0; row < map.height; row++) {
    if (table.nodeAt(map.map[col + row * map.width]).type !== headerCell) {
      return false;
    }
  }

  return true;
} // 插入列


function addColumn(tr, {
  map,
  tableStart,
  table,
  tableCell
}, col, numCell, hasRowHeader, defaultColWidth, dir) {
  const {
    table_cell,
    table_header,
    paragraph
  } = table.type.schema.nodes;
  if (hasRowHeader === undefined) hasRowHeader = getHasRowHeader(table.content.content, table_header);
  let refColumn = col > 0 ? -1 : 0;

  if (columnIsHeader(map, table, col + refColumn)) {
    refColumn = col === 0 || col === map.width ? null : 0;
  }

  for (let row = 0; row < map.height; row++) {
    const index = row * map.width + col; // 中间插入跨列处理

    if (col > 0 && col < map.width && map.map[index - 1] === map.map[index]) {
      const pos = map.map[index];
      const cell = table.nodeAt(pos);
      tr.setNodeMarkup(tr.mapping.map(tableStart + pos), null, addColspan(cell.attrs, col - map.colCount(pos))); // 跨行跳过

      row += cell.attrs.rowspan - 1;
    } else {
      const cellIndex = refColumn !== null ? map.map[index + refColumn + dir] : map.map[map.width - 1];
      const cell = table.nodeAt(cellIndex || map.map[map.width - 1]);
      const type = row === 0 && hasRowHeader ? table_header : table_cell;
      const pos = map.positionAt(row, col, table); // 原单元格列宽

      const colwidth = defaultColWidth || cell.attrs.colwidth; // 原单元格底色
      // 取消与第一列颜色相同的背景色 bugfix
      // const bgColor = cell.attrs.bgColor
      // 原单元格首行对齐方式

      const firstChildAlign = cell.firstChild.attrs.align;
      const defaultType = paragraph;
      const attrs = !numCell || hasRowHeader && row === 0 ? {
        colwidth: [...colwidth]
      } : {
        numCell,
        colwidth: [...colwidth] // 插入行号列特殊处理

      };

      if (numCell) {
        row += cell.attrs.rowspan - 1;
        tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill(objectSpread({}, attrs, {
          rowspan: cell.attrs.rowspan
        }), defaultType.create({
          align: firstChildAlign
        })));
      } else {
        tr.insert(tr.mapping.map(tableStart + pos), type.createAndFill(attrs, defaultType.create({
          align: firstChildAlign
        })));
      }
    }
  }

  return tr;
} // 左侧插入列


function addColumnBefore(store) {
  return function (state, dispatch, view) {
    const {
      schema
    } = state;
    const {
      table_header,
      table_cell
    } = schema.nodes;
    const cellTypes = [table_header, table_cell];
    const rect = selectedRect(state);
    if (!rect) return false;
    const tableContent = rect.table.content.content; // 是否在行号列或表头列左侧

    if (rect.left === 0 || rect.left === 1) {
      const {
        hasColHeader,
        headerCol
      } = getHasColHeader(tableContent, table_header);
      if (hasColHeader && rect.left === headerCol) return false;
      const hasNumCol = getHasNumCol(tableContent, table_header);
      if (hasNumCol && rect.left === 0) return false;
    }

    if (dispatch) {
      const hasRowHeader = getHasRowHeader(tableContent, table_header); // 确保插入后光标定位到对应位置

      const originNode = index_js.findParentNode(state.tr.selection.$from.path, node => cellTypes.includes(node.type));
      const {
        node: {
          attrs
        }
      } = originNode;
      const combinedColWidth = [attrs.colwidth.reduce((prev, cur) => prev + cur)];
      const tr = addColumn(state.tr, rect, rect.left, false, hasRowHeader, combinedColWidth, rect.left === 0 ? 0 : 1);
      const foundCellNode = index_js.findParentNode(tr.selection.$from.path, node => cellTypes.includes(node.type));
      const newPos = foundCellNode.pos - 2;
      if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
      dispatch(tr);
      store.handleTableWidthChange();
      view.focus();
    }

    return true;
  };
} // 右侧插入列

function addColumnAfter(store) {
  return function (state, dispatch, view) {
    const {
      schema
    } = state;
    const {
      table_header,
      table_cell
    } = schema.nodes;
    const cellTypes = [table_header, table_cell];
    const rect = selectedRect(state);
    if (!rect) return false;
    const tableContent = rect.table.content.content; // 是否在表头列左侧

    if (rect.left === 0 || rect.left === 1) {
      const {
        hasColHeader,
        headerCol
      } = getHasColHeader(tableContent, table_header);
      if (hasColHeader && rect.left + 1 === headerCol) return false;
    }

    if (dispatch) {
      // originNode是为了让新生成的列宽度与当前光标位置的宽度一致，同时避免展示和浏览宽度的不一致，同addColumnBefore
      const originNode = index_js.findParentNode(state.tr.selection.$from.path, node => cellTypes.includes(node.type));
      const {
        node: {
          attrs
        }
      } = originNode;
      const hasRowHeader = getHasRowHeader(tableContent, table_header);
      const combinedColWidth = [attrs.colwidth.reduce((prev, cur) => prev + cur)];
      const tr = addColumn(state.tr, rect, rect.right, false, hasRowHeader, combinedColWidth, 0); // tr来确保插入后光标定位到对应位置

      const foundCellNode = index_js.findParentNode(tr.selection.$from.path, node => cellTypes.includes(node.type));
      const newPos = foundCellNode.pos + foundCellNode.node.nodeSize + 2;
      if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
      dispatch(tr);
      store.handleTableWidthChange('right');
      view.focus();
    }

    return true;
  };
} // 是否为表头行

function rowIsHeader(map, table, row) {
  const headerCell = table.type.schema.nodes.table_header;

  for (let col = 0; col < map.width; col++) {
    if (table.nodeAt(map.map[col + row * map.width]).type !== headerCell) {
      return false;
    }
  }

  return true;
} // 插入行


function addRow(tr, {
  map,
  tableStart,
  table
}, row) {
  const nodes = table.type.schema.nodes;
  const {
    table_cell,
    table_header,
    paragraph
  } = nodes;
  const tableContent = table.content.content;
  const hasNumCol = getHasNumCol(tableContent, table_header);
  const {
    headerCol
  } = getHasColHeader(tableContent, table_header);
  let rowPos = tableStart;

  for (let i = 0; i < row; i++) rowPos += table.child(i).nodeSize;

  const cells = [];
  const rowspanPos = new Set();
  let refRow = row > 0 ? -1 : 0;

  if (rowIsHeader(map, table, row + refRow)) {
    refRow = row === 0 || row === map.height ? null : 0;
  }

  for (let col = 0, index = map.width * row; col < map.width; col++, index++) {
    // 扩展跨行单元格
    if (row > 0 && row < map.height && map.map[index] === map.map[index - map.width]) {
      const pos = map.map[index];
      if (rowspanPos.has(pos)) continue;
      rowspanPos.add(pos);
      const cellNode = table.nodeAt(pos, index);
      const attrs = cellNode.attrs;
      tr.setNodeMarkup(tableStart + pos, null, setAttr(attrs, 'rowspan', attrs.rowspan + 1));
      col += attrs.colspan - 1;
    } else {
      const type = col === headerCol ? table_header : table_cell;
      let tableCell;
      let colwidth = null;

      if (refRow) {
        tableCell = table.nodeAt(map.map[index + refRow * map.width]);
        colwidth = tableCell.attrs.colwidth;
      } // 添加时带上行号列


      const attrs = hasNumCol && col === 0 ? {
        colwidth,
        numCell: true
      } : {
        colwidth // 原单元格对齐方式

      };

      if (tableCell) {
        const firstChildAlign = tableCell.firstChild.attrs.align;
        const defaultType = paragraph;
        cells.push(type.createAndFill(attrs, defaultType.create({
          align: firstChildAlign
        })));
      } else {
        cells.push(type.createAndFill(attrs));
      }
    }
  }

  tr.insert(rowPos, nodes.table_row.create(null, cells));
  return tr;
} // 上方插入行

function addRowBefore(store) {
  return function (state, dispatch, view) {
    const {
      selection,
      schema
    } = state;
    const {
      $from
    } = selection;
    const {
      table_row,
      table_header
    } = schema.nodes;
    const rect = selectedRect(state);
    if (!rect) return false;
    const tableContent = rect.table.content.content;
    const hasRowHeader = getHasRowHeader(tableContent, table_header);
    if (hasRowHeader && rect.top === 0) return false;

    if (dispatch) {
      const tr = addRow(state.tr, rect, rect.top); // 确保插入后光标定位到对应位置

      const foundRowNode = index_js.findParentNode($from.path, node => node.type === table_row);
      const hasNumCol = getHasNumCol(tableContent, table_header); // eslint-disable-next-line

      const newPos = getAddRowBeforePos(rect, foundRowNode, hasNumCol);
      if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
      dispatch(tr);
      store.handleTableHeightChange();
      view.focus();
    }

    return true;
  };
} // 计算插入后位置

function getAddRowBeforePos(rect, foundRowNode) {
  const leftStart = rect.top * rect.map.width;
  const leftEnd = leftStart + rect.left;
  const leftPosArr = rect.map.map.slice(leftStart, leftEnd);
  let leftDis = 0;
  let lastMaxPos = rect.map.map[leftStart - 1];
  leftPosArr.forEach(pos => {
    if (pos >= lastMaxPos) {
      leftDis++;
      lastMaxPos = pos;
    }
  });
  return foundRowNode.pos + 2 + leftDis * 4;
} // 下方插入行


function addRowAfter(store) {
  return function (state, dispatch, view) {
    if (dispatch) {
      const {
        selection,
        schema
      } = state;
      const {
        $from
      } = selection;
      const {
        table_row,
        table_header
      } = schema.nodes;
      const rect = selectedRect(state);
      if (!rect) return false;
      const tableContent = rect.table.content.content;
      const tr = addRow(state.tr, rect, rect.bottom);

      if (rect.tableCell.attrs.rowspan === 1) {
        const foundRowNode = index_js.findParentNode($from.path, node => node.type === table_row);
        const hasNumCol = getHasNumCol(tableContent, table_header); // eslint-disable-next-line

        const newPos = getAddRowAfterPos(rect, foundRowNode, hasNumCol);
        if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
      }

      dispatch(tr.scrollIntoView());
      store.$scroll.scrollTop += 30;
      store.handleTableHeightChange();
      view.focus();
    }

    return true;
  };
} // 计算插入后位置

function getAddRowAfterPos(rect, foundRowNode, hasNumCol) {
  const nextRowPos = foundRowNode.pos + foundRowNode.node.nodeSize + 2;
  const leftStart = (rect.top + 1) * rect.map.width;
  const leftEnd = leftStart + rect.left;
  const leftPosArr = rect.map.map.slice(leftStart, leftEnd);

  if (leftPosArr.length === 0) {
    return nextRowPos + 1 + rect.left * 4;
  }

  let leftDis = 0;
  let lastMaxPos = rect.map.map[leftStart - 1];
  leftPosArr.forEach(pos => {
    if (pos >= lastMaxPos) {
      leftDis++;
      lastMaxPos = pos;
    }
  });
  return nextRowPos + 1 + leftDis * 4;
} // 合并单元格


function mergeCells(state, dispatch) {
  const {
    selection,
    schema
  } = state;
  const {
    table_cell,
    table_header
  } = schema.nodes;
  const cellTypes = [table_cell, table_header];

  if (selection instanceof CellSelection) {
    let hasNumCell = false;
    let allNumCell = true;
    selection.ranges.forEach(range => {
      const foundCellNode = index_js.findParentNode(range.$from.path, node => node && cellTypes.includes(node.type));

      if (foundCellNode && foundCellNode.node.attrs.numCell) {
        hasNumCell = true;
      } else {
        allNumCell = false;
      }
    });
    if (hasNumCell && !allNumCell) return false;
  }

  const sel = state.selection;
  if (!(sel instanceof CellSelection) || sel.$anchorCell.pos === sel.$headCell.pos) return false;
  const rect = selectedRect(state);
  const map = rect.map;

  if (cellsOverlapRectangle(map, rect)) {
    return false;
  }

  if (dispatch) {
    const tr = state.tr;
    let colwidth = [];
    let content = prosemirrorModel.Fragment.empty;
    let mergedPos;
    let mergedCell;
    const seen = [];

    for (let row = rect.top; row < rect.bottom; row++) {
      const posArr = [];

      for (let col = rect.left; col < rect.right; col++) {
        const cellPos = map.map[row * map.width + col]; // 解决连续合并已经合并过的单元格造成的累加问题

        if (posArr.includes(cellPos)) continue;
        posArr.push(cellPos);
        const cell = rect.table.nodeAt(cellPos);

        if (row === rect.top) {
          colwidth = colwidth.concat(cell.attrs.colwidth);
        }

        if (seen.indexOf(cellPos) > -1) continue;
        seen.push(cellPos);

        if (mergedPos == null) {
          mergedPos = cellPos;
          mergedCell = cell;
        } else {
          if (!isEmptyCell(cell)) {
            content = content.append(cell.content);
          }

          const mapped = tr.mapping.map(cellPos + rect.tableStart);
          tr.delete(mapped, mapped + cell.nodeSize);
        }
      }
    }

    const newAttrs = objectSpread({}, mergedCell.attrs, {
      colspan: rect.right - rect.left,
      rowspan: rect.bottom - rect.top,
      colwidth
    });

    tr.setNodeMarkup(mergedPos + rect.tableStart, null, newAttrs);

    if (content.size) {
      const end = mergedPos + 1 + mergedCell.content.size;
      const start = isEmptyCell(mergedCell) ? mergedPos + 1 : end;
      tr.replaceWith(start + rect.tableStart, end + rect.tableStart, content);
    }

    tr.setSelection(new CellSelection(tr.doc.resolve(mergedPos + rect.tableStart)));
    dispatch(tr);
  }

  return true;
} // 拆分单元格

function splitCell(state, dispatch) {
  const {
    schema,
    tr
  } = state;
  const {
    table_cell,
    table_header
  } = schema.nodes;
  let selection = state.selection; // 非选中状态

  if (!(selection instanceof CellSelection)) {
    const rowType = schema.nodes.table_row;
    let pos; // 鼠标所在位置cell

    const fromPath = [...selection.$from.path].reverse();

    for (let i = 0; i < fromPath.length; i++) {
      const node = fromPath[i];

      if (node.type === rowType) {
        pos = fromPath[i - 2];
        break;
      }
    }

    if (!pos) return false;
    selection = new CellSelection(tr.doc.resolve(pos));
    tr.setSelection(selection);
  }

  if (selection.$anchorCell.pos !== selection.$headCell.pos) return false;
  const cellNode = selection.$anchorCell.nodeAfter;
  if (cellNode.attrs.colspan === 1 && cellNode.attrs.rowspan === 1) return false;

  if (dispatch) {
    let baseAttrs = cellNode.attrs;
    const attrs = [];
    const colwidth = baseAttrs.colwidth;
    if (baseAttrs.rowspan > 1) baseAttrs = setAttr(baseAttrs, 'rowspan', 1);
    if (baseAttrs.colspan > 1) baseAttrs = setAttr(baseAttrs, 'colspan', 1);
    const rect = selectedRect(state);
    if (!rect) return false;
    const tableContent = rect.table.content.content;
    const hasRowHeader = getHasRowHeader(tableContent, table_header);
    const {
      hasColHeader,
      headerCol
    } = getHasColHeader(tableContent, table_header, hasRowHeader); // eslint-disable-next-line

    const tr = state.tr;

    for (let i = 0; i < rect.right - rect.left; i++) {
      attrs.push(colwidth ? setAttr(baseAttrs, 'colwidth', colwidth && colwidth[i] ? [colwidth[i]] : null) : baseAttrs);
    }

    let lastCell;

    for (let row = 0; row < rect.bottom; row++) {
      if (row >= rect.top) {
        let pos = rect.map.positionAt(row, rect.left, rect.table);
        if (row === rect.top) pos += cellNode.nodeSize;

        for (let col = rect.left, i = 0; col < rect.right; col++, i++) {
          // eslint-disable-next-line
          if (col === rect.left && row === rect.top) continue;
          let cellType = table_cell; // 为表头列或表头行

          if (row === 0 && hasRowHeader || col === headerCol && hasColHeader) {
            cellType = table_header;
          }

          tr.insert(lastCell = tr.mapping.map(pos + rect.tableStart, 1), cellType.createAndFill(attrs[i]));
        }
      }
    }

    tr.setNodeMarkup(selection.$anchorCell.pos, null, attrs[0]);
    tr.setSelection(new CellSelection(tr.doc.resolve(selection.$anchorCell.pos), lastCell && tr.doc.resolve(lastCell)));
    dispatch(tr);
  }

  return true;
} // :: (EditorState, ?(tr: Transaction)) → bool
// Deletes the table around the selection, if any.

function deleteTableLib(state, dispatch) {
  const $pos = state.selection.$anchor;

  for (let d = $pos.depth; d > 0; d--) {
    const node = $pos.node(d);

    if (node.type.spec.tableRole === 'table') {
      if (dispatch) dispatch(state.tr.delete($pos.before(d), $pos.after(d)).scrollIntoView());
      return true;
    }
  }

  return false;
} // 删除表格


function deleteTable(store) {
  return function (state, dispatch, view, trigger) {
    if (deleteTableLib(state, dispatch)) {
      store.hidePopover();
      trigger && trigger('afterDelete', {
        draggable: true
      });
      view.focus();
      return true;
    }

    return false;
  };
} // :: (EditorState, dispatch: ?(tr: Transaction)) → bool
// Command function that removes the selected columns from a table.

function deleteColumnLib(state, dispatch) {
  if (dispatch) {
    const rect = selectedRect(state);
    const tr = state.tr;
    if (rect.left === 0 && rect.right == rect.map.width) return false;

    for (let i = rect.right - 1;; i--) {
      removeColumn(tr, rect, i);
      if (i == rect.left) break;
      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      rect.map = TableMap.get(rect.table);
    }

    dispatch(tr);
  }

  return true;
} // 删除当前列


function deleteColumn(store) {
  return function (state, dispatch, view) {
    let transaction = state.tr;
    const rect = selectedRect(state);
    if (!rect) return false;

    const fakeDispatch = tr => {
      transaction = tr;
    };

    if (deleteColumnLib(state, fakeDispatch)) {
      const {
        selection,
        schema
      } = state;
      const {
        table_row
      } = schema.nodes;
      const path = selection.$from.path;
      const foundRowNode = index_js.findParentNode(path, node => node.type === table_row);
      const tableCellNode = rect.tableCell; // 最后一列

      if (foundRowNode.node.lastChild === tableCellNode) {
        // eslint-disable-next-line
        transaction = transaction.setSelection(prosemirrorState.TextSelection.create(transaction.doc, transaction.selection.from - 6));
      }

      dispatch(transaction);
      view.focus();
      store.handleTableWidthChange();
      return true;
    }

    return deleteTable(store)(state, dispatch, view);
  };
}

function removeRow(tr, ref, row) {
  const map = ref.map;
  const table = ref.table;
  const tableStart = ref.tableStart;
  let rowPos = 0;

  for (let i = 0; i < row; i++) {
    rowPos += table.child(i).nodeSize;
  }

  const nextRow = rowPos + table.child(row).nodeSize;
  const mapFrom = tr.mapping.maps.length;
  tr.delete(rowPos + tableStart, nextRow + tableStart);
  let lastPos = null;

  for (let col = 0, index = row * map.width; col < map.width; col++, index++) {
    const pos = map.map[index];

    if (pos !== lastPos) {
      if (row > 0 && pos === map.map[index - map.width]) {
        // If this cell starts in the row above, simply reduce its rowspan
        const attrs = table.nodeAt(pos).attrs; // eslint-disable-next-line

        tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + tableStart), null, setAttr(attrs, 'rowspan', attrs.rowspan - 1));
        col += attrs.colspan - 1;
      } else if (row < map.width && pos === map.map[index + map.width]) {
        // Else, if it continues in the row below, it has to be moved down
        const cell = table.nodeAt(pos);
        const copy = cell.type.create(setAttr(cell.attrs, 'rowspan', cell.attrs.rowspan - 1), cell.content);
        const newPos = map.positionAt(row + 1, col, table);
        tr.insert(tr.mapping.slice(mapFrom).map(tableStart + newPos), copy);
        col += cell.attrs.colspan - 1;
      }
    }

    lastPos = pos;
  }
} // 删除行


function deleteRow(store) {
  return function (state, dispatch, view) {
    const {
      tr,
      selection,
      schema
    } = state;
    const {
      table_row
    } = schema.nodes;
    const rect = selectedRect(state);

    if (!rect || rect.top === 0 && rect.bottom === rect.map.height) {
      return deleteTable(store)(state, dispatch, view);
    }

    for (let i = rect.bottom - 1;; i--) {
      removeRow(tr, rect, i);

      if (i === rect.top) {
        break;
      }

      rect.table = rect.tableStart ? tr.doc.nodeAt(rect.tableStart - 1) : tr.doc;
      rect.map = TableMap.get(rect.table);
    } // eslint-disable-next-line


    const newPos = getDeleteRowPos(rect, tr, selection, table_row);
    if (newPos >= 0) tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
    dispatch(tr);
    view.focus();
    store.handleTableHeightChange();
    return true;
  };
}

function getDeleteRowPos(rect, tr, selection, table_row) {
  // debugger
  let path = selection.$from.path; // 多个选中

  if (selection instanceof CellSelection) {
    let minFromPos = selection.from;
    selection.ranges.forEach(sel => {
      if (sel.$from.pos < minFromPos) {
        path = sel.$from.path;
        minFromPos = sel.from;
      }
    });
    const foundRowNode = index_js.findParentNode(path, node => node.type === table_row);
    return foundRowNode.pos - 3;
  }

  const tableNode = rect.table;
  const foundRowNode = index_js.findParentNode(path, node => node.type === table_row);
  const currentRowNode = foundRowNode.node;
  const nowPos = tr.selection.from;
  const tableNodeContent = tableNode.content.content;
  const numCellPlus = rect.tableCell.attrs.numCell ? 4 : 0; // 寻找最后一个非空表格行

  let height = rect.map.height - 1;
  let lastNotEmptyRowNode = tableNodeContent[height];

  while (lastNotEmptyRowNode.nodeSize === 2 && tableNode[--height]) {
    lastNotEmptyRowNode = tableNode[--height];
  }

  const isLastRow = currentRowNode === lastNotEmptyRowNode || currentRowNode.nodeSize === lastNotEmptyRowNode.nodeSize && currentRowNode.textContent === lastNotEmptyRowNode.textContent; // 最后一行删除，光标跳到上一行

  if (isLastRow && tableNodeContent.length !== 1) {
    const leftPlus = rect.map.map[rect.map.width * (rect.top - 1) + rect.left] || 0;
    return rect.tableStart + leftPlus + 1 + numCellPlus;
  }

  const leftStart = (rect.top + 1) * rect.map.width;
  const leftEnd = leftStart + rect.left;
  const leftPosArr = rect.map.map.slice(leftStart, leftEnd);
  let leftDis = 0;
  let lastMaxPos = rect.map.map[leftStart - 1];
  leftPosArr.forEach(pos => {
    if (pos >= lastMaxPos) {
      leftDis++;
      lastMaxPos = pos;
    }
  });
  if (!tableNodeContent[rect.top + 1]) return nowPos + numCellPlus;
  const tableRowNodeContent = tableNodeContent[rect.top + 1].content.content;
  let plus = 0;

  for (let i = 0; i < leftDis; i++) {
    plus += tableRowNodeContent[i] ? tableRowNodeContent[i].nodeSize : 0;
  }

  return nowPos + plus + numCellPlus;
} // 设置 / 取消表头行


function toggleRowHeader(store) {
  return function (hasRowHeader, headerCol, hasNumCol, tableNode, startPos) {
    return function (state, dispatch, view) {
      if (dispatch) {
        const {
          tr,
          schema
        } = state;
        const cellType = schema.nodes.table_cell;
        const headerType = schema.nodes.table_header;
        let transaction; // 取消表头行

        if (hasRowHeader) {
          tr.doc.nodesBetween(startPos, tableNode.nodeSize + startPos, (node, pos, parent) => {
            if (node.type === headerType && parent === tableNode.firstChild) {
              let newAttrs = node.attrs;

              if (node === parent.firstChild) {
                if (hasNumCol) newAttrs = objectSpread({}, newAttrs, {
                  numCell: true
                });
                transaction = headerCol === 0 ? tr.setNodeMarkup(pos, null, newAttrs) : tr.setNodeMarkup(pos, cellType, newAttrs);
              } else {
                const index = parent.content.content.indexOf(node);

                if (headerCol !== index) {
                  transaction = tr.setNodeMarkup(pos, cellType, newAttrs);
                }
              }
            }
          }); // 设置表头行
        } else {
          tr.doc.nodesBetween(startPos, tableNode.nodeSize + startPos, (node, pos, parent) => {
            if (parent === tableNode.firstChild) {
              const attrs = node.attrs;
              transaction = hasNumCol ? tr.setNodeMarkup(pos, headerType, objectSpread({}, attrs, {
                numCell: false
              })) : tr.setNodeMarkup(pos, headerType, attrs);
            }
          });
        }

        if (transaction) dispatch(transaction);
      }

      view.focus();
      let tableDOM = view.docView.domFromPos(startPos + 1).node;
      if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
      store.showPopover(tableDOM);
      return true;
    };
  };
} // 设置 / 取消表头列

function toggleColHeader(hasColHeader, hasRowHeader, hasNumCol, tableNode, startPos) {
  return function (state, dispatch, view) {
    if (dispatch) {
      const {
        tr,
        schema
      } = state;
      const cellType = schema.nodes.table_cell;
      const headerType = schema.nodes.table_header;
      const tableContent = tableNode.content.content;
      let transaction; // 取消表头列

      if (hasColHeader) {
        tr.doc.nodesBetween(startPos, tableNode.nodeSize + startPos, (node, pos, parent) => {
          if (node.type === headerType && tableContent.includes(parent) && !(hasRowHeader && parent === tableNode.firstChild)) {
            transaction = tr.setNodeMarkup(pos, cellType, node.attrs);
          }
        }); // 设置表头列
      } else {
        let rowspan = 0;
        tr.doc.nodesBetween(startPos, tableNode.nodeSize + startPos, (node, pos, parent) => {
          if (node === parent.firstChild && tableContent.includes(parent)) {
            if (!rowspan) {
              if (node.attrs.rowspan > 1) rowspan = node.attrs.rowspan - 1;
              if (node.type === cellType) transaction = tr.setNodeMarkup(pos, headerType, node.attrs);
            } else {
              rowspan--;
            }
          }
        });
      }

      if (transaction) dispatch(transaction);
    }

    view.focus();
    return true;
  };
}

function removeColumn(tr, {
  map,
  table,
  tableStart
}, col) {
  const mapStart = tr.mapping.maps.length;

  for (let row = 0; row < map.height;) {
    const index = row * map.width + col;
    const pos = map.map[index];
    const cell = table.nodeAt(pos); // If this is part of a col-spanning cell

    if (col > 0 && map.map[index - 1] === pos || col < map.width - 1 && map.map[index + 1] === pos) {
      tr.setNodeMarkup(tr.mapping.slice(mapStart).map(tableStart + pos), null, rmColSpan(cell.attrs, col - map.colCount(pos)));
    } else {
      const start = tr.mapping.slice(mapStart).map(tableStart + pos);
      tr.delete(start, start + cell.nodeSize);
    }

    row += cell.attrs.rowspan;
  }
} // 设置 / 取消行号列


function toggleNumCol(store) {
  return function (hasNumCol, hasRowHeader) {
    return function (state, dispatch, view) {
      if (dispatch) {
        const {
          tr
        } = state;
        const rect = selectedRect(state);
        if (!rect) return false;
        let transaction = tr;

        if (hasNumCol) {
          // 取消行号列
          removeColumn(transaction, rect, 0);
        } else {
          // 设置行号列
          transaction = addColumn(transaction, rect, 0, true, hasRowHeader, [50], 0);
        }

        dispatch(transaction);
      }

      store.handleTableWidthChange();
      view.focus();
      return true;
    };
  };
} // 设置表格底色

function setBgColor(color) {
  return function (state, dispatch, view) {
    const {
      selection,
      tr,
      schema
    } = state;
    let transaction = tr; // 多个选中

    if (selection instanceof CellSelection) {
      const ranges = selection.ranges;
      ranges.forEach(sel => {
        const $from = sel.$from; // eslint-disable-next-line

        transaction = transaction.setNodeMarkup($from.pos - 1, $from.parent.type, objectSpread({}, $from.parent.attrs, {
          bgColor: color
        }));
      });
    } else {
      const cellType = schema.nodes.table_cell;
      const headerType = schema.nodes.table_header;
      const foundNode = index_js.findParentNode(selection.$from.path, node => [cellType, headerType].includes(node.type)); // eslint-disable-next-line

      transaction = transaction.setNodeMarkup(foundNode.pos, foundNode.node.type, objectSpread({}, foundNode.node.attrs, {
        bgColor: color
      }));
    }

    dispatch(transaction);
    return true;
  };
} // 设置表格为响应式

function setResponsive(store) {
  return function (state, dispatch, view) {
    const {
      selection,
      tr,
      schema
    } = state;
    const tableType = schema.nodes.table;
    const foundNode = index_js.findParentNode(selection.$from.path, node => node.type === tableType);
    if (!foundNode) return true;

    if (!foundNode.node.attrs.responsive) {
      if (dispatch) {
        tr.setNodeMarkup(foundNode.pos, null, objectSpread({}, foundNode.node.attrs, {
          responsive: true
        }));
        dispatch(tr);
        view.focus();
        let tableDOM = view.docView.domFromPos(foundNode.pos + 1).node;
        if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
        store.showPopover(tableDOM); // store.toggleHeaderBar(false)
      }

      return true;
    }

    return false;
  };
} // 固定表格宽度

function setFixed(state, dispatch, view) {
  const {
    selection,
    tr,
    schema,
    doc
  } = state;
  const tableType = schema.nodes.table;
  const foundNode = index_js.findParentNode(selection.$from.path, node => node.type === tableType);

  if (foundNode && foundNode.node.attrs.responsive) {
    if (dispatch) {
      const {
        docView
      } = view;
      const {
        table_header,
        table_cell
      } = schema.nodes;
      const cellTypes = [table_header, table_cell];
      const tablePos = foundNode.pos;
      const tableNode = foundNode.node;
      doc.nodesBetween(tablePos, tablePos + tableNode.nodeSize, (node, pos) => {
        if (cellTypes.includes(node.type)) {
          const attrs = node.attrs;
          const cellDom = docView.domFromPos(pos + 1).node;
          const colspan = parseInt(cellDom.getAttribute('colspan'), 10) || 1;
          const cellWidth = cellDom.getBoundingClientRect().width / colspan;
          const newColwidth = [];

          for (let i = 0; i < colspan; i++) newColwidth.push(cellWidth);

          const newAttrs = objectSpread({}, attrs, {
            colwidth: newColwidth
          });

          tr.setNodeMarkup(pos, null, newAttrs);
        }
      });
      tr.setNodeMarkup(tablePos, null, objectSpread({}, tableNode.attrs, {
        responsive: false
      }));
      dispatch(tr);
      view.focus();
    }

    return true;
  }

  return false;
} // 全选表格时缩进表格 update: 全选时表格不可缩进, 仅列表可缩进

function setIndent(attrsGetter, type) {
  return function (state, dispatch, view) {
    const {
      selection,
      tr
    } = state;
    const {
      $anchorCell,
      $headCell,
      $from,
      dom
    } = selection;
    const disableIndent = selection instanceof index_js$2.GapCursor && dom && dom.tagName.toUpperCase() === 'TABLE' || isAllCellSelection(selection);
    if (disableIndent) return false; // if (selection instanceof GapCursor && dom && dom.tagName.toUpperCase() === 'TABLE') {
    //   return false //console.log('setIndent table')
    // const { nodeAfter, nodeBefore } = $from
    // if (!nodeAfter) { return false }
    // let pos = $from.pos
    // let tableNode = nodeAfter
    // if (nodeAfter.type.name !== 'table') {
    //   tableNode = nodeBefore
    //   pos -= tableNode.nodeSize
    // }
    // const newAttrs = attrsGetter(tableNode.attrs)
    // if (tableNode.attrs.indent <= 0 && type === 'less') return false
    // tr.setNodeMarkup(pos, null, newAttrs)
    // if (dispatch) {
    //   dispatch(tr)
    //   view.focus()
    // }
    // return true
  }; // if (isAllCellSelection(selection)) {
  //   return false
  //   const $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell
  //   const pos = $firstCell.pos
  //   const tableNode = findParentNode($from.path, item => item.type && item.type.name === 'table').node
  //   const newAttrs = attrsGetter(tableNode.attrs)
  //   if (tableNode.attrs.indent <= 0 && type === 'less') return false
  //   tr.setNodeMarkup(pos, null, newAttrs)
  //   if (dispatch) {
  //     dispatch(tr)
  //     view.focus()
  //   }
  //   return true
  // }
  // }
} // () -> Command

function increaseIndent() {
  return setIndent(attrs => objectSpread({}, attrs, {
    indent: attrs.indent + 1
  }), 'more');
} // () -> Command

function reduceIndent() {
  return setIndent(attrs => objectSpread({}, attrs, {
    indent: attrs.indent - 1
  }), 'less');
} // 调整表格中的位置

function setPosition(position) {
  const verticalAlign = ['top', 'middle', 'bottom'];
  const textAlign = ['left', 'center', 'right'];
  let style = {};

  if (~verticalAlign.indexOf(position)) {
    style = {
      verticalAlign: position
    };
  }

  if (~textAlign.indexOf(position)) {
    style = {
      textAlign: position
    };
  } // top middle bottom left center right


  return function (state, dispatch, view) {
    const {
      selection,
      tr,
      schema
    } = state;
    let transaction = tr; // 多个选中

    if (selection instanceof CellSelection) {
      const ranges = selection.ranges;
      ranges.forEach(sel => {
        const $from = sel.$from; // eslint-disable-next-line

        transaction = transaction.setNodeMarkup($from.pos - 1, $from.parent.type, objectSpread({}, $from.parent.attrs, style));
      });
    } else {
      const cellType = schema.nodes.table_cell;
      const headerType = schema.nodes.table_header;
      const foundNode = index_js.findParentNode(selection.$from.path, node => [cellType, headerType].includes(node.type)); // eslint-disable-next-line

      transaction = transaction.setNodeMarkup(foundNode.pos, foundNode.node.type, objectSpread({}, foundNode.node.attrs, style));
    }

    dispatch(transaction);
    return true;
  };
} // 编辑表格边框样式

function setTableAttrsCommand(attrs) {
  return function (state, dispatch, view) {
    const {
      selection,
      tr,
      schema
    } = state;
    const tableType = schema.nodes.table;
    const foundNode = index_js.findParentNode(selection.$from.path, node => node.type === tableType);
    if (!foundNode) return true;

    if (attrs) {
      tr.setNodeMarkup(foundNode.pos, null, objectSpread({}, foundNode.node.attrs, attrs));
      dispatch(tr);
      return true;
    }

    return false;
  };
}

const key = new prosemirrorState.PluginKey('selectingCells'); // Helper to get the selected rectangle in a table, if any. Adds table
// map, table node, and table start offset to the object for convenience.

function selectedRect(state, curSelection) {
  const cellType = state.schema.nodes.table_cell;
  const headerType = state.schema.nodes.table_header;
  const sel = curSelection || state.selection;
  const $pos = selectionCell(state, sel);
  if (!$pos) return false;
  const table = $pos.node(-1);
  const tableStart = $pos.start(-1);
  const map = TableMap.get(table);
  const foundNode = index_js.findParentNode(sel.$from.path, node => [cellType, headerType].includes(node.type));
  let tableCell;

  if (foundNode) {
    tableCell = foundNode.node;
  } else {
    return false;
  }

  let rect;

  if (sel instanceof CellSelection) {
    rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
  } else {
    rect = map.findCell($pos.pos - tableStart);
  }

  rect.tableStart = tableStart;
  rect.map = map;
  rect.table = table;
  rect.tableCell = tableCell;
  return rect;
}
function isInTable(state) {
  const $head = state.selection.$head;

  for (let d = $head.depth; d > 0; d--) {
    if ($head.node(d).type.spec.tableRole === 'row') return true;
  }

  return false;
}
function cellAround($pos) {
  for (let d = $pos.depth - 1; d > 0; d--) {
    if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
  }

  return null;
}

function cellNear($pos) {
  for (let after = $pos.nodeAfter, pos = $pos.pos; after; after = after.firstChild, pos++) {
    const role = after.type.spec.tableRole;
    if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
  }

  for (let before = $pos.nodeBefore, pos = $pos.pos; before; before = before.lastChild, pos--) {
    const role = before.type.spec.tableRole;
    if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
  }
}

function setAttr(attrs, name, value) {
  const result = {}; // eslint-disable-next-line

  for (let prop in attrs) result[prop] = attrs[prop];

  result[name] = value;
  return result;
}
function selectionCell(state, curSelection) {
  const sel = curSelection || state.selection;

  if (sel.$anchorCell) {
    return sel.$anchorCell.pos > sel.$headCell.pos ? sel.$anchorCell : sel.$headCell;
  }

  return sel.$anchorCell || cellAround(sel.$head) || cellNear(sel.$head);
}
function rmColspan(attrs, pos, n = 1) {
  const result = setAttr(attrs, 'colspan', attrs.colspan - n);

  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    result.colwidth.splice(pos, n);
    if (!result.colwidth.some(w => w > 0)) result.colwidth = null;
  }

  return result;
}
function addColspan(attrs, pos, n = 1) {
  const result = setAttr(attrs, 'colspan', attrs.colspan + n);

  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();

    for (let i = 0; i < n; i++) result.colwidth.splice(pos, 0, 0);
  }

  return result;
} // 是否表头行

function getHasRowHeader(tableContent, headerType) {
  let hasRowHeader = false;
  tableContent.forEach(tableRow => {
    if (hasRowHeader) return;
    const rowContent = tableRow.content.content; // let has = true
    // const rowContentLen = rowContent.length
    // for (let i = 0; i < rowContentLen; i++) {
    //   if (rowContent[i].type !== headerType) {
    //     has = false
    //     break
    //   }
    // }
    // fix 2565422 no-cellnumber-in-first-row

    hasRowHeader = rowContent.some(p => p.type === headerType); // hasRowHeader = rowContentLen !== 0 && has
  });
  return hasRowHeader;
} // 是否有表头列

function getHasColHeader(tableContent, headerType, hasRowHeader) {
  if (hasRowHeader === undefined) hasRowHeader = getHasRowHeader(tableContent, headerType); // 只有一行表头行时

  if (hasRowHeader && tableContent.length === 1) {
    return {
      hasColHeader: false,
      headerCol: null
    };
  }

  let hasColHeader = false;
  let headerCol = null;
  const colLen = tableContent[0].childCount;
  const rowLen = tableContent.length;
  const preRowspanInfo = {}; // 先前单元格的跨行信息

  for (let i = 0; i < colLen; i++) {
    if (hasColHeader) break;
    let has = true;
    let rowspan = 0;

    for (let j = 0; j < rowLen; j++) {
      // 跨所有行的表头不算表头列
      if (rowspan === rowLen - 1) has = false;

      if (rowspan === 0) {
        const node = tableContent[j].content.content[i - (preRowspanInfo[j] || 0)];
        if (!node) has = false;

        if (node && node.attrs.rowspan > 1) {
          rowspan = node.attrs.rowspan - 1;
        }

        if (node && node.type !== headerType) has = false;
      } else {
        preRowspanInfo[j] = preRowspanInfo[j] ? 1 + preRowspanInfo[j] : 1;
        rowspan--;
      }
    }

    hasColHeader = has;
    headerCol = i;
  }

  if (!hasColHeader) {
    headerCol = null;
  }

  return {
    hasColHeader,
    headerCol
  };
} // 是否有行号列

function getHasNumCol(tableContent, headerType, hasRowHeader) {
  if (hasRowHeader === undefined) hasRowHeader = getHasRowHeader(tableContent, headerType); // 只有一行表头行时

  if (hasRowHeader && tableContent.length === 1) {
    return false;
  }

  let hasNumCol = true;
  let rowspan = 0;

  for (let i = 0; i < tableContent.length; i++) {
    if (rowspan === 0) {
      const node = tableContent[i].firstChild; // eslint-disable-next-line

      if (!node) continue;
      const nodeRowspan = node.attrs.rowspan;
      if (nodeRowspan > 1) rowspan = nodeRowspan - 1; // 没有行号并且非表头行

      if (!node.attrs.numCell && (nodeRowspan === tableContent.length && node.type === headerType || !(node.type === headerType && i === 0))) {
        hasNumCol = false;
        break;
      }
    } else rowspan--;
  }

  return hasNumCol;
} // 是否有表头行和表头列

function hasTableHeader(state) {
  const {
    schema,
    selection
  } = state;
  const {
    $from
  } = selection;
  const tableType = schema.nodes.table;
  const headerType = schema.nodes.table_header;
  const foundNode = index_js.findParentNode($from.path, node => node.type === tableType);
  if (!foundNode) return {
    hasRowHeader: false,
    hasColHeader: false
  };
  const {
    node: tableNode,
    pos: startPos
  } = foundNode;
  if (!tableNode) return {
    hasRowHeader: false,
    hasColHeader: false,
    hasNumCol: false,
    tableNode,
    startPos
  };
  const tableContent = tableNode.content.content;
  const hasRowHeader = getHasRowHeader(tableContent, headerType);
  const {
    hasColHeader,
    headerCol
  } = getHasColHeader(tableContent, headerType, hasRowHeader);
  const hasNumCol = getHasNumCol(tableContent, headerType, hasRowHeader);
  return {
    hasRowHeader,
    hasColHeader,
    headerCol,
    hasNumCol,
    tableNode,
    startPos
  };
} // 选中单元格

function canSplitCell(state) {
  try {
    const can = splitCell(state);
    return can;
  } catch (error) {// console.error(error)
  }

  return false;
} // 是否在行号格中

function isInNumCell(state) {
  const {
    selection
  } = state;
  const {
    $from
  } = selection;
  return index_js.findParentNode($from.path, node => node.attrs && node.attrs.numCell);
} // 在表格内插入自动撑大列宽

function afterInsert(store) {
  return function ({
    braceWidth
  }) {
    return function (state, dispatch, view) {
      if (!braceWidth) return;
      const {
        selection,
        schema
      } = state;
      const {
        $from
      } = selection;
      const {
        table_cell,
        table_header
      } = schema.nodes;
      const cellTypes = [table_cell, table_header];
      const fromPath = $from.path;
      const foundCellNode = index_js.findParentNode(fromPath, node => cellTypes.includes(node.type)); // 是否在表格内

      if (foundCellNode) {
        const attrs = foundCellNode.node.attrs;
        const width = attrs.colwidth.reduce((a, b) => a + b); // 单元格宽度是否小于撑开宽度

        if (width < braceWidth) {
          updateColumnWidth(view, foundCellNode.pos, braceWidth);
          store.reShowPopover();
        }
      }
    };
  };
} // 状态变化

function stateChanged(store) {
  return function (state, dispatch, view) {
    const {
      schema,
      selection
    } = state;
    const {
      $from
    } = selection;
    const table = schema.nodes.table;
    const foundNode = index_js.findParentNode($from.path, node => node.type === table);

    if (foundNode) {
      let tableDOM = view.docView.domFromPos(foundNode.pos + 1).node;
      if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
      store.showPopover(tableDOM);
    } else if (store.isShowPopover) {
      store.hidePopover();
    }
  };
} // 当拖拽粘贴块到表格中时 触发单元格toDOM 检查是否需要overflow

const triggerTableCellToDOM = view => {
  const $pos = view.state.selection.$from;
  const tr = view.state.tr;
  const {
    table_cell,
    table_header
  } = view.state.schema.nodes;
  const cellTypes = [table_cell, table_header];
  const foundCellNode = index_js.findParentNode($pos.path, node => cellTypes.includes(node.type));

  if (foundCellNode && !foundCellNode.node.isText) {
    const attrs = foundCellNode.node.attrs;

    const newAttrs = objectSpread({}, attrs, {
      numCell: 0
    });

    if (attrs.numCell === true) return false;

    try {
      tr.setNodeMarkup(foundCellNode.pos, null, newAttrs);
      view.dispatch(tr);
    } catch (error) {
      console.error(error);
    }
  }
}; // dpi=1.25是 表格宽度需要为 4 的整数倍

function formatWidth(width) {
  width = Math.round(width);
  const remainder = width % 4;

  switch (remainder) {
    case 0:
      return width;

    case 1:
      return width - 1;

    case 2:
      return width + 2;

    default:
      return width + 1;
  }
} // 是否为空单元格

function isEmptyCell(cell) {
  const c = cell.content;
  return c.childCount === 1 && c.firstChild.isTextblock && c.firstChild.childCount === 0;
}
function cellsOverlapRectangle(ref, rect) {
  if (!ref) {
    return false;
  }

  const width = ref.width;
  const height = ref.height;
  const map = ref.map;
  let indexTop = rect.top * width + rect.left;
  let indexLeft = indexTop;
  let indexBottom = (rect.bottom - 1) * width + rect.left;
  let indexRight = indexTop + (rect.right - rect.left - 1);

  for (let i = rect.top; i < rect.bottom; i++) {
    if (rect.left > 0 && map[indexLeft] === map[indexLeft - 1] || rect.right < width && map[indexRight] === map[indexRight + 1]) {
      return true;
    }

    indexLeft += width;
    indexRight += width;
  }

  for (let i$1 = rect.left; i$1 < rect.right; i$1++) {
    if (rect.top > 0 && map[indexTop] === map[indexTop - width] || rect.bottom < height && map[indexBottom] === map[indexBottom + width]) {
      return true;
    }

    indexTop++;
    indexBottom++;
  }

  return false;
}
function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function inSameTable($a, $b) {
  return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}
function rmColSpan(attrs, pos, n = 1) {
  const result = setAttr(attrs, 'colspan', attrs.colspan - n);

  if (result.colwidth) {
    result.colwidth = result.colwidth.slice();
    result.colwidth.splice(pos, n);
    if (!result.colwidth.some(w => w > 0)) result.colwidth = null;
  }

  return result;
}
function nextCell($pos, axis, dir) {
  const start = $pos.start(-1);
  const map = TableMap.get($pos.node(-1));
  const moved = map.nextCell($pos.pos - start, axis, dir);
  return moved === null ? null : $pos.node(0).resolve(start + moved);
}

function findNextCell($cell, dir) {
  if (dir < 0) {
    const before = $cell.nodeBefore;
    if (before) return $cell.pos - before.nodeSize;

    for (let row = $cell.index(-1) - 1, rowEnd = $cell.before(); row >= 0; row--) {
      const rowNode = $cell.node(-1).child(row);
      if (rowNode.childCount) return rowEnd - 1 - rowNode.lastChild.nodeSize;
      rowEnd -= rowNode.nodeSize;
    }
  } else {
    if ($cell.index() < $cell.parent.childCount - 1) return $cell.pos + $cell.nodeAfter.nodeSize;
    const table = $cell.node(-1);

    for (let row = $cell.indexAfter(-1), rowStart = $cell.after(); row < table.childCount; row++) {
      const rowNode = table.child(row);
      if (rowNode.childCount) return rowStart + 1;
      rowStart += rowNode.nodeSize;
    }
  }
}

function moveCellForward($pos) {
  return $pos.node(0).resolve($pos.pos + $pos.nodeAfter.nodeSize);
} // :: (number) → (EditorState, dispatch: ?(tr: Transaction)) → bool
// Returns a command for selecting the next (direction=1) or previous
// (direction=-1) cell in a table.


function goToNextCell(direction) {
  return function (state, dispatch) {
    if (!isInTable(state)) return false;
    const cell = findNextCell(selectionCell(state), direction);
    if (cell === null) return;

    if (dispatch) {
      const $cell = state.doc.resolve(cell);
      dispatch(state.tr.setSelection(prosemirrorState.TextSelection.between($cell, moveCellForward($cell))).scrollIntoView());
    }

    return true;
  };
}
const canAddColumnBefore = store => state => {
  try {
    return addColumnBefore(store)(state);
  } catch (error) {
    console.error(error);
    return false;
  }
};
const canAddColumnAfter = store => state => {
  try {
    return addColumnAfter(store)(state);
  } catch (error) {
    console.error(error);
    return false;
  }
};
const canAddRowBefore = store => state => {
  try {
    return addRowBefore(store)(state);
  } catch (error) {
    console.warn(error);
    return false;
  }
}; // 是否全选表格

const isAllCellSelection = selection => {
  if (selection instanceof CellSelection) {
    const {
      $from,
      ranges
    } = selection;
    const foundNode = index_js.findParentNode($from.path, item => item.type && item.type.name === 'table');
    const tableRowContents = foundNode.node.content.content;
    let tableCellCount = 0;

    for (let i = 0; i < tableRowContents.length; i++) {
      const row = tableRowContents[i];
      tableCellCount += row.content.content.length;
    }

    return tableCellCount === ranges.length;
  }

  return false;
}; // 是否可缩进

function canIndent(state, direction) {
  return setIndent(_ => _, direction)(state);
}
function getTableAttrs(state) {
  const $from = state.selection.$from;
  const foundNode = index_js.findParentNode($from.path, item => item.type && item.type.name === 'table');

  if (foundNode) {
    return foundNode.node.attrs;
  }
}

// This file defines a ProseMirror selection subclass that models
// subclass that represents a cell selection spanning part of a table.
// With the plugin enabled, these will be created when the user
// selects across cells, and will be drawn by giving selected cells a
// `selectedCell` CSS class.

class CellSelection extends prosemirrorState.Selection {
  // :: (ResolvedPos, ?ResolvedPos)
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor($anchorCell, $headCell = $anchorCell) {
    let table = $anchorCell.node(-1),
        map = TableMap.get(table),
        start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter(p => p != $headCell.pos - start); // Make the head cell the first range, so that it counts as the
    // primary part of the selection

    cells.unshift($headCell.pos - start);
    const ranges = cells.map(pos => {
      let cell = table.nodeAt(pos),
          from = pos + start + 1;
      return new prosemirrorState.SelectionRange(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
    super(ranges[0].$from, ranges[0].$to, ranges); // :: ResolvedPos
    // A resolved position pointing _in front of_ the anchor cell (the one
    // that doesn't move when extending the selection).

    this.$anchorCell = $anchorCell; // :: ResolvedPos
    // A resolved position pointing in front of the head cell (the one
    // moves when extending the selection).

    this.$headCell = $headCell;
  }

  map(doc, mapping) {
    const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
    const $headCell = doc.resolve(mapping.map(this.$headCell.pos));

    if (pointsAtCell($anchorCell) && pointsAtCell($headCell) && inSameTable($anchorCell, $headCell)) {
      const tableChanged = this.$anchorCell.node(-1) != $anchorCell.node(-1);

      if (tableChanged && this.isRowSelection()) {
        return CellSelection.colSelection($anchorCell, $headCell);
      } else if (tableChanged && this.isColSelection()) {
        return CellSelection.rowSelection($anchorCell, $headCell);
      }

      return new CellSelection($anchorCell, $headCell);
    }

    return prosemirrorState.TextSelection.between($anchorCell, $headCell);
  } // :: () → Slice
  // Returns a rectangular slice of table rows containing the selected
  // cells.


  content() {
    let table = this.$anchorCell.node(-1),
        map = TableMap.get(table),
        start = this.$anchorCell.start(-1);
    const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
    let seen = [],
        rows = [];

    for (let row = rect.top; row < rect.bottom; row++) {
      const rowContent = [];

      for (let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++) {
        const pos = map.map[index];

        if (seen.indexOf(pos) == -1) {
          seen.push(pos);
          let cellRect = map.findCell(pos),
              cell = table.nodeAt(pos);
          let extraLeft = rect.left - cellRect.left,
              extraRight = cellRect.right - rect.right;

          if (extraLeft > 0 || extraRight > 0) {
            let attrs = cell.attrs;
            if (extraLeft > 0) attrs = rmColSpan(attrs, 0, extraLeft);
            if (extraRight > 0) attrs = rmColSpan(attrs, attrs.colspan - extraRight, extraRight);
            if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);else cell = cell.type.create(attrs, cell.content);
          }

          if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
            const attrs = setAttr(cell.attrs, 'rowspan', Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top));
            if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);else cell = cell.type.create(attrs, cell.content);
          }

          rowContent.push(cell);
        }
      }

      rows.push(table.child(row).copy(prosemirrorModel.Fragment.from(rowContent)));
    }

    return new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(rows), 1, 1);
  }

  replace(tr, content = prosemirrorModel.Slice.empty) {
    let mapFrom = tr.steps.length,
        ranges = this.ranges;

    for (let i = 0; i < ranges.length; i++) {
      let {
        $from,
        $to
      } = ranges[i],
          mapping = tr.mapping.slice(mapFrom);
      tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? prosemirrorModel.Slice.empty : content);
    }

    const sel = prosemirrorState.Selection.findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
    if (sel) tr.setSelection(sel);
  }

  replaceWith(tr, node) {
    this.replace(tr, new prosemirrorModel.Slice(prosemirrorModel.Fragment.from(node), 0, 0));
  }

  forEachCell(f) {
    let table = this.$anchorCell.node(-1),
        map = TableMap.get(table),
        start = this.$anchorCell.start(-1);
    const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));

    for (let i = 0; i < cells.length; i++) {
      f(table.nodeAt(cells[i]), start + cells[i]);
    }
  } // :: () → bool
  // True if this selection goes all the way from the top to the
  // bottom of the table.


  isColSelection() {
    let anchorTop = this.$anchorCell.index(-1),
        headTop = this.$headCell.index(-1);
    if (Math.min(anchorTop, headTop) > 0) return false;
    let anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan,
        headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(anchorBot, headBot) == this.$headCell.node(-1).childCount;
  } // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest row selection that covers the given anchor
  // and head cell.


  static rowSelection($anchorCell, $headCell = $anchorCell) {
    let map = TableMap.get($anchorCell.node(-1)),
        start = $anchorCell.start(-1);
    let anchorRect = map.findCell($anchorCell.pos - start),
        headRect = map.findCell($headCell.pos - start);
    const doc = $anchorCell.node(0);

    if (anchorRect.top <= headRect.top) {
      if (anchorRect.top > 0) {
        $anchorCell = doc.resolve(start + map.map[anchorRect.left]);
      }

      if (headRect.bottom < map.height) {
        $headCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
      }
    } else {
      if (headRect.top > 0) {
        $headCell = doc.resolve(start + map.map[headRect.left]);
      }

      if (anchorRect.bottom < map.height) {
        $anchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
      }
    }

    return new CellSelection($anchorCell, $headCell);
  } // :: () → bool
  // True if this selection goes all the way from the left to the
  // right of the table.


  isRowSelection() {
    let map = TableMap.get(this.$anchorCell.node(-1)),
        start = this.$anchorCell.start(-1);
    let anchorLeft = map.colCount(this.$anchorCell.pos - start),
        headLeft = map.colCount(this.$headCell.pos - start);
    if (Math.min(anchorLeft, headLeft) > 0) return false;
    let anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan,
        headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(anchorRight, headRight) == map.width;
  }

  eq(other) {
    return other instanceof CellSelection && other.$anchorCell.pos == this.$anchorCell.pos && other.$headCell.pos == this.$headCell.pos;
  } // :: (ResolvedPos, ?ResolvedPos) → CellSelection
  // Returns the smallest column selection that covers the given anchor
  // and head cell.


  static colSelection($anchorCell, $headCell = $anchorCell) {
    let map = TableMap.get($anchorCell.node(-1)),
        start = $anchorCell.start(-1);
    let anchorRect = map.findCell($anchorCell.pos - start),
        headRect = map.findCell($headCell.pos - start);
    const doc = $anchorCell.node(0);

    if (anchorRect.left <= headRect.left) {
      if (anchorRect.left > 0) {
        $anchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
      }

      if (headRect.right < map.width) {
        $headCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
      }
    } else {
      if (headRect.left > 0) {
        $headCell = doc.resolve(start + map.map[headRect.top * map.width]);
      }

      if (anchorRect.right < map.width) {
        $anchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
      }
    }

    return new CellSelection($anchorCell, $headCell);
  }

  toJSON() {
    return {
      type: 'cell',
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }

  static fromJSON(doc, json) {
    return new CellSelection(doc.resolve(json.anchor), doc.resolve(json.head));
  } // :: (Node, number, ?number) → CellSelection


  static create(doc, anchorCell, headCell = anchorCell) {
    return new CellSelection(doc.resolve(anchorCell), doc.resolve(headCell));
  }

  getBookmark() {
    return new CellBookmark(this.$anchorCell.pos, this.$headCell.pos);
  }

}
CellSelection.prototype.visible = false;
prosemirrorState.Selection.jsonID('cell', CellSelection);

class CellBookmark {
  constructor(anchor, head) {
    this.anchor = anchor;
    this.head = head;
  }

  map(mapping) {
    return new CellBookmark(mapping.map(this.anchor), mapping.map(this.head));
  }

  resolve(doc) {
    let $anchorCell = doc.resolve(this.anchor),
        $headCell = doc.resolve(this.head);

    if ($anchorCell.parent.type.spec.tableRole == 'row' && $headCell.parent.type.spec.tableRole == 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && inSameTable($anchorCell, $headCell)) {
      return new CellSelection($anchorCell, $headCell);
    }

    return prosemirrorState.Selection.near($headCell, 1);
  }

}

function drawCellSelection(state) {
  if (!(state.selection instanceof CellSelection)) return null;
  const cells = [];
  state.selection.forEachCell((node, pos) => {
    cells.push(prosemirrorView.Decoration.node(pos, pos + node.nodeSize, {
      class: 'selectedCell'
    }));
  });
  return prosemirrorView.DecorationSet.create(state.doc, cells);
}

function isCellBoundarySelection({
  $from,
  $to
}) {
  if ($from.pos == $to.pos || $from.pos < $from.pos - 6) return false; // Cheap elimination

  let afterFrom = $from.pos,
      beforeTo = $to.pos,
      depth = $from.depth;

  for (; depth >= 0; depth--, afterFrom++) {
    if ($from.after(depth + 1) < $from.end(depth)) break;
  }

  for (let d = $to.depth; d >= 0; d--, beforeTo--) {
    if ($to.before(d + 1) > $to.start(d)) break;
  }

  return afterFrom == beforeTo && /row|table/.test($from.node(depth).type.spec.tableRole);
}

function normalizeSelection(state, tr) {
  let sel = (tr || state).selection,
      doc = (tr || state).doc,
      normalize,
      role;

  if (sel instanceof prosemirrorState.NodeSelection && (role = sel.node.type.spec.tableRole)) {
    if (role == 'cell' || role == 'header_cell') {
      normalize = CellSelection.create(doc, sel.from);
    } else if (role == 'row') {
      const $cell = doc.resolve(sel.from + 1);
      normalize = CellSelection.rowSelection($cell, $cell);
    } else {
      let map = TableMap.get(sel.node),
          start = sel.from + 1;
      const lastCell = start + map.map[map.width * map.height - 1];
      normalize = CellSelection.create(doc, start + 1, lastCell);
    }
  } else if (sel instanceof prosemirrorState.TextSelection && isCellBoundarySelection(sel)) {
    normalize = prosemirrorState.TextSelection.create(doc, sel.from);
  }

  if (normalize) {
    (tr || (tr = state.tr)).setSelection(normalize);
  }

  return tr;
}

var css$5 = ".selectbar-addtip-wrapper.left,.selectbar-addtip-wrapper.right{float:left;width:50%;height:100%}.selectbar-addtip-wrapper.bottom,.selectbar-addtip-wrapper.top{width:100%;height:50%;position:relative}.selectbar-addtip{position:absolute;display:flex;justify-content:center;align-items:center;background:#111;border-radius:3px;line-height:26px;z-index:99;cursor:pointer}.selectbar-addtip svg path{fill:#fff}.selectbar-addtip.left{left:-12px}.selectbar-addtip.right{right:-12px}.selectbar-addtip.left,.selectbar-addtip.right{top:0;width:24px;height:24px;margin-bottom:4px}.selectbar-addtip.left:after,.selectbar-addtip.right:after{content:\"\";position:absolute;width:0;bottom:-4px;right:50%;-webkit-transform:translate(50%);transform:translate(50%);display:block;border-color:#111 transparent;border-style:solid;border-width:5px 5px 0;z-index:1}.selectbar-addtip.top{top:-12px}.selectbar-addtip.bottom{bottom:-12px}.selectbar-addtip.bottom,.selectbar-addtip.top{left:-20px;width:24px;height:24px;margin-right:4px}.selectbar-addtip.bottom:after,.selectbar-addtip.top:after{content:\"\";position:absolute;width:0;right:-9px;bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%);display:block;border:5px solid transparent;border-left-color:#111;z-index:1}";
styleInject(css$5);

/** @jsx h */

class Addtip extends preact.Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasAddtip: false,
      extraOffset: 0
    };

    this.handleMouseEnter = e => {
      const {
        dir
      } = this.props;
      const {
        left,
        right
      } = e.target.getBoundingClientRect();
      let extraOffset = 0;

      if (e.target.closest('.ct-table-col-selectbar-wrapper')) {
        const wrapper = e.target.closest('.ct-table-col-selectbar-wrapper');
        const {
          left: wrapperLeft,
          right: wrapperRight
        } = wrapper.getBoundingClientRect();

        if (dir === 'left') {
          extraOffset = left > wrapperLeft ? 0 : wrapperLeft - left;
        }

        if (dir === 'right') {
          extraOffset = right > wrapperRight ? wrapperRight - right : 0;
        }
      }

      this.setState({
        hasAddtip: true,
        extraOffset
      });
    };
  }

  render() {
    const {
      children,
      dir,
      onClick,
      offset
    } = this.props;
    const {
      hasAddtip,
      extraOffset
    } = this.state;
    const style = {
      left: offset + extraOffset
    };
    return preact.h("div", {
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: () => this.setState({
        hasAddtip: false
      }),
      className: `selectbar-addtip-wrapper ${dir}`,
      ref: refs => {
        this.wrapper = refs;
      }
    }, children, hasAddtip && preact.h("div", {
      className: `selectbar-addtip ${dir}`,
      style: style,
      onClick: onClick
    }, preact.h("svg", {
      width: "16px",
      height: "16px",
      viewBox: "0 0 16 16"
    }, preact.h("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, preact.h("g", {
      transform: "translate(-273.000000, -427.000000)",
      fill: "#BDC2C7"
    }, preact.h("g", {
      transform: "translate(276.000000, 430.000000)"
    }, preact.h("path", {
      d: "M5.66497803,4.33502197 L5.66497803,0.664978027 C5.66497803,0.297720804 5.36725722,0 5,0 C4.63274278,0 4.33502197,0.297720804 4.33502197,0.664978027 L4.33502197,4.33502197 L0.664978027,4.33502197 C0.297720804,4.33502197 0,4.63274278 0,5 C0,5.36725722 0.297720804,5.66497803 0.664978027,5.66497803 L4.33502197,5.66497803 L4.33502197,9.33502197 C4.33502197,9.7022792 4.63274278,10 5,10 C5.36725722,10 5.66497803,9.7022792 5.66497803,9.33502197 L5.66497803,5.66497803 L9.33502197,5.66497803 C9.7022792,5.66497803 10,5.36725722 10,5 C10,4.63274278 9.7022792,4.33502197 9.33502197,4.33502197 L5.66497803,4.33502197 Z",
      id: "Combined-Shape"
    })))))));
  }

}

const preventShiftMouseDown = e => {
  if (e.shiftKey) e.preventDefault();
};
/** @jsx h */


class RowSelectBar extends preact.Component {
  constructor(...args) {
    super(...args);
    this.anchorCellIdx = null;
    this.headCellIdx = null;

    this.handleItemClick = (event, itemIdx) => {
      const {
        view,
        tableDOM,
        tableWidth,
        reShowPopover
      } = this.props;
      const {
        dispatch,
        state
      } = view;
      const {
        tr,
        doc
      } = state;
      const tableBodyDOM = tableDOM.lastElementChild;
      let anchorCellIdx = itemIdx;
      let headCellIdx = itemIdx; // 是否按下shift

      if (event.shiftKey) {
        if (this.anchorCellIdx < itemIdx) {
          anchorCellIdx = typeof this.anchorCellIdx === 'number' ? this.anchorCellIdx : itemIdx;
          headCellIdx = itemIdx;
        } else {
          anchorCellIdx = itemIdx;
          headCellIdx = typeof this.headCellIdx === 'number' ? this.headCellIdx : itemIdx;
        }
      } // 确定选择的始末位置


      let idxChanged = true;
      let times = 0;

      while (idxChanged && times < 50) {
        times++;
        idxChanged = false;
        Array.from(tableBodyDOM.children).forEach((tableRowDOM, idx) => {
          const cellDOMs = Array.from(tableRowDOM.children);
          if (idx > headCellIdx) return;
          cellDOMs.forEach(cell => {
            if (cell.rowSpan) {
              const maxReach = idx + cell.rowSpan - 1;

              if (idx < anchorCellIdx && maxReach >= anchorCellIdx) {
                anchorCellIdx = idx;
                idxChanged = true;
              }

              if (maxReach > headCellIdx) {
                headCellIdx = maxReach;
                idxChanged = true;
              }
            }
          });
        });
      }

      this.anchorCellIdx = anchorCellIdx;
      this.headCellIdx = headCellIdx; // 获取始末位置的单元格节点

      const anchorCellDOM = tableBodyDOM.children[anchorCellIdx].firstElementChild;
      const borderWidth = parseInt(window.getComputedStyle(anchorCellDOM, null).borderWidth, 10);
      let headCellDOM;
      Array.from(tableBodyDOM.children).forEach((tableRowDOM, idx) => {
        const cellDOM = tableRowDOM.lastElementChild;

        if (!headCellDOM && cellDOM && idx >= anchorCellIdx && headCellIdx >= idx && ( // 在范围之内
        cellDOM.rowSpan && cellDOM.rowSpan - 1 + idx === headCellIdx || idx === headCellIdx)) {
          // 在末尾
          // 是否在最右侧
          const totalOffset = cellDOM.offsetLeft + cellDOM.offsetWidth;
          const floorTableWidth = Math.floor(tableWidth);
          const dis = totalOffset - floorTableWidth + borderWidth;

          if (dis > -5 && dis < 5) {
            headCellDOM = cellDOM;
          }
        }
      }); // 获取始末位置的pos

      const anchorPos = view.docView.posFromDOM(anchorCellDOM, undefined, -1) - 1;
      const headPos = view.docView.posFromDOM(headCellDOM, undefined, -1) - 1; // 设置选区

      const newSelection = new CellSelection(doc.resolve(anchorPos), doc.resolve(headPos));
      dispatch(tr.setSelection(newSelection));
      view.focus();
      reShowPopover();
    };

    this.handleAddtipClick = (event, idx, dir) => {
      const {
        store,
        view,
        tableDOM
      } = this.props;
      const {
        dispatch,
        state
      } = view;
      const {
        tr,
        doc
      } = state;
      const tableBodyDOM = tableDOM.lastElementChild;
      event.stopPropagation(); // 获取行首单元格节点

      let currentCellDOM = null;
      let cellIdx = idx;

      while (!currentCellDOM) {
        currentCellDOM = tableBodyDOM.children[cellIdx].firstElementChild;
        cellIdx--;
      } // 获取pos


      const currentPos = view.docView.posFromDOM(currentCellDOM, undefined, -1);
      dispatch(tr.setSelection(prosemirrorState.TextSelection.create(doc, currentPos + (currentCellDOM.classList.contains('num-cell') ? 4 : 2))));

      if (dir === 'top') {
        return addRowBefore(store)(view.state, view.dispatch, view);
      }

      return addRowAfter(store)(view.state, view.dispatch, view);
    };

    this.renderItems = () => {
      const {
        tableDOM,
        selectedRowArr
      } = this.props;
      if (!tableDOM) return [];
      let tableRowDOMs = Array.from(tableDOM.lastElementChild.children);
      const items = [];
      this.anchorCellIdx = selectedRowArr.length ? Math.min(...selectedRowArr) : null;
      this.headCellIdx = selectedRowArr.length ? Math.max(...selectedRowArr) : null;

      if (tableRowDOMs[0] && tableRowDOMs[0].classList.contains('ProseMirror-widget')) {
        tableRowDOMs = tableRowDOMs.slice(1);
      } // 设置对应选中的选择栏项


      tableRowDOMs.forEach((tr, idx) => {
        const trHeight = parseFloat(window.getComputedStyle(tr).height);
        const selected = selectedRowArr.includes(idx);
        items.push(preact.h("div", {
          key: idx,
          className: `ct-table-selectbar-item${selected ? ' selected' : ''}`,
          style: {
            height: `${trHeight + (idx === 0 ? 1 : 0)}px`
          },
          onClick: e => this.handleItemClick(e, idx),
          onMouseDown: preventShiftMouseDown
        }, preact.h(Addtip, {
          dir: "top",
          onClick: e => this.handleAddtipClick(e, idx, 'top')
        }, preact.h("div", {
          className: "visible-wrapper top"
        }, preact.h("div", {
          className: "visible"
        }))), preact.h(Addtip, {
          dir: "bottom",
          onClick: e => this.handleAddtipClick(e, idx, 'bottom')
        }, preact.h("div", {
          className: "visible-wrapper bottom"
        }, preact.h("div", {
          className: "visible"
        })))));
      });
      return items;
    };
  }

  render() {
    return preact.h("div", {
      className: "ct-table-row-selectbar"
    }, this.renderItems());
  }

}

/** @jsx h */

const preventShiftMouseDown$1 = e => {
  if (e.shiftKey) e.preventDefault();
};

class ColSelectBar$1 extends preact.Component {
  constructor(props) {
    super(props);
    this.anchorCellIdx = null;
    this.headCellIdx = null;
    this.state = {
      scrollLeft: 0
    };

    this.handleItemClick = (event, itemIdx) => {
      const {
        view,
        tableDOM,
        reShowPopover
      } = this.props;
      const {
        dispatch,
        state
      } = view;
      const {
        tr,
        doc
      } = state;
      const tableBodyDOM = tableDOM.lastElementChild;
      let anchorCellIdx = itemIdx;
      let headCellIdx = itemIdx; // 是否按下shift

      if (event.shiftKey) {
        if (this.anchorCellIdx < itemIdx) {
          anchorCellIdx = typeof this.anchorCellIdx === 'number' ? this.anchorCellIdx : itemIdx;
          headCellIdx = itemIdx;
        } else {
          anchorCellIdx = itemIdx;
          headCellIdx = typeof this.headCellIdx === 'number' ? this.headCellIdx : itemIdx;
        }
      } // 确定选择的始末位置


      let idxChanged = true;

      while (idxChanged) {
        idxChanged = false;
        Array.from(tableBodyDOM.children).forEach(tableRowDOM => {
          const cellDOMs = Array.from(tableRowDOM.children);
          cellDOMs.forEach((cellDOM, idx) => {
            if (idx <= headCellIdx && cellDOM.colSpan) {
              const maxReach = idx + cellDOM.colSpan - 1; // 起始之外且宽度到达起始

              if (idx < anchorCellIdx && maxReach >= anchorCellIdx) {
                anchorCellIdx = idx;
                idxChanged = true;
              } // 宽度超过末尾


              if (maxReach > headCellIdx) {
                headCellIdx = maxReach;
                idxChanged = true;
              }
            }
          });
        });
      }

      this.anchorCellIdx = anchorCellIdx;
      this.headCellIdx = headCellIdx; // 获取始末位置的单元格节点

      let anchorCellDOM;
      let headCellDOM;
      let index = 0;
      Array.from(tableBodyDOM.firstElementChild.children).forEach(cellDOM => {
        if (index === anchorCellIdx) anchorCellDOM = cellDOM;
        index = (cellDOM.colSpan ? index + cellDOM.colSpan - 1 : index) + 1;
      });
      const preRowspanInfo = {}; // 先前单元格的跨行信息

      const tableRows = tableBodyDOM.children;
      const colLen = tableDOM.firstElementChild.children.length;
      const rowLen = tableRows.length;

      for (let i = 0; i < colLen && !headCellDOM; i++) {
        let rowspan = 0;

        for (let j = 0; j < rowLen && !headCellDOM; j++) {
          let cellDOM;

          if (rowspan === 0) {
            cellDOM = tableRows[j].children[i - (preRowspanInfo[j] || 0)];

            if (cellDOM && cellDOM.rowSpan > 1) {
              rowspan = cellDOM.rowSpan - 1;
            }
          } else {
            cellDOM = tableRows[j].children[i];
            preRowspanInfo[j] = preRowspanInfo[j] ? 1 + preRowspanInfo[j] : 1;
            rowspan--;
          }

          if (cellDOM && (cellDOM.rowSpan ? cellDOM.rowSpan + j : j) === rowLen && ((cellDOM.colSpan ? i + cellDOM.colSpan - 1 : i) === headCellIdx || anchorCellDOM.offsetLeft === cellDOM.offsetLeft)) {
            headCellDOM = cellDOM;
          }
        }
      }

      if (!headCellDOM || this.anchorCellIdx !== this.headCellIdx) {
        let maybeHeadCellDOM = 0;
        index = preRowspanInfo[rowLen - 1] || 0;
        Array.from(tableBodyDOM.lastElementChild.children).forEach(cellDOM => {
          if (cellDOM && anchorCellDOM.offsetLeft === cellDOM.offsetLeft) maybeHeadCellDOM = cellDOM;
          if ((cellDOM.colSpan ? index + cellDOM.colSpan - 1 : index) === headCellIdx) headCellDOM = cellDOM;
          index = (cellDOM.colSpan ? index + cellDOM.colSpan - 1 : index) + 1;
        });
        if (!headCellDOM) headCellDOM = maybeHeadCellDOM;
      } // 获取始末位置的pos


      const anchorPos = view.docView.posFromDOM(anchorCellDOM, undefined, -1) - 1;
      const headPos = view.docView.posFromDOM(headCellDOM, undefined, -1) - 1; // 设置选区

      const newSelection = new CellSelection(doc.resolve(anchorPos), doc.resolve(headPos));
      dispatch(tr.setSelection(newSelection));
      view.focus();
      reShowPopover();
    };

    this.handleAddtipClick = (event, idx, dir) => {
      const {
        store,
        view,
        tableDOM
      } = this.props;
      const {
        dispatch,
        state
      } = view;
      const {
        tr,
        doc
      } = state;
      const tableBodyDOM = tableDOM.lastElementChild;
      event.stopPropagation(); // 获取列首单元格节点

      let currentCellDOM = null;
      let index = 0;
      Array.from(tableBodyDOM.firstElementChild.children).forEach(cellDOM => {
        if (currentCellDOM) return;
        const maxReach = index + cellDOM.colSpan - 1;
        if (index <= idx && idx <= maxReach) currentCellDOM = cellDOM;
        index = (cellDOM.colSpan ? maxReach : index) + 1;
      }); // 获取pos

      const currentPos = view.docView.posFromDOM(currentCellDOM, undefined, -1);
      dispatch(tr.setSelection(prosemirrorState.TextSelection.create(doc, currentPos + 1)));

      if (dir === 'left') {
        return addColumnBefore(store)(view.state, view.dispatch, view);
      }

      return addColumnAfter(store)(view.state, view.dispatch, view);
    };

    this.renderItems = () => {
      const {
        store,
        tableDOM,
        selectedColArr
      } = this.props;
      const {
        scrollLeft
      } = this.state;
      if (!tableDOM) return [];
      let colDOMs = Array.from(tableDOM.firstElementChild.children);
      const items = [];

      if (colDOMs.length === 0) {
        const tableRowDOMs = tableDOM.lastElementChild.children;
        const rowDOM = tableRowDOMs[0];
        colDOMs = [];

        for (let i = 0; i < rowDOM.childElementCount; i++) {
          const cellDOM = rowDOM.children[i];
          const colspan = parseInt(cellDOM.getAttribute('colspan'), 10) || 1;
          const cellWidth = cellDOM.getBoundingClientRect().width / colspan;

          for (let j = 0; j < colspan; j++) {
            colDOMs.push({
              cellWidth
            });
          }
        }
      }

      store.colDOMs = colDOMs;
      this.anchorCellIdx = selectedColArr.length ? Math.min(...selectedColArr) : null;
      this.headCellIdx = selectedColArr.length ? Math.max(...selectedColArr) : null; // 设置对应选中的选择栏项

      let totalWidth = 0;
      colDOMs.forEach((col, idx) => {
        const colWidth = col.cellWidth || parseInt(col.style && col.style.width, 10);
        totalWidth += colWidth;
        const selected = selectedColArr.includes(idx);
        items.push(preact.h("div", {
          key: idx,
          className: `ct-table-selectbar-item${selected ? ' selected' : ''}`,
          style: {
            width: `${idx === colDOMs.length - 1 ? colWidth + 1 : colWidth}px`
          },
          onClick: e => this.handleItemClick(e, idx),
          onMouseDown: preventShiftMouseDown$1
        }, preact.h(Addtip, {
          dir: "left",
          offset: totalWidth - colWidth - 12 - scrollLeft,
          onClick: e => this.handleAddtipClick(e, idx, 'left')
        }, preact.h("div", {
          className: "visible-wrapper left"
        }, preact.h("div", {
          className: "visible"
        }))), preact.h(Addtip, {
          dir: "right",
          offset: totalWidth - 12 - scrollLeft,
          onClick: e => this.handleAddtipClick(e, idx, 'right')
        }, preact.h("div", {
          className: "visible-wrapper right"
        }, preact.h("div", {
          className: "visible"
        })))));
      });
      return {
        items,
        totalWidth
      };
    };

    this.onScroll = e => {
      this.setState({
        scrollLeft: e.target.scrollLeft
      });
    };

    this.handleScroll = throttle(this.onScroll, 300);
  }

  componentDidMount() {
    const {
      parentNode
    } = this.props;
    this.scrollBar.scrollLeft = parentNode.scrollLeft;
  }

  componentDidUpdate() {
    const {
      parentNode
    } = this.props;
    const scrollLeft = parentNode.scrollLeft;

    if (this.scrollBar.scrollLeft !== scrollLeft) {
      this.scrollBar.scrollLeft = scrollLeft;
    }
  } // 选择栏被点击


  render() {
    const {
      containerWidth,
      tableMarginLeft,
      colPaddingLeft
    } = this.props;
    const {
      items,
      totalWidth
    } = this.renderItems();
    return preact.h("div", {
      style: {
        position: 'relative'
      }
    }, preact.h("div", {
      className: "ct-table-col-selectbar-wrapper",
      style: {
        width: `${containerWidth - tableMarginLeft + colPaddingLeft}px`,
        paddingLeft: `${colPaddingLeft}px`
      },
      ref: div => {
        this.scrollBar = div;
      },
      onScroll: this.handleScroll
    }, preact.h("div", {
      className: "ct-table-col-selectbar",
      style: {
        width: `${totalWidth + 1}px`
      }
    }, items)));
  }

}

/** @jsx h */

const showPopoverUtil = (popover, styleObj, Component, props) => {
  if (!popover) return;
  popover.style.display = 'block';
  Object.keys(styleObj).forEach(key => {
    popover.style[key] = styleObj[key];
  });
  preact.render(preact.h(Component, props), popover, popover.firstChild);
};
const hidePopoverUtil = popover => {
  if (!popover) return;
  popover.style.display = 'none';
  preact.render(null, popover, popover.firstChild);
};
const isLegalTableDOM = tableDOM => tableDOM && tableDOM.tagName.toUpperCase() === 'TABLE' && tableDOM.parentNode && tableDOM.parentNode.classList.contains('ct-table-wrapper') && !tableDOM.closest('.ct-collapse:not(.active)');

class TableStore {
  constructor(config) {
    this.config = {};
    this.core = null;
    this.view = null;
    this.modules = null;
    this.$scroll = null;
    this.popover = null;
    this.isShowPopover = false;
    this.isShowScrollBar = false;
    this.isShowHeaderBar = false;
    this.isShowSelectBar = false;
    this.headerTableDOM = null;
    this.headerParentNode = null;
    this.headerPaddingLeft = 0;
    this.scrollTableDOM = null;
    this.tableDOM = null;
    this.tableContent = "";
    this.tablePos = null;
    this.parentNode = null;
    this.colDOMs = [];
    this.tableMarginLeft = 0;
    this.tableLeft = 0;
    this.tableTop = 0;
    this.tableBottom = 0;
    this.tableHeight = 0;
    this.tableWidth = 0;
    this.containerWidth = 0;
    this.colPaddingLeft = 0;
    this.scrollContainerWidth = 0;
    this.scrollTableWidth = 0;
    this.tableHeightChanging = false;
    this.cellSelection = null;
    this.selectedRowArr = [];
    this.selectedColArr = [];

    this.emitTableError = msg => {
      if (this.editor) {
        this.editor.emit("tableError", msg);
      }
    };

    this.checkGlobalTabel = (checkHeader = true) => {
      const tableDOMs = Array.from(this.$scroll.querySelectorAll(".ct-table-wrapper > table")).filter(tableDOM => !tableDOM.closest(".ct-collapse:not(.active)"));
      if (checkHeader) this.checkTableHeader(tableDOMs);
      this.checkScrollBar(tableDOMs);
    };

    this.reShowPopover = () => {
      const tableDOM = this.tableDOM || this.tablePos && this.view.docView.domFromPos(this.tablePos + 1).node.parentNode;
      this.showPopover(tableDOM);
    };

    this.showPopover = tableDOM => {
      if (!isLegalTableDOM(tableDOM)) return this.hidePopover();
      this.isShowPopover = true;
      this.tableDOM = tableDOM;
      this.tableContent = tableDOM.innerHTML;
      this.parentNode = tableDOM.parentNode;
      setTimeout(() => {
        if (!this.tableDOM) return this.hidePopover();

        try {
          this.tablePos = this.view.docView.posFromDOM(this.tableDOM) - 1;
        } catch (error) {
          // posFromDOM会有报错的可能，报错就返回即可,因为光标不会改变下次的逻辑
          // 这里原本是return hidePopover()，是没有必要的
          return;
        }

        this.setTableRect();
        this.showSelectBar();
        this.handleCellSelected();
        this.addEvents();
        this.checkTableHeader([tableDOM, this.headerTableDOM].filter(_ => !!_));
      }, 0);
    };

    this.hidePopover = () => {
      const tableDOM = this.tableDOM;
      this.isShowPopover = false;
      this.tableDOM = null;
      this.tablePos = null;
      this.cellSelection = null;
      this.selectedRowArr = [];
      this.selectedColArr = [];
      this.hideSelectBar();
      this.removeEvents();
      this.checkTableHeader([tableDOM, this.headerTableDOM].filter(_ => !!_));
    };

    this.checkScrollBar = tableDOMs => {
      const res = tableDOMs.some(tableDOM => this.toggleScrollBar(tableDOM));

      if (!res) {
        this.scrollTableDOM = null;
        this.hideScrollBar();
      }
    };

    this.toggleScrollBar = scrollTableDOM => {
      const bottomBias = this.getBottomBias();
      const scrollParentNode = scrollTableDOM.parentNode;
      const isOutTable = scrollParentNode && !scrollParentNode.closest("table");
      if (!isOutTable) return false;
      const tableRect = scrollTableDOM.getBoundingClientRect();
      const tableLeft = tableRect.left + scrollParentNode.scrollLeft;
      const tableBottom = window.innerHeight - tableRect.bottom;
      const containerWidth = scrollParentNode.clientWidth;
      const tableWidth = tableRect.width; // 满足滚动条件

      if (containerWidth < tableWidth && tableRect.top + bottomBias + 10 < window.innerHeight && tableBottom < bottomBias + 10) {
        this.scrollTableDOM = scrollTableDOM;
        this.scrollParentNode = scrollParentNode;
        this.scrollContainerWidth = containerWidth;
        this.scrollTableWidth = tableWidth;
        this.showScrollBar(tableLeft);
        return true;
      }

      return false;
    };

    this.showScrollBar = tableLeft => {
      const bottomBias = this.getBottomBias();
      const styleObj = {
        left: `${tableLeft}px`,
        bottom: `${bottomBias}px`
      };
      const props = {
        scrollParentNode: this.scrollParentNode,
        scrollContainerWidth: this.scrollContainerWidth,
        scrollTableWidth: this.scrollTableWidth
      };
      showPopoverUtil(this.scrollBarPopover, styleObj, ScrollBar, props);
      this.isShowScrollBar = true;
    };

    this.hideScrollBar = () => {
      hidePopoverUtil(this.scrollBarPopover);
      this.isShowScrollBar = false;
    };

    this.checkTableHeader = tableDOMs => {
      const res = tableDOMs.some(tableDOM => this.toggleHeaderBar(tableDOM));

      if (!res) {
        this.headerTableDOM = null;
        this.hideHeaderBar();
      }
    };

    this.toggleHeaderBar = headerTableDOM => {
      try {
        const topBias = this.getTopBias();
        const tbody = headerTableDOM.querySelector('tbody');
        const findFirstTr = tbody && tbody.querySelector("tr"); // 找到tbody中的第一个tr

        if (!findFirstTr) {
          throw new Error(`citadelError: cann't find tr in dom ${tbody.innerHTML}`);
        }

        const hasTableHeader = [...findFirstTr.cells].every(cell => cell.tagName === "TH");
        const {
          top,
          bottom,
          left
        } = headerTableDOM.getBoundingClientRect();

        if (hasTableHeader && top < topBias && bottom > topBias + findFirstTr.clientHeight) {
          this.headerTableDOM = headerTableDOM;
          this.headerParentNode = headerTableDOM.parentNode;
          this.tableHeader = this.cloneHeader(findFirstTr);
          const scrollLeft = this.headerParentNode.scrollLeft;
          this.showHeaderBar(topBias, left, scrollLeft);
          return true;
        }

        return false;
      } catch (err) {
        throw err;
      }
    };

    this.showHeaderBar = (toolbarHeight, headerLeft, scrollLeft) => {
      const marginLeft = parseInt(this.headerTableDOM.style.marginLeft, 10) || 0;
      let paddingLeft = 0;
      let popoverLeft = scrollLeft + headerLeft;

      if (marginLeft >= scrollLeft) {
        popoverLeft -= scrollLeft;
        paddingLeft = scrollLeft;
      } else {
        popoverLeft -= marginLeft;
        paddingLeft = marginLeft;
      }

      this.headerPaddingLeft = paddingLeft;
      const styleObj = {
        left: `${popoverLeft}px`,
        top: `${toolbarHeight}px`
      };
      const props = {
        view: this.view,
        $scroll: this.$scroll,
        headerTableDOM: this.headerTableDOM,
        tableHeader: this.tableHeader,
        headerParentNode: this.headerParentNode,
        headerPaddingLeft: this.headerPaddingLeft
      };
      showPopoverUtil(this.headerBarPopover, styleObj, HeaderBar, props);
      this.isShowHeaderBar = true;
      this.headerParentNode.addEventListener("scroll", this.handleHeaderTableScroll);
    };

    this.hideHeaderBar = () => {
      hidePopoverUtil(this.headerBarPopover);
      this.isShowHeaderBar = false;
      this.headerParentNode && this.headerParentNode.removeEventListener("scroll", this.handleHeaderTableScroll);
    };

    this.handleHeaderTableScroll = () => {
      if (this.isShowHeaderBar && this.headerTableDOM) {
        const popoverDOM = document.querySelector(".ct-table-headerbar-popover");
        const wrapperDOM = popoverDOM.querySelector(".ct-table-wrapper");

        if (wrapperDOM) {
          const headerLeft = this.headerTableDOM.getBoundingClientRect().left;
          const scrollLeft = this.headerParentNode.scrollLeft;
          const marginLeft = parseInt(this.headerTableDOM.style.marginLeft, 10) || 0;
          let paddingLeft = 0;
          let popoverLeft = headerLeft + scrollLeft;

          if (marginLeft >= scrollLeft) {
            popoverLeft -= scrollLeft;
            paddingLeft = scrollLeft;
          } else {
            popoverLeft -= marginLeft;
            paddingLeft = marginLeft;
          }

          this.headerPaddingLeft = paddingLeft;
          popoverDOM.style.left = `${popoverLeft}px`;
          wrapperDOM.scrollLeft = scrollLeft;
        }
      }
    };

    this.cloneHeader = header => {
      const newHeader = header.cloneNode(true);
      const ctFrames = header.querySelectorAll(".ct-frame"); // 显示悬浮表头行的iframe内容

      Array.from(newHeader.querySelectorAll(".ct-frame")).forEach((frame, i) => {
        frame.onload = () => {
          frame.contentDocument.write(`<!doctype html>${ctFrames[i].contentDocument.documentElement.innerHTML}`);
        };
      });
      return newHeader;
    };

    this.showSelectBar = () => {
      const scrollLeft = this.parentNode.scrollLeft;
      let tableLeft = this.tableLeft;
      let paddingLeft = 0;

      if (this.tableMarginLeft >= scrollLeft) {
        tableLeft -= scrollLeft;
        paddingLeft = scrollLeft;
      } else {
        tableLeft -= this.tableMarginLeft;
        paddingLeft = this.tableMarginLeft;
      }

      this.colPaddingLeft = paddingLeft;
      const allStyleObj = {
        left: `${tableLeft - 18}px`,
        top: `${this.tableTop - 18}px`
      };
      const rowStyleObj = {
        left: `${tableLeft - 26}px`,
        top: `${this.tableTop}px`,
        height: `${this.tableHeight}px`
      };
      const colStyleObj = {
        left: `${tableLeft}px`,
        top: `${this.tableTop - 46}px`,
        width: `${this.containerWidth}px`
      };
      const allProps = {
        view: this.view,
        tablePos: this.tablePos,
        tableDOM: this.tableDOM,
        colDOMs: this.colDOMs,
        selectedRowArr: this.selectedRowArr,
        selectedColArr: this.selectedColArr,
        reShowPopover: this.reShowPopover
      };
      const rowProps = {
        store: this,
        view: this.view,
        tableDOM: this.tableDOM,
        parentNode: this.parentNode,
        tableWidth: this.tableWidth,
        selectedRowArr: this.selectedRowArr,
        reShowPopover: this.reShowPopover
      };
      const colProps = {
        store: this,
        view: this.view,
        tableDOM: this.tableDOM,
        parentNode: this.parentNode,
        containerWidth: this.containerWidth,
        tableMarginLeft: this.tableMarginLeft,
        colPaddingLeft: this.colPaddingLeft,
        selectedColArr: this.selectedColArr,
        reShowPopover: this.reShowPopover
      };
      showPopoverUtil(this.allSelectBarPopover, allStyleObj, ColSelectBar, allProps);
      showPopoverUtil(this.rowSelectBarPopover, rowStyleObj, RowSelectBar, rowProps);
      showPopoverUtil(this.colSelectBarPopover, colStyleObj, ColSelectBar$1, colProps);
      this.isShowSelectBar = true;
    };

    this.hideSelectBar = () => {
      hidePopoverUtil(this.allSelectBarPopover);
      hidePopoverUtil(this.rowSelectBarPopover);
      hidePopoverUtil(this.colSelectBarPopover);
      this.isShowSelectBar = false;
    };

    this.handleCellSelected = selection => {
      if (!this.tableDOM || this.cellSelection === selection) return;
      this.cellSelection = selection;
      setTimeout(() => {
        this.countSelected();

        if (this.view.state.selection instanceof CellSelection) {
          this.showSelectBar();
        }
      }, 0);
    };

    this.countSelected = () => {
      if (!this.tableDOM) return;
      const selectedCells = this.tableDOM.querySelectorAll(".selectedCell");
      const tableRowDOMs = Array.from(this.tableDOM.lastElementChild.children);
      const selectedRowArr = [];
      const selectedColArr = []; // 获取选中单元格左侧单元格总宽度和跨列信息

      const leftWidthSet = [];
      const colSpanMap = {}; // 获取选中单元格上方单元格总高度和跨列信息

      const offsetTopSet = new Set();
      const rowSpanMap = {};
      selectedCells.forEach(selectedCell => {
        const leftWidth = selectedCell.offsetLeft;
        const colSpan = selectedCell.colSpan;
        leftWidthSet.push(leftWidth);

        if (!colSpanMap[leftWidth] || colSpanMap[leftWidth] < colSpan) {
          colSpanMap[leftWidth] = colSpan;
        }

        const offsetTop = selectedCell.offsetTop;
        const rowSpan = selectedCell.rowSpan;
        offsetTopSet.add(offsetTop);

        if (!rowSpanMap[offsetTop] || rowSpanMap[offsetTop] < rowSpan) {
          rowSpanMap[offsetTop] = rowSpan;
        }
      });

      if (this.colDOMs.length === 0 || !this.colDOMs[0].style) {
        const rowDOM = tableRowDOMs[0];
        this.colDOMs = [];

        for (let i = 0; i < rowDOM.childElementCount; i++) {
          const cellDOM = rowDOM.children[i];
          const colspan = parseInt(cellDOM.getAttribute("colspan"), 10) || 1;
          const cellWidth = cellDOM.getBoundingClientRect().width / colspan;

          for (let j = 0; j < colspan; j++) {
            this.colDOMs.push({
              cellWidth
            });
          }
        }
      } // 设置对应选中的选择栏项


      let leftWidth = 0;
      this.colDOMs.forEach((col, idx) => {
        const colWidth = col.cellWidth || parseInt(col.style && col.style.width, 10);
        const selected = leftWidthSet.some(_ => {
          const dis = leftWidth - _;
          return dis > -5 && dis < 5;
        });
        if (selected) selectedColArr.push(idx); // 若该处跨列，则设置下一项也为高亮

        const colSpan = colSpanMap[leftWidth];
        leftWidth += colWidth;

        if (selected && colSpan > 1) {
          leftWidthSet.push(leftWidth);
          colSpanMap[leftWidth] = colSpan - 1;
        }
      }); // 设置对应选中的选择栏项

      let nextSelected = 0;
      tableRowDOMs.forEach((tr, idx) => {
        const offsetTop = tr.offsetTop;
        const selected = offsetTopSet.has(offsetTop) || nextSelected > 0;
        if (selected) selectedRowArr.push(idx); // 若该处跨列，则设置下一项也为高亮

        const rowSpan = rowSpanMap[offsetTop];

        if (selected && rowSpan - 1 > nextSelected) {
          nextSelected = rowSpan - 1;
        } else {
          nextSelected--;
        }
      });
      this.selectedRowArr = selectedRowArr;
      this.selectedColArr = selectedColArr;
    };

    this.addEvents = () => {
      this.removeEvents();
      this.$scroll.addEventListener("mousewheel", this.handleMouseWheel);
      window.addEventListener("resize", this.handlePageResize);
    };

    this.removeEvents = () => {
      this.$scroll.removeEventListener("mousewheel", this.handleMouseWheel);
      window.removeEventListener("resize", this.handlePageResize);
    };

    this.handleMouseWheel = e => {
      const isInSelectBar = e.target.classList.contains("visible");
      if (!isInSelectBar) return;
      let direct = 0;

      if (e.wheelDelta) {
        direct = e.wheelDelta > 0 ? 1 : -1;
      } else if (e.detail) {
        direct = e.detail > 0 ? 1 : -1;
      }

      if (direct !== 0) {
        if (direct === 1) {
          this.$scroll.scrollTop -= 8;
        } else {
          this.$scroll.scrollTop += 8;
        }
      }
    };

    this.handleTableScroll = () => {
      if (this.isShowPopover) {
        const {
          onTableScroll
        } = this.config;
        this.setTableRect();
        this.showSelectBar();
        this.checkGlobalTabel(false);
        if (onTableScroll) onTableScroll(this.core);
      }
    };

    this.handleTableWidthChange = dir => {
      if (!this.tableDOM) return;
      const preTableWith = this.tableWidth;

      if (dir === "right") {
        setTimeout(() => {
          this.parentNode.scrollLeft += this.tableWidth - preTableWith;
        }, 10);
      }

      this.setTableRect();
      this.showSelectBar();
    };

    this.handleTableHeightChange = () => {
      if (!this.tableDOM) return;
      this.tableHeightChanging = true;
      this.setTableRect();
      this.showSelectBar();
    };

    this.handlePageScroll = () => {
      this.checkGlobalTabel();

      if (this.tableHeightChanging) {
        this.tableHeightChanging = false;
        return;
      }

      if (this.isShowPopover) {
        this.setTableRect();
        this.showSelectBar();
      }
    };

    this.handlePageResize = () => {
      this.showPopover(this.tableDOM);
    };

    this.setTableRect = () => {
      if (!this.tableDOM) return this.hidePopover();
      const tableRect = this.tableDOM.getBoundingClientRect();
      this.tableMarginLeft = parseInt(this.tableDOM.style.marginLeft, 10) || 0;
      this.tableLeft = tableRect.left + this.parentNode.scrollLeft;
      this.tableTop = tableRect.top;
      this.tableBottom = window.innerHeight - tableRect.bottom;
      this.containerWidth = this.parentNode.clientWidth;
      this.tableHeight = tableRect.height;
      this.tableWidth = tableRect.width;
    };

    this.showModal = () => {
      const {
        state
      } = this.view;
      const {
        selection,
        schema
      } = state;
      const tableType = schema.nodes.table;
      const foundNode = index_js.findParentNode(selection.$from.path, node => node.type === tableType);
      if (!foundNode) return;
      const Component = preact.h(TableModal, _extends_1({
        store: this.editor
      }, foundNode.node.attrs, {
        setTableAttrs: attrs => this.setTableAttrs(objectSpread({}, foundNode.node.attrs, attrs), foundNode.pos),
        hideModal: this.hideModal
      }));
      preact.render(Component, this.modalPopover);
    };

    this.hideModal = () => {
      preact.render(null, this.modalPopover, this.modalPopover.lastChild);
    };

    this.setTableAttrs = (attrs, pos) => {
      const {
        state,
        dispatch
      } = this.view;
      const {
        tr
      } = state;
      tr.setNodeMarkup(pos, null, objectSpread({}, attrs));
      dispatch(tr);
      this.view.focus();
      this.showPopover(this.tableDOM);
    };

    this.config = config;
    this.showPopover = throttle(this.showPopover, 200);
  }

  init(editor) {
    this.editor = editor;
    this.core = editor.core;
    this.view = editor.view;
    this.$scroll = editor.$scroll;
    this.modules = editor.modules;
    this.getTopBias = editor.getTopBias;
    this.getBottomBias = editor.getBottomBias;

    if (this.$scroll.tagName === "HTML") {
      window.addEventListener("scroll", this.handlePageScroll);
    } else {
      this.$scroll.addEventListener("scroll", this.handlePageScroll);
    }
  }

  onCreatePopover(scrollBarPopover, headerBarPopover, rowSelectBarPopover, colSelectBarPopover, allSelectBarPopover, modalPopover) {
    this.scrollBarPopover = scrollBarPopover;
    this.headerBarPopover = headerBarPopover;
    this.rowSelectBarPopover = rowSelectBarPopover;
    this.colSelectBarPopover = colSelectBarPopover;
    this.allSelectBarPopover = allSelectBarPopover;
    this.modalPopover = modalPopover;
    setTimeout(this.checkGlobalTabel, 0);
  }

  onRemovePopover() {
    this.hidePopover();
    this.hideHeaderBar();
    this.hideScrollBar();

    if (this.$scroll.tagName === "HTML") {
      window.removeEventListener("scroll", this.handlePageScroll);
    } else {
      this.$scroll.removeEventListener("scroll", this.handlePageScroll);
    }
  } // 检查编辑器内所有表格


}

// () -> string

function uuid() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const id = [];

  for (let i = 0; i < 8; i++) {
    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
  }

  return id.join('');
}

const getWidthNumber = (width, tableWidth) => {
  if (typeof width === 'string') {
    // 兼容百分比宽度
    if (width.indexOf('%') !== -1) {
      return parseFloat(width) * 0.01 * tableWidth;
    }

    return parseInt(width, 10);
  }

  return width;
};
function getCellAttrs(dom) {
  const pmDOM = document.querySelector('.ProseMirror');
  let widthAttr = dom.getAttribute('data-colwidth');
  let tableWidth = pmDOM ? pmDOM.clientWidth : 0;
  const tableEl = dom.parentNode.parentNode.parentNode;
  const colgroupEl = tableEl.children[0];
  const index = Array.from(dom.parentNode.children).findIndex(el => el === dom);
  const col = colgroupEl.children[index];
  const colspan = parseFloat(dom.getAttribute('colspan') || 1);
  const rowspan = parseFloat(dom.getAttribute('rowspan') || 1);

  if (!widthAttr) {
    widthAttr = dom.width || dom.style.width || col && (col.width || col.style.width);
    tableWidth = getWidthNumber(tableEl.style.width, tableWidth);
  }

  let widths;

  if (widthAttr && widthAttr.split(',').length > colspan) {
    widths = [widthAttr.split(',').map(p => parseInt(p)).reduce((prev, cur) => prev + cur)];
  } else {
    widths = widthAttr ? widthAttr.split(',').map(w => getWidthNumber(w, tableWidth)) : [tableWidth / (colgroupEl.children[0] ? colgroupEl.children[0].children.length : 1)];
    widths = widths.map(num => num < 50 ? 50 : ~~num);
  }

  const widthsLen = widths.length;

  if (widthsLen < colspan) {
    const fillArr = new Array(colspan - widthsLen);
    fillArr.fill(50);
    widths = [...widths, ...fillArr];
  }

  if (window.devicePixelRatio === 1.25) {
    widths = widths.map(formatWidth);
  }

  const dataCellDiffId = dom.getAttribute('data-cell-diff-id');
  const result = {
    dataCellDiffId,
    colspan,
    rowspan,
    colwidth: widthsLen <= colspan ? widths : [50],
    bgColor: dom.style.backgroundColor,
    textAlign: dom.style.textAlign,
    verticalAlign: dom.style.verticalAlign,
    color: dom.style.color,
    numCell: dom.classList.contains('num-cell')
  };
  return result;
}
function setCellAttrs(node) {
  const attrs = {};
  const nodeAttrs = node.attrs;

  if (nodeAttrs.colspan !== 1) {
    attrs.colspan = nodeAttrs.colspan;
  }

  if (nodeAttrs.rowspan !== 1) {
    attrs.rowspan = nodeAttrs.rowspan;
  }

  if (nodeAttrs.colwidth) {
    attrs['data-colwidth'] = nodeAttrs.colwidth.join(',');
  } else {
    attrs['data-colwidth'] = '68';
  }

  attrs.width = attrs['data-colwidth'];
  let style = ''; // 检查单元格内是否有会溢出内容

  const textBlockNames = ['paragraph', 'heading'];

  if (node.content.content.some(child => {
    const typeName = child.type.name;
    if (child.type.spec.braceWidth) return true;
    if (textBlockNames.includes(typeName)) return child.content.content.some(_ => _.type.spec.braceWidth);
    return false;
  })) {
    attrs.class = 'overflow';
  }

  if (nodeAttrs.bgColor) style += `background-color: ${nodeAttrs.bgColor};`;
  if (nodeAttrs.color) style += `color: ${nodeAttrs.color};`;
  if (nodeAttrs.verticalAlign) style += `vertical-align:${nodeAttrs.verticalAlign};`;
  if (nodeAttrs.textAlign) style += `text-align:${nodeAttrs.textAlign};`;
  if (style) attrs.style = style;

  if (nodeAttrs.numCell) {
    attrs.contenteditable = true;
    attrs.style = 'caret-color: transparent';
    attrs.class = attrs.class ? `${attrs.class} num-cell` : 'num-cell';
  }

  attrs['data-cell-diff-id'] = nodeAttrs.dataCellDiffId || `ct-cell-diff-id-${uuid()}`;
  return attrs;
}
function getTableAttrs$1(dom) {
  const marginLeft = parseInt(dom.style.marginLeft, 10) / 20 || 0;
  const indent = marginLeft > 0 ? marginLeft : 0;
  const responsive = dom.classList.contains('responsive');
  const borderStyle = dom.getAttribute('data-borderstyle');
  const borderWidth = dom.getAttribute('data-borderwidth');
  const borderColor = dom.getAttribute('data-bordercolor');
  const dataDiffId = dom.getAttribute('data-diff-id');
  return {
    indent,
    responsive,
    borderStyle,
    borderWidth,
    borderColor,
    dataDiffId
  };
}
function setTableAttrs(node) {
  const attrs = {};
  const {
    indent,
    responsive,
    borderStyle,
    borderWidth,
    borderColor,
    dataDiffId
  } = node.attrs;
  if (indent > 0) attrs.style = `margin-left: ${indent * 20}px;`;
  if (responsive) attrs.class = 'responsive';
  if (borderStyle !== 'solid') attrs['data-borderstyle'] = borderStyle;
  if (borderWidth !== 1) attrs['data-borderwidth'] = borderWidth;
  if (borderColor !== '#dddddd') attrs['data-bordercolor'] = borderColor;
  attrs['data-diff-id'] = dataDiffId || `ct-diff-id-${uuid()}`;
  return attrs;
}

const cellAttrs = {
  colspan: {
    default: 1
  },
  rowspan: {
    default: 1
  },
  colwidth: {
    default: [68]
  },
  textAlign: {
    default: null
  },
  verticalAlign: {
    default: null
  },
  bgColor: {
    default: null
  },
  color: {
    default: null
  },
  numCell: {
    default: null
  },
  // 行号格
  dataCellDiffId: {
    default: null
  }
};
var schema = {
  nodes: {
    table: {
      content: 'table_row+',
      tableRole: 'table',
      isolating: true,
      allowGapCursor: true,
      insertBlock: true,
      group: 'block',
      attrs: {
        indent: {
          default: 0
        },
        responsive: {
          default: false
        },
        borderStyle: {
          default: 'solid'
        },
        borderWidth: {
          default: 1
        },
        borderColor: {
          default: '#cccccc'
        },
        dataDiffId: {
          default: null
        }
      },
      parseDOM: [{
        tag: 'table',
        getAttrs: getTableAttrs$1
      }],

      toDOM(node) {
        return ['table', setTableAttrs(node), ['tbody', 0]];
      }

    },
    table_row: {
      content: '(table_cell | table_header)*',
      tableRole: 'row',
      attrs: {
        dataRowDiffId: {
          default: null
        }
      },
      parseDOM: [{
        tag: 'tr',

        getAttrs(dom) {
          const dataRowDiffId = dom.getAttribute('data-row-diff-id');
          return {
            dataRowDiffId
          };
        }

      }],

      toDOM(dom) {
        const attrs = {};
        const {
          attrs: {
            dataRowDiffId
          }
        } = dom;
        attrs['data-row-diff-id'] = dataRowDiffId || `ct-tr-diff-id-${uuid()}`;
        return ['tr', attrs, 0];
      }

    },
    table_cell: {
      content: 'block+',
      attrs: cellAttrs,
      tableRole: 'cell',
      isolating: true,
      parseDOM: [{
        tag: 'td',

        getAttrs(dom) {
          return getCellAttrs(dom);
        }

      }],

      toDOM(node) {
        return ['td', setCellAttrs(node), 0];
      }

    },
    table_header: {
      content: 'block+',
      attrs: cellAttrs,
      tableRole: 'header_cell',
      isolating: true,
      parseDOM: [{
        tag: 'th',

        getAttrs(dom) {
          return getCellAttrs(dom);
        }

      }],

      toDOM(node) {
        return ['th', setCellAttrs(node), 0];
      }

    }
  }
};

const dfsTable = (content, nodeTypes, depth) => {
  const {
    table
  } = nodeTypes;

  for (let i = 0; i < content.length; i++) {
    const node = content[i];

    if (node.type === table) {
      processTable(node, nodeTypes);
    } else if (depth < 3) {
      const nodeContent = node.content.content;

      if (nodeContent.length > 0) {
        dfsTable(nodeContent, nodeTypes, depth + 1);
      }
    }
  }
}; // 表格粘贴到表格中时新单元格处理

const processCell = (sliceNode, tableNode, rowNode, cellNode, table_cell, table_header) => {
  let hasRowHeader = false;
  let hasColHeader = false;
  const rowNodes = tableNode.content.content;
  const cellNodes = rowNode.content.content;
  const rowIndex = rowNodes.indexOf(rowNode);
  const colIndex = cellNodes.indexOf(cellNode);
  const sliceContent = sliceNode.content.content;

  if (cellNode.type === table_header) {
    if (colIndex === cellNodes.length - 1) {
      hasRowHeader = true;
    } else {
      const cell = cellNodes[colIndex + 1];
      if (cell && cell.type === table_header) hasRowHeader = true;
    }

    if (rowIndex === rowNodes.length - 1) {
      hasColHeader = true;
    } else {
      const cell = rowNodes[rowIndex + 1].content.content[colIndex];
      if (cell && cell.type === table_header) hasColHeader = true;
    }
  }

  let type = hasRowHeader ? table_header : table_cell;
  const rowContent = sliceContent[0].content.content;

  for (let j = 0; j < rowContent.length; j++) {
    const cell = rowContent[j];
    const cellContent = cell.content.content;

    if (cell.type !== type) {
      rowContent[j] = type.create(cell.attrs, cellContent, cell.marks);
    }
  }

  type = hasColHeader ? table_header : table_cell;

  for (let i = 0; i < sliceContent.length; i++) {
    const rowContent = sliceContent[i].content.content;
    const cell = rowContent[0];

    if (cell && cell.type !== type && !(type !== table_header && i === 0)) {
      const cellContent = cell.content.content;
      rowContent[0] = type.create(cell.attrs, cellContent, cell.marks);
    }
  }
}; // 处理表格

const processTable = (tableNode, nodeTypes) => {
  const {
    table,
    table_cell,
    table_header,
    paragraph
  } = nodeTypes;
  const tableContent = tableNode.content.content;
  const {
    headerCol
  } = getHasColHeader(tableContent, table_header);
  const firstRowContent = tableContent[0].content.content;

  for (let j = 0; j < firstRowContent.length; j++) {
    const cell = firstRowContent[j];
    let cellContent = cell.content.content;
    const isEmpty = cellContent.length <= 0;

    if (!isEmpty) {
      for (let k = 0; k < cellContent.length; k++) {
        if (cellContent[k].type === table) {
          processTable(cellContent[k], nodeTypes);
        }
      }
    } else {
      // 处理空内容
      cellContent = paragraph.create();
    }

    firstRowContent[j] = cell.type.create(cell.attrs, cellContent, cell.marks);
  }

  for (let i = 0; i < tableContent.length; i++) {
    const rowContent = tableContent[i].content.content;

    for (let j = 0; j < rowContent.length; j++) {
      const cell = rowContent[j];
      let cellContent = cell.content.content;
      const isEmpty = cellContent.length <= 0;

      if (!isEmpty) {
        for (let k = 0; k < cellContent.length; k++) {
          if (cellContent[k].type === table) {
            processTable(cellContent[k], nodeTypes);
          }
        }
      } else {
        // 处理空内容
        cellContent = paragraph.create();
      } // 移除第一行和第一列外的th


      if (cell.type === table_header && i > 0 && j !== headerCol || isEmpty) {
        rowContent[j] = table_cell.create(objectSpread({}, cell.attrs, {
          bgColor: '#f6f6f6'
        }), cellContent, cell.marks);
      }
    }
  }
};

// : (Slice) → ?{width: number, height: number, rows: [Fragment]}
// Get a rectangular area of cells from a slice, or null if the outer
// nodes of the slice aren't table cells or rows.

function pastedCells(slice) {
  if (!slice.size) return null;
  let {
    content,
    openStart,
    openEnd
  } = slice;

  while (content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')) {
    openStart--;
    openEnd--;
    content = content.firstChild.content;
  }

  let first = content.firstChild,
      role = first.type.spec.tableRole;
  let schema = first.type.schema,
      rows = [];
  const table_row = schema.nodes.table_row;

  if (role === 'row') {
    for (let i = 0; i < content.childCount; i++) {
      let cells = content.child(i).content;
      const left = i ? 0 : Math.max(0, openStart - 1);
      const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
      if (left || right) cells = fitSlice(table_row, new prosemirrorModel.Slice(cells, left, right)).content;
      rows.push(cells);
    }
  } else if (role === 'cell' || role === 'header_cell') {
    rows.push(openStart || openEnd ? fitSlice(table_row, new prosemirrorModel.Slice(content, openStart, openEnd)).content : content);
  } else {
    return null;
  } // 去除行号


  rows.forEach(row => {
    const rowContent = row.content;
    rowContent.forEach((cell, i) => {
      if (cell.attrs.numCell) rowContent[i] = cell.type.create(objectSpread({}, cell.attrs, {
        numCell: false
      }), cell.content);
    });
  });
  return ensureRectangular(schema, rows);
} // : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.

function ensureRectangular(schema, rows) {
  const {
    table_cell
  } = schema.nodes;
  const widths = [];

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];

    for (let j = row.childCount - 1; j >= 0; j--) {
      const {
        rowspan,
        colspan
      } = row.child(j).attrs;

      for (let r = i; r < i + rowspan; r++) {
        widths[r] = (widths[r] || 0) + colspan;
      }
    }
  }

  let width = 0;

  for (let r = 0; r < widths.length; r++) width = Math.max(width, widths[r]);

  for (let r = 0; r < widths.length; r++) {
    if (r >= rows.length) rows.push(prosemirrorModel.Fragment.empty);

    if (widths[r] < width) {
      let empty = table_cell.createAndFill(),
          cells = [];

      for (let i = widths[r]; i < width; i++) cells.push(empty);

      rows[r] = rows[r].append(prosemirrorModel.Fragment.from(cells));
    }
  }

  return {
    height: rows.length,
    width,
    rows
  };
}

function fitSlice(nodeType, slice) {
  const node = nodeType.createAndFill();
  const tr = new prosemirrorTransform.Transform(node).replace(0, node.content.size, slice);
  return tr.doc;
} // : ({width: number, height: number, rows: [Fragment]}, number, number) → {width: number, height: number, rows: [Fragment]}
// Clip or extend (repeat) the given set of cells to cover the given
// width and height. Will clip rowspan/colspan cells at the edges when
// they stick out.

function clipCells({
  width,
  height,
  rows
}, newWidth, newHeight) {
  if (width != newWidth) {
    let added = [],
        newRows = [];

    for (let row = 0; row < rows.length; row++) {
      let frag = rows[row],
          cells = [];

      for (let col = added[row] || 0, i = 0; col < newWidth; i++) {
        let cell = frag.child(i % frag.childCount);

        if (col + cell.attrs.colspan > newWidth) {
          cell = cell.type.create(rmColspan(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
        }

        cells.push(cell);
        col += cell.attrs.colspan;

        for (let j = 1; j < cell.attrs.rowspan; j++) {
          added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
        }
      }

      newRows.push(prosemirrorModel.Fragment.from(cells));
    }

    rows = newRows;
    width = newWidth;
  }

  if (height != newHeight) {
    const newRows = [];

    for (let row = 0, i = 0; row < newHeight; row++, i++) {
      let cells = [],
          source = rows[i % height];

      for (let j = 0; j < source.childCount; j++) {
        let cell = source.child(j);

        if (row + cell.attrs.rowspan > newHeight) {
          cell = cell.type.create(setAttr(cell.attrs, 'rowspan', newHeight - cell.attrs.rowspan), cell.content);
        }

        cells.push(cell);
      }

      newRows.push(prosemirrorModel.Fragment.from(cells));
    }

    rows = newRows;
    height = newHeight;
  }

  return {
    width,
    height,
    rows
  };
} // Make sure a table has at least the given width and height. Return
// true if something was changed.

function growTable(tr, map, table, start, width, height, mapFrom) {
  let schema = tr.doc.type.schema,
      empty,
      emptyHead;
  const {
    table_cell,
    table_header,
    table_row
  } = schema.nodes;

  if (width > map.width) {
    for (let row = 0, rowEnd = 0; row < map.height; row++) {
      const rowNode = table.child(row);
      rowEnd += rowNode.nodeSize;
      let cells = [],
          add;

      if (rowNode.lastChild === null || rowNode.lastChild.type === table_cell) {
        add = empty || (empty = table_cell.createAndFill());
      } else {
        add = emptyHead || (emptyHead = table_header.createAndFill());
      }

      for (let i = map.width; i < width; i++) cells.push(add);

      tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
  }

  if (height > map.height) {
    const cells = [];

    for (let i = 0, start = (map.height - 1) * map.width; i < Math.max(map.width, width); i++) {
      let cell;

      if (i >= map.width) {
        cell = table_cell.createAndFill();
      } else {
        const mapCell = table.nodeAt(map.map[start + i]);
        const header = i >= map.width ? false : mapCell.type === table_header;
        cell = header ? table_header.createAndFill({
          numCell: mapCell.attrs.numCell
        }) : table_cell.createAndFill({
          numCell: mapCell.attrs.numCell
        });
      }

      cells.push(cell);
    }

    let emptyRow = table_row.create(null, prosemirrorModel.Fragment.from(cells)),
        rows = [];

    for (let i = map.height; i < height; i++) rows.push(emptyRow);

    tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    return true;
  }

  return !!(empty || emptyHead);
} // Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.


function isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
  if (top === 0 || top === map.height) return false;
  let found = false;

  for (let col = left; col < right; col++) {
    let index = top * map.width + col,
        pos = map.map[index];

    if (map.map[index - map.width] === pos) {
      found = true;
      const cell = table.nodeAt(pos);
      const {
        top: cellTop,
        left: cellLeft
      } = map.findCell(pos);
      tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), null, setAttr(cell.attrs, 'rowspan', top - cellTop));
      tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), cell.type.createAndFill(setAttr(cell.attrs, 'rowspan', cellTop + cell.attrs.rowspan - top)));
      col += cell.attrs.colspan - 1;
    }
  }

  return found;
} // Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.


function isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
  if (left === 0 || left === map.width) return false;
  let found = false;

  for (let row = top; row < bottom; row++) {
    let index = row * map.width + left,
        pos = map.map[index];

    if (map.map[index - 1] === pos) {
      found = true;
      let cell = table.nodeAt(pos),
          cellLeft = map.colCount(pos);
      const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
      tr.setNodeMarkup(updatePos, null, rmColspan(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
      tr.insert(updatePos + cell.nodeSize, cell.type.createAndFill(rmColspan(cell.attrs, 0, left - cellLeft)));
      row += cell.attrs.rowspan - 1;
    }
  }

  return found;
} // Insert the given set of cells (as returned by `pastedCells`) into a
// table, at the position pointed at by rect.


function insertCells(state, dispatch, tableStart, rect, cells, store) {
  let table = tableStart ? state.doc.nodeAt(tableStart - 1) : state.doc;
  let map = TableMap.get(table);
  const {
    top,
    left
  } = rect;
  const right = left + cells.width;
  const bottom = top + cells.height;
  const tr = state.tr;
  let mapFrom = 0;
  let hasExtraWidth = false;
  const initMap = map;

  function recomp() {
    table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;

    if (!table) {
      store.emitTableError('不能仅改变合并单元格的一部分'); // Toastr.error('不能仅改变合并单元格的一部分')

      return false;
    }

    map = TableMap.get(table);
    mapFrom = tr.mapping.maps.length;
    return true;
  } // Prepare the table to be large enough and not have any cells
  // crossing the boundaries of the rectangle that we want to
  // insert into. If anything about it changes, recompute the table
  // map so that subsequent operations can see the current shape.


  if (growTable(tr, map, table, tableStart, right, bottom, mapFrom)) {
    if (!recomp()) {
      return;
    }
  }

  if (isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) {
    hasExtraWidth = true;

    if (!recomp()) {
      return;
    }
  }

  if (isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) {
    hasExtraWidth = true;

    if (!recomp()) {
      return;
    }
  }

  if (isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) {
    if (!recomp()) {
      return;
    }
  }

  if (isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) {
    if (!recomp()) {
      return;
    }
  }

  if (map.width - initMap.width > 0 && hasExtraWidth) {
    // Toastr.error('不能仅改变合并单元格的一部分')
    store.emitTableError('不能仅改变合并单元格的一部分');
    return;
  }

  let count = 0;

  for (let row = top; row < bottom; row++) {
    const from = map.positionAt(row, left, table);
    const to = map.positionAt(row, right, table);
    let slice = new prosemirrorModel.Slice(cells.rows[row - top], 1, 1);
    const ids = [];
    tr.doc.nodesBetween(from + tableStart + count, to + tableStart + count, node => {
      if (['table_cell', 'table_header'].includes(node.type.name) && node.attrs.dataCellDiffId) {
        ids.push(node.attrs.dataCellDiffId);
      }
    });
    count += 4;

    if (slice.size > 0) {
      slice.content.content.forEach((p, index) => {
        p.attrs.dataCellDiffId = ids[index] || p.attrs.dataCellDiffId;
      });
      tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), slice);
    } else {
      tr.delete(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart));
    }
  }

  if (map.width - initMap.width === 0 && !hasExtraWidth) {
    recomp();
    let cellCount = 0;
    cells.rows.forEach(f => cellCount += f.childCount);

    if (cellCount === 1) {
      tr.setSelection(new CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table))));
    } else {
      tr.setSelection(new CellSelection(tr.doc.resolve(tableStart + map.positionAt(top, left, table)), tr.doc.resolve(tableStart + map.positionAt(bottom - 1, right - 1, table))));
    }
  } // 防止光标跳到行号格中


  const cellNode = tr.selection.$from.node(-1);

  if (cellNode.attrs.numCell === true) {
    tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, tr.selection.from - 6));
  }

  dispatch(tr);
}

const transformPasted = store => slice => {
  const {
    state
  } = store.view;
  const {
    schema,
    selection
  } = state;
  const {
    table,
    table_row,
    table_cell,
    table_header
  } = schema.nodes;
  const sliceContent = slice.content.content;
  let sliceNode = sliceContent.length === 1 ? sliceContent[0] : null; // 单独粘贴表格

  if (sliceNode) {
    // 全选单元格粘贴
    if (sliceNode.type !== table && selection instanceof CellSelection) {
      const cellNode = table_cell.create({
        colwidth: [68]
      }, sliceNode);
      const rowNode = table_row.create(null, prosemirrorModel.Fragment.from(cellNode));
      sliceNode = table.create(null, prosemirrorModel.Fragment.from(rowNode));
      sliceContent[0] = sliceNode;
    } // 表格中粘贴


    if (sliceNode.type === table) {
      let {
        $from
      } = selection; // 多个单元格选中时取最前面的单元格

      if (selection instanceof CellSelection) {
        let minPos = Infinity;
        selection.ranges.forEach(range => {
          const pos = range.$from.pos;

          if (pos < minPos) {
            minPos = pos;
            $from = range.$from;
          }
        });
      }

      const foundTable = index_js.findParentNode($from.path, node => node.type === table); // 表格中粘贴表格处理单元格转换

      if (foundTable) {
        const tableNode = foundTable.node;
        const rowNode = index_js.findParentNode($from.path, node => node.type === table_row).node;
        const cellNode = index_js.findParentNode($from.path, node => [table_cell, table_header].includes(node.type)).node;
        processCell(sliceNode, tableNode, rowNode, cellNode, table_cell, table_header);
      } else {
        // 处理粘贴表格时第一个单元格跳出问题
        slice.openStart = 0;
        slice.openEnd = 0;
      }
    } else if (sliceNode.type.isAtom) {
      slice.openStart = 0;
      slice.openEnd = 0;
    }
  }

  dfsTable(sliceContent, schema.nodes, 0);
  return slice;
};

var css$6 = ".ct-editor-popover{display:none;position:fixed;top:auto;left:auto;right:auto;bottom:auto;z-index:19;background:#fff;box-shadow:0 4px 16px 0 rgba(106,93,73,.2),0 8px 20px 0 rgba(106,93,73,.1);border-radius:1px;opacity:1;transition:opacity .2s ease}div.ct-table-headerbar-popover{box-shadow:none;border-radius:none;background:transparent;z-index:99}div.ct-table-scrollbar-popover{z-index:19}div.ct-table-all-selectbar-popover,div.ct-table-col-selectbar-popover,div.ct-table-row-selectbar-popover{z-index:2;box-shadow:none;background:transparent}div.ct-table-all-selectbar-popover{z-index:3;width:18px;height:18px}div.ct-table-row-selectbar-popover{width:26px}div.ct-table-col-selectbar-popover{height:26px;pointer-events:none}";
styleInject(css$6);

class Popover$1 {
  constructor(view, store) {
    this.store = store;
    const viewParentNode = view.dom.parentNode;
    this.scrollBarPopover = document.createElement('div');
    this.scrollBarPopover.className = 'ct-table-scrollbar-popover ct-editor-popover';
    this.headerBarPopover = document.createElement('div');
    this.headerBarPopover.className = 'ct-table-headerbar-popover ct-editor-popover';
    this.rowSelectBarPopover = document.createElement('div');
    this.rowSelectBarPopover.className = 'ct-table-row-selectbar-popover ct-editor-popover';
    this.colSelectBarPopover = document.createElement('div');
    this.colSelectBarPopover.className = 'ct-table-col-selectbar-popover ct-editor-popover';
    this.allSelectBarPopover = document.createElement('div');
    this.allSelectBarPopover.className = 'ct-table-all-selectbar-popover ct-editor-popover';
    this.modalPopover = document.createElement('div');
    this.modalPopover.className = 'ct-table-modal-popover ct-editor-popover';

    if (viewParentNode) {
      viewParentNode.appendChild(this.scrollBarPopover);
      viewParentNode.appendChild(this.headerBarPopover);
      viewParentNode.appendChild(this.rowSelectBarPopover);
      viewParentNode.appendChild(this.colSelectBarPopover);
      viewParentNode.appendChild(this.allSelectBarPopover);
      viewParentNode.appendChild(this.modalPopover);
      this.store.onCreatePopover(this.scrollBarPopover, this.headerBarPopover, this.rowSelectBarPopover, this.colSelectBarPopover, this.allSelectBarPopover, this.modalPopover);
    }

    if (this.store.editor) {
      this.store.init(this.store.editor);
    }
  }

  destroy() {
    this.allSelectBarPopover.remove();
    this.scrollBarPopover.remove();
    this.headerBarPopover.remove();
    this.rowSelectBarPopover.remove();
    this.colSelectBarPopover.remove();
    this.modalPopover.remove();
    this.store.onRemovePopover();
  } // 全选表格位置变化时更新弹窗


  update(view) {
    if (!this.store.isShowPopover) return;
    const selection = view.state.selection;

    if (isAllCellSelection(selection)) {
      const foundNode = index_js.findParentNode(selection.$from.path, item => item.type && item.type.name === 'table');
      let tableDOM = view.docView.domFromPos(foundNode.pos + 1).node;
      if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
      this.store.showPopover(tableDOM);
    }
  }

}

const handleMouseEvent = (store, view, e) => {
  const target = e.target;

  const domAssert = dom => dom.tagName.toUpperCase() === 'TABLE';

  const dom = index_js.findParentDOM(target, domAssert);

  if (dom) {
    store.showPopover(dom);
    setTimeout(() => {
      store.countSelected();
      store.showSelectBar();
    }, 1);
  } else if (store.isShowPopover) {
    store.hidePopover();
  }
};

const handleKeyEvent = (store, view) => {
  const {
    schema,
    selection
  } = view.state;
  const {
    $from
  } = selection;
  const table = schema.nodes.table;
  const foundNode = index_js.findParentNode($from.path, node => node.type === table);

  if (foundNode) {
    let tableDOM = view.docView.domFromPos(foundNode.pos + 1).node;
    if (tableDOM.tagName.toUpperCase() !== 'TABLE') tableDOM = tableDOM.parentNode;
    store.showPopover(tableDOM);
  } else if (store.isShowPopover) {
    store.hidePopover();
  }
};

function createPlugin(store) {
  const pluginKey = new prosemirrorState.PluginKey('table');
  return new prosemirrorState.Plugin({
    key: pluginKey,
    state: {
      init() {
        return 0;
      },

      apply(tr, value, oldState, newState) {
        const {
          selection
        } = newState;

        if (isAllCellSelection(selection)) {
          store.isShowPopover = true;
        }

        store.checkGlobalTabel();
      }

    },
    props: {
      decorations: state => {
        const {
          selection
        } = state;
        const {
          $from
        } = selection;

        if (selection instanceof CellSelection) {
          store.handleCellSelected(selection); // 表格选中区域描边

          const rows = selection.content().content.content;
          const rowsLen = rows.length;
          const topBorderCells = rows[0].content.content;
          const bottomBorderCells = [];
          const leftBorderCells = [];
          const rightBorderCells = [];
          const ignoreLeftRow = [];
          rows.forEach((row, i) => {
            const cells = row.content.content;
            const cellsLen = cells.length;
            cells.forEach((cell, j) => {
              if (i === rowsLen - 1 || i + cell.attrs.rowspan === rowsLen) {
                bottomBorderCells.push(cell);
              }

              if (j === 0 && !ignoreLeftRow.includes(i)) {
                leftBorderCells.push(cell);
                let rowspan = cell.attrs.rowspan - 1;

                while (rowspan > 0) {
                  ignoreLeftRow.push(i + rowspan);
                  rowspan--;
                }
              }

              if (j === cellsLen - 1 && !rightBorderCells.some(borderCell => borderCell.rowspan + borderCell.row > i)) {
                rightBorderCells.push({
                  cell,
                  row: i,
                  rowspan: cell.attrs.rowspan
                });
              }
            });
          });
          const borderCells = [];
          selection.forEachCell((node, pos) => {
            let className = '';
            if (topBorderCells.includes(node)) className += ' top';
            if (bottomBorderCells.includes(node)) className += ' bottom';
            if (leftBorderCells.includes(node)) className += ' left';
            if (rightBorderCells.some(borderCell => borderCell.cell === node)) className += ' right';
            if (className !== '') borderCells.push(prosemirrorView.Decoration.node(pos, pos + node.nodeSize, {
              class: className.trim()
            }));
          });
          return prosemirrorView.DecorationSet.create(state.doc, borderCells);
        }

        const table = index_js.findParentNode($from.path, item => item.type && item.type.name === "table");

        if (table) {
          const attrs = {
            class: "ct-table-show"
          };
          const deco = prosemirrorView.Decoration.node(table.pos, table.pos + table.node.nodeSize, attrs);
          return prosemirrorView.DecorationSet.create(state.doc, [deco]);
        }

        store.handleCellSelected(null);
        return null;
      },
      handleClick: (view, pos) => {
        const {
          tr,
          schema,
          doc,
          selection
        } = view.state;

        if (selection instanceof CellSelection) {
          const {
            table_header,
            table_cell
          } = schema.nodes;
          const cellTypes = [table_header, table_cell];
          const foundNode = index_js.findParentNode(selection.$from.path, node => cellTypes.includes(node.type));
          if (!foundNode) return false;
          view.dispatch(tr.setSelection(prosemirrorState.TextSelection.create(doc, pos)));
        }
      },
      handlePaste: view => {
        setTimeout(() => triggerTableCellToDOM(view), 0);
      },
      transformPasted: transformPasted(store),
      afterPasted: triggerTableCellToDOM,
      afterDrop: (view, pos) => {
        triggerTableCellToDOM(view); // 解决拖拽到文档第一行时滚动条位置错误

        if (pos === 0) store.$scroll.scrollTop = 0;
        handleKeyEvent(store, view);
      },
      handleDOMEvents: {
        drop: view => {
          store.hidePopover();
          setTimeout(() => triggerTableCellToDOM(view), 0);
        },
        mousedown: (view, e) => handleMouseEvent(store, view, e),
        contextmenu: (view, e) => handleMouseEvent(store, view, e),
        keyup: view => handleKeyEvent(store, view),
        keydown: () => store.reShowPopover(),
        cut: view => {
          const {
            selection
          } = view.state;

          if (selection instanceof CellSelection) {
            if (isAllCellSelection(selection)) {
              const {
                $anchorCell
              } = selection;
              const tablePos = $anchorCell.before(-1);
              store.hidePopover();
              setTimeout(() => {
                const {
                  dispatch,
                  state: {
                    doc,
                    tr
                  }
                } = view;
                const tableSize = doc.nodeAt(tablePos).nodeSize;
                const selection = prosemirrorState.TextSelection.create(doc, tablePos, tablePos + tableSize);
                dispatch(tr.setSelection(selection).deleteSelection());
              }, 0);
            }
          }
        }
      }
    },

    view(editorView) {
      return new Popover$1(editorView, store);
    }

  });
}

function isInList(state) {
  if (!state) return false;
  const {
    $from,
    $to
  } = state.selection;
  const range = $from.blockRange($to);
  if (!range) return false;
  const {
    bullet_list,
    ordered_list,
    task_list
  } = state.schema.nodes;
  const listTypes = [bullet_list, ordered_list, task_list];
  const depth0Node = $from.node(range.depth);
  const depth1Node = $from.node(range.depth - 1);
  const depth1NodeType = depth1Node && depth1Node.type;
  const depth0NodeType = depth0Node && depth0Node.type;
  return listTypes.some(type => type === depth1NodeType || type === depth0NodeType);
} // :: (NodeType, ?Object) → (state: EditorState, dispatch: ?(tr: Transaction)) → bool

const goToNextCell1 = goToNextCell(1);
const goToPreCell = goToNextCell(-1); // Tab键前进到下一格

function handleTab(store) {
  return function (state, dispatch, view) {
    const {
      selection,
      schema
    } = state;
    if (isInList(state)) return false;
    if (increaseIndent()(state, dispatch, view)) return true;
    if (!isInTable(state)) return false;
    if (goToNextCell1(state, dispatch, view)) return true;
    const {
      table_cell,
      table_header
    } = schema.nodes;
    const cellTypes = [table_cell, table_header];
    const rect = selectedRect(state);
    if (!rect) return false;
    let transaction = addRow(state.tr, rect, rect.bottom);
    const foundNode = index_js.findParentNode(selection.$from.path, node => cellTypes.includes(node.type));
    transaction = transaction.setSelection(prosemirrorState.TextSelection.create(transaction.doc, foundNode.pos + foundNode.node.nodeSize + 3));
    dispatch(transaction);
    return true;
  };
} // Shift+Tab键前进到上一格

function handleShiftTab(store) {
  return function (state, dispatch, view) {
    if (isInList(state)) return false;
    if (reduceIndent()(state, dispatch, view)) return true;
    if (!isInTable(state)) return false;
    return goToPreCell(state, dispatch, view);
  };
} // 向前删除动作处理

function handleBackspace(store) {
  return function (state, dispatch, view) {
    const {
      tr,
      selection,
      schema
    } = state;
    const {
      table_cell,
      table_header
    } = schema.nodes;
    const {
      $from,
      $to,
      from,
      to
    } = selection;
    const cellTypes = [table_cell, table_header]; // 选中全表格删除

    if (selection instanceof CellSelection) {
      store.hidePopover();

      if (deleteWholeTable(selection, tr, dispatch)) {
        return true;
      }

      store.showPopover();
    }

    const foundNode = index_js.findParentNode($from.path, node => cellTypes.includes(node.type));
    if (!foundNode) return false; // 行首虚拟光标

    if (selection instanceof index_js$2.GapCursor && $from.parentOffset === 0) {
      // 非第一行
      if (from - foundNode.pos > 2) {
        dispatch(tr.delete(from - 2, from));
      }

      return true;
    } // 三击全选文字时候删除


    if ($from.parent !== $to.parent && $to.parentOffset === 0) {
      dispatch(tr.delete(from, to - 4));
      return true;
    }

    return false;
  };
} // 向后删除动作处理
// export function handleDelete (state, dispatch, view) {
//   const { tr, selection } = state
//   if (selection instanceof CellSelection && deleteWholeTable(selection, tr, dispatch)) {
//     return true
//   }
// }
// 全选表格时进行删除

function deleteWholeTable(selection, tr, dispatch) {
  const {
    $from,
    $anchorCell,
    $headCell
  } = selection;
  const tableNode = index_js.findParentNode($from.path, item => item.type && item.type.name === 'table').node;

  if (isAllCellSelection(selection)) {
    const $firstCell = $anchorCell.pos < $headCell.pos ? $anchorCell : $headCell;
    const pos = $firstCell.pos - 2;
    tr.delete(pos, pos + tableNode.nodeSize);

    if (tr.doc.nodeSize > pos + 2) {
      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos + 1));
    } else {
      tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, pos));
    }

    if (dispatch) {
      dispatch(tr);
      return true;
    }

    return tr;
  }

  return false;
}

// This file defines a number of helpers for wiring up user input to
const handleKeyDown = keymap.keydownHandler({
  ArrowLeft: arrow('horiz', -1),
  ArrowRight: arrow('horiz', 1),
  ArrowUp: arrow('vert', -1),
  ArrowDown: arrow('vert', 1),
  'Shift-ArrowLeft': shiftArrow('horiz', -1),
  'Shift-ArrowRight': shiftArrow('horiz', 1),
  'Shift-ArrowUp': shiftArrow('vert', -1),
  'Shift-ArrowDown': shiftArrow('vert', 1),
  Backspace: deleteCellSelection,
  'Mod-Backspace': deleteCellSelection,
  Delete: deleteCellSelection,
  'Mod-Delete': deleteCellSelection
});

function arrow(axis, dir) {
  return (state, dispatch, view) => {
    const {
      table
    } = state.schema.nodes;
    const sel = state.selection;

    if (sel instanceof CellSelection) {
      dispatch(state.tr.setSelection(prosemirrorState.Selection.near(sel.$headCell, dir)));
      return true;
    }

    const foundNode = index_js.findParentNode(sel.$from.path, node => node.type === table);
    if (!foundNode) return false;

    if (axis === 'horiz') {
      const newPos = sel.head + dir;

      if (foundNode.pos + 4 > newPos) {
        dispatch(state.tr.setSelection(new index_js$2.GapCursor(state.doc.resolve(foundNode.pos))));
        return true;
      }
    }

    if (axis != 'horiz' && !sel.empty) return false;
    const end = atEndOfCell(view, axis, dir);
    if (end == null) return false;

    if (axis === 'horiz') {
      dispatch(state.tr.setSelection(prosemirrorState.Selection.near(state.doc.resolve(sel.head + dir), dir)));
      return true;
    }

    let $cell = state.doc.resolve(end),
        $next = nextCell($cell, axis, dir),
        newSel;
    if ($next) newSel = prosemirrorState.Selection.near($next, 1);else if (dir < 0) newSel = prosemirrorState.Selection.near(state.doc.resolve($cell.before(-1)), -1);else newSel = prosemirrorState.Selection.near(state.doc.resolve($cell.after(-1)), 1);
    dispatch(state.tr.setSelection(newSel));
    return true;
  };
}

function shiftArrow(axis, dir) {
  return (state, dispatch, view) => {
    let sel = state.selection;

    if (!(sel instanceof CellSelection)) {
      const end = atEndOfCell(view, axis, dir);
      if (end == null) return false;
      sel = new CellSelection(state.doc.resolve(end));
    }

    const $head = nextCell(sel.$headCell, axis, dir);
    if (!$head) return false;
    if (dispatch) dispatch(state.tr.setSelection(new CellSelection(sel.$anchorCell, $head)));
    return true;
  };
}

function deleteCellSelection(state, dispatch) {
  const sel = state.selection;
  if (!(sel instanceof CellSelection)) return false;

  if (dispatch) {
    let tr = state.tr,
        baseContent = state.schema.nodes.table_cell.createAndFill().content;
    sel.forEachCell((cell, pos) => {
      if (!cell.content.eq(baseContent)) {
        tr.replace(tr.mapping.map(pos + 1), tr.mapping.map(pos + cell.nodeSize - 1), new prosemirrorModel.Slice(baseContent, 0, 0));
      }
    });
    if (tr.docChanged) dispatch(tr);
  }

  return true;
}

function handleTripleClick(view, pos) {
  let doc = view.state.doc,
      $cell = cellAround(doc.resolve(pos));
  if (!$cell) return false;
  view.dispatch(view.state.tr.setSelection(new CellSelection($cell)));
  return true;
}
function handlePaste(view, _, slice, store) {
  if (!isInTable(view.state)) return false;
  let cells = pastedCells(slice),
      sel = view.state.selection;

  if (sel instanceof CellSelection) {
    if (!cells) cells = {
      width: 1,
      height: 1,
      rows: [prosemirrorModel.Fragment.from(fitSlice(view.state.schema.nodes.table_cell, slice))]
    };
    let table = sel.$anchorCell.node(-1),
        start = sel.$anchorCell.start(-1);
    const rect = TableMap.get(table).rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
    cells = clipCells(cells, rect.right - rect.left, rect.bottom - rect.top);
    insertCells(view.state, view.dispatch, start, rect, cells, store);
    return true;
  } else if (cells) {
    let $cell = selectionCell(view.state),
        start = $cell.start(-1);
    insertCells(view.state, view.dispatch, start, TableMap.get($cell.node(-1)).findCell($cell.pos - start), cells, store);
    return true;
  }

  return false;
}
function handleMouseDown$1(view, startEvent) {
  if (startEvent.ctrlKey || startEvent.metaKey) return;
  let startDOMCell = domInCell(view, startEvent.target),
      $anchor;

  if (startEvent.shiftKey && view.state.selection instanceof CellSelection) {
    // Adding to an existing cell selection
    setCellSelection(view.state.selection.$anchorCell, startEvent);
    startEvent.preventDefault();
  } else if (startEvent.shiftKey && startDOMCell && ($anchor = cellAround(view.state.selection.$anchor)) != null && cellUnderMouse(view, startEvent).pos != $anchor.pos) {
    // Adding to a selection that starts in another cell (causing a
    // cell selection to be created).
    setCellSelection($anchor, startEvent);
    startEvent.preventDefault();
  } else if (!startDOMCell) {
    // Not in a cell, let the default behavior happen.
    return;
  } // Create and dispatch a cell selection between the given anchor and
  // the position under the mouse.


  function setCellSelection($anchor, event) {
    let $head = cellUnderMouse(view, event);
    const starting = key.getState(view.state) == null;

    if (!$head || !inSameTable($anchor, $head)) {
      if (starting) $head = $anchor;else return;
    }

    const selection = new CellSelection($anchor, $head);

    if (starting || !view.state.selection.eq(selection)) {
      const tr = view.state.tr.setSelection(selection);
      if (starting) tr.setMeta(key, $anchor.pos);
      view.dispatch(tr);
    }
  } // Stop listening to mouse motion events.


  function stop() {
    view.root.removeEventListener('mouseup', stop);
    view.root.removeEventListener('dragstart', stop);
    view.root.removeEventListener('mousemove', move);
    if (key.getState(view.state) != null) view.dispatch(view.state.tr.setMeta(key, -1));
  }

  function move(event) {
    let anchor = key.getState(view.state),
        $anchor;

    if (anchor != null) {
      // Continuing an existing cross-cell selection
      $anchor = view.state.doc.resolve(anchor);
    } else if (domInCell(view, event.target) != startDOMCell) {
      // Moving out of the initial cell -- start a new cell selection
      $anchor = cellUnderMouse(view, startEvent);
      if (!$anchor) return stop();
    }

    if ($anchor) setCellSelection($anchor, event);
  }

  view.root.addEventListener('mouseup', stop);
  view.root.addEventListener('dragstart', stop);
  view.root.addEventListener('mousemove', move);
} // Check whether the cursor is at the end of a cell (so that further
// motion would move out of the cell)

function atEndOfCell(view, axis, dir) {
  if (!(view.state.selection instanceof prosemirrorState.TextSelection)) return null;
  const {
    $head
  } = view.state.selection;

  for (let d = $head.depth - 1; d >= 0; d--) {
    let parent = $head.node(d),
        index = dir < 0 ? $head.index(d) : $head.indexAfter(d);
    if (index != (dir < 0 ? 0 : parent.childCount)) return null;

    if (parent.type.spec.tableRole == 'cell' || parent.type.spec.tableRole == 'header_cell') {
      const cellPos = $head.before(d);
      const dirStr = axis == 'vert' ? dir > 0 ? 'down' : 'up' : dir > 0 ? 'right' : 'left';
      return view.endOfTextblock(dirStr) ? cellPos : null;
    }
  }

  return null;
}

function domInCell(view, dom) {
  for (; dom && dom != view.dom; dom = dom.parentNode) {
    if (dom.nodeName == 'TD' || dom.nodeName == 'TH') return dom;
  }
}

function cellUnderMouse(view, event) {
  const mousePos = view.posAtCoords({
    left: event.clientX,
    top: event.clientY
  });
  if (!mousePos) return null;
  return mousePos ? cellAround(view.state.doc.resolve(mousePos.pos)) : null;
}

// This file defines helpers for normalizing tables, making sure no
// compared to the given previous document. Useful for avoiding
// duplicate work on each transaction.

function changedDescendants(old, cur, offset, f) {
  let oldSize = old.childCount,
      curSize = cur.childCount;

  outer: for (let i = 0, j = 0; i < curSize; i++) {
    const child = cur.child(i);

    for (let scan = j, e = Math.min(oldSize, i + 3); scan < e; scan++) {
      if (old.child(scan) == child) {
        j = scan + 1;
        offset += child.nodeSize;
        continue outer;
      }
    }

    f(child, offset);

    if (j < oldSize && old.child(j).sameMarkup(child)) {
      changedDescendants(old.child(j), child, offset + 1, f);
    } else {
      child.nodesBetween(0, child.content.size, f, offset + 1);
    }

    offset += child.nodeSize;
  }
} // :: (EditorState, ?EditorState) → ?Transaction
// Inspect all tables in the given state's document and return a
// transaction that fixes them, if necessary. If `oldState` was
// provided, that is assumed to hold a previous, known-good state,
// which will be used to avoid re-scanning unchanged parts of the
// document.


function fixTables(state, oldState) {
  let tr,
      check = (node, pos) => {
    if (node.type.spec.tableRole == 'table') tr = fixTable(state, node, pos, tr);
  };

  if (!oldState) state.doc.descendants(check);else if (oldState.doc != state.doc) changedDescendants(oldState.doc, state.doc, 0, check);
  return tr;
} // : (EditorState, Node, number, ?Transaction) → ?Transaction
// Fix the given table, if necessary. Will append to the transaction
// it was given, if non-null, or create a new one if necessary.

function fixTable(state, table, tablePos, tr) {
  const map = TableMap.get(table);
  if (!map.problems) return tr;
  if (!tr) tr = state.tr; // Track which rows we must add cells to, so that we can adjust that
  // when fixing collisions.

  const mustAdd = [];

  for (let i = 0; i < map.height; i++) mustAdd.push(0);

  for (let i = 0; i < map.problems.length; i++) {
    const prob = map.problems[i];

    if (prob.type == 'collision') {
      const cell = table.nodeAt(prob.pos);

      for (let j = 0; j < cell.attrs.rowspan; j++) mustAdd[prob.row + j] += prob.n;

      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, rmColSpan(cell.attrs, cell.attrs.colspan - prob.n, prob.n));
    } else if (prob.type == 'missing') {
      mustAdd[prob.row] += prob.n;
    } else if (prob.type == 'overlong_rowspan') {
      const cell = table.nodeAt(prob.pos);
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell.attrs, 'rowspan', cell.attrs.rowspan - prob.n));
    } else if (prob.type == 'colwidth mismatch') {
      const cell = table.nodeAt(prob.pos);
      tr.setNodeMarkup(tr.mapping.map(tablePos + 1 + prob.pos), null, setAttr(cell.attrs, 'colwidth', prob.colwidth));
    }
  }

  let first, last;

  for (let i = 0; i < mustAdd.length; i++) {
    if (mustAdd[i]) {
      if (first == null) first = i;
      last = i;
    }
  } // Add the necessary cells, using a heuristic for whether to add the
  // cells at the start or end of the rows (if it looks like a 'bite'
  // was taken out of the table, add cells at the start of the row
  // after the bite. Otherwise add them at the end).


  for (let i = 0, pos = tablePos + 1; i < map.height; i++) {
    const end = pos + table.child(i).nodeSize;
    const add = mustAdd[i];

    if (add > 0) {
      const nodes = [];

      for (let j = 0; j < add; j++) {
        nodes.push(state.schema.nodes.table_cell.createAndFill());
      }

      const side = (i == 0 || first == i - 1) && last == i ? pos + 1 : end - 1;
      tr.insert(tr.mapping.map(side), nodes);
    }

    pos = end;
  }

  return tr;
}

//
// Creates a [plugin](http://prosemirror.net/docs/ref/#state.Plugin)
// that, when added to an editor, enables cell-selection, handles
// cell-based copy/paste, and makes sure tables stay well-formed (each
// row has the same width, and cells don't overlap).
//
// You should probably put this plugin near the end of your array of
// plugins, since it handles mouse and arrow key events in tables
// rather broadly, and other plugins, like the gap cursor or the
// column-width dragging plugin, might want to get a turn first to
// perform more specific behavior.

function tableEditing(store) {
  return new prosemirrorState.Plugin({
    key,
    // This piece of state is used to remember when a mouse-drag
    // cell-selection is happening, so that it can continue even as
    // transactions (which might move its anchor cell) come in.
    state: {
      init() {
        return null;
      },

      apply(tr, cur) {
        const set = tr.getMeta(key);
        if (set != null) return set === -1 ? null : set;
        if (cur == null || !tr.docChanged) return cur;
        const {
          deleted,
          pos
        } = tr.mapping.mapResult(cur);
        return deleted ? null : pos;
      }

    },
    props: {
      decorations: drawCellSelection,
      handleDOMEvents: {
        mousedown: handleMouseDown$1,
        input: (view, e) => {
          const {
            state: {
              selection
            }
          } = view;
          const {
            $from
          } = selection;
          const isNumCell = index_js.findParentNode($from.path, node => node.attrs && node.attrs.numCell);

          if (isNumCell) {
            e.preventDefault();
          }
        }
      },

      createSelectionBetween(view) {
        if (key.getState(view.state) != null) return view.state.selection;
      },

      handleTripleClick,
      handleKeyDown,
      handlePaste: (...args) => handlePaste(...args, store)
    },

    appendTransaction(_, oldState, state) {
      return normalizeSelection(state, fixTables(state, oldState));
    }

  });
}

var css$7 = ".ct-table-wrapper{width:100%;overflow-x:auto;overflow-y:hidden;margin:8px 0;padding-bottom:1px;padding-right:1px;counter-reset:cellnumber}.ct-table-wrapper table,.ct-table-wrapper tbody,.ct-table-wrapper td,.ct-table-wrapper th{background-clip:padding-box!important}.ct-table-wrapper table{width:auto;border-collapse:collapse;table-layout:fixed;word-break:break-all;position:relative;overflow:auto;margin-top:15px}.ct-table-wrapper td,.ct-table-wrapper th{box-sizing:border-box;width:auto;min-width:-webkit-fit-content;min-width:-moz-fit-content;min-width:fit-content;padding:1px 8px;border:1px solid #ddd;vertical-align:top;background-color:#fff}.ct-table-wrapper td.overflow,.ct-table-wrapper th.overflow{overflow:hidden;position:relative}.ct-table-wrapper td>ol,.ct-table-wrapper td>ul,.ct-table-wrapper th>ol,.ct-table-wrapper th>ul{overflow:hidden}.ct-table-wrapper th{text-align:left;background-color:#f6f6f6}.ct-table-wrapper td{overflow:hidden}.ct-table-wrapper .num-cell{counter-increment:cellnumber;vertical-align:top;text-align:center;color:#000;padding:8px 0;font-size:12px;-webkit-user-select:none!important;-moz-user-select:none!important;-ms-user-select:none!important;user-select:none!important}.ct-table-wrapper .num-cell:before{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;content:counter(cellnumber)}.ct-table-wrapper .num-cell p{display:none}.ct-table-wrapper h1,.ct-table-wrapper h2,.ct-table-wrapper h3,.ct-table-wrapper h4,.ct-table-wrapper h5,.ct-table-wrapper h6,.ct-table-wrapper p{min-width:0;margin-top:8px}.ct-table-wrapper ol,.ct-table-wrapper ul{padding-left:34px}.ct-table-wrapper .ct-image{font-size:1;min-width:32px;max-width:calc(100% - 6px)}.ProseMirror.resize-cursor{cursor:col-resize}.ProseMirror .column-resize-handler{position:absolute;top:0;bottom:-1px;width:2px;right:0;z-index:15;background-color:#adf;pointer-events:none}.column-resize-handler.ProseMirror-widget{background:#3d91f2}table .selectedCell{position:relative}table .selectedCell:after{z-index:2;position:absolute;content:\"\";left:0;right:0;top:0;bottom:0;background-color:rgba(65,194,245,.2);pointer-events:none}table .selectedCell.top:after{border-top:2px solid #1c6cdc}table .selectedCell.bottom:after{border-bottom:2px solid #1c6cdc}table .selectedCell.left:after{border-left:2px solid #1c6cdc}table .selectedCell.right:after{border-right:2px solid #1c6cdc}table[data-borderstyle=dashed]>tbody>tr>td,table[data-borderstyle=dashed]>tbody>tr>th{border-style:dashed}table[data-borderwidth=\"0\"]>tbody>tr>td,table[data-borderwidth=\"0\"]>tbody>tr>th{border:none}table[data-borderwidth=\"1\"] tr:first-child:after{content:\"\"}table[data-borderwidth=\"1\"]>tbody>tr>td,table[data-borderwidth=\"1\"]>tbody>tr>th{border-width:1px}table[data-borderwidth=\"1\"]>tbody>tr .column-resize-handler{width:2px}table[data-borderwidth=\"1\"]>tbody>tr .selectedCell:after{left:0;right:0;top:0;bottom:0;border-width:2px}table[data-borderwidth=\"2\"]>tbody>tr>td,table[data-borderwidth=\"2\"]>tbody>tr>th{border-width:2px}table[data-borderwidth=\"2\"]>tbody>tr .column-resize-handler{width:3px}table[data-borderwidth=\"2\"]>tbody>tr .selectedCell:after{left:1px;right:1px;top:1px;bottom:1px;border-width:3px}table[data-borderwidth=\"3\"]>tbody>tr>td,table[data-borderwidth=\"3\"]>tbody>tr>th{border-width:3px}table[data-borderwidth=\"3\"]>tbody>tr .column-resize-handler{width:4px}table[data-borderwidth=\"3\"]>tbody>tr .selectedCell:after{left:2px;right:2px;top:2px;bottom:2px;border-width:4px}table[data-borderwidth=\"4\"]>tbody>tr>td,table[data-borderwidth=\"4\"]>tbody>tr>th{border-width:4px}table[data-borderwidth=\"4\"]>tbody>tr .column-resize-handler{width:5px}table[data-borderwidth=\"4\"]>tbody>tr .selectedCell:after{left:3px;right:3px;top:3px;bottom:3px;border-width:5px}table[data-borderwidth=\"5\"]>tbody>tr>td,table[data-borderwidth=\"5\"]>tbody>tr>th{border-width:5px}table[data-borderwidth=\"5\"]>tbody>tr .column-resize-handler{width:6px}table[data-borderwidth=\"5\"]>tbody>tr .selectedCell:after{left:4px;right:4px;top:4px;bottom:4px;border-width:6px}table[data-borderwidth=\"6\"]>tbody>tr>td,table[data-borderwidth=\"6\"]>tbody>tr>th{border-width:6px}table[data-borderwidth=\"6\"]>tbody>tr .column-resize-handler{width:7px}table[data-borderwidth=\"6\"]>tbody>tr .selectedCell:after{left:5px;right:5px;top:5px;bottom:5px;border-width:7px}table[data-borderwidth=\"7\"]>tbody>tr>td,table[data-borderwidth=\"7\"]>tbody>tr>th{border-width:7px}table[data-borderwidth=\"7\"]>tbody>tr .column-resize-handler{width:8px}table[data-borderwidth=\"7\"]>tbody>tr .selectedCell:after{left:6px;right:6px;top:6px;bottom:6px;border-width:8px}table[data-bordercolor=\"#fff\"]>tbody>tr>td,table[data-bordercolor=\"#fff\"]>tbody>tr>th{border-color:#fff}table[data-bordercolor=\"#333\"]>tbody>tr>td,table[data-bordercolor=\"#333\"]>tbody>tr>th{border-color:#333}table[data-bordercolor=\"#f5222d\"]>tbody>tr>td,table[data-bordercolor=\"#f5222d\"]>tbody>tr>th{border-color:#f5222d}table[data-bordercolor=\"#fa541c\"]>tbody>tr>td,table[data-bordercolor=\"#fa541c\"]>tbody>tr>th{border-color:#fa541c}table[data-bordercolor=\"#faad14\"]>tbody>tr>td,table[data-bordercolor=\"#faad14\"]>tbody>tr>th{border-color:#faad14}table[data-bordercolor=\"#fadb14\"]>tbody>tr>td,table[data-bordercolor=\"#fadb14\"]>tbody>tr>th{border-color:#fadb14}table[data-bordercolor=\"#52c41a\"]>tbody>tr>td,table[data-bordercolor=\"#52c41a\"]>tbody>tr>th{border-color:#52c41a}table[data-bordercolor=\"#13c2c2\"]>tbody>tr>td,table[data-bordercolor=\"#13c2c2\"]>tbody>tr>th{border-color:#13c2c2}table[data-bordercolor=\"#1890ff\"]>tbody>tr>td,table[data-bordercolor=\"#1890ff\"]>tbody>tr>th{border-color:#1890ff}table[data-bordercolor=\"#2f54eb\"]>tbody>tr>td,table[data-bordercolor=\"#2f54eb\"]>tbody>tr>th{border-color:#2f54eb}table[data-bordercolor=\"#722ed1\"]>tbody>tr>td,table[data-bordercolor=\"#722ed1\"]>tbody>tr>th{border-color:#722ed1}table[data-bordercolor=\"#eb2f96\"]>tbody>tr>td,table[data-bordercolor=\"#eb2f96\"]>tbody>tr>th{border-color:#eb2f96}table[data-bordercolor=\"#f6f6f6\"]>tbody>tr>td,table[data-bordercolor=\"#f6f6f6\"]>tbody>tr>th{border-color:#f6f6f6}table[data-bordercolor=\"#989898\"]>tbody>tr>td,table[data-bordercolor=\"#989898\"]>tbody>tr>th{border-color:#989898}table[data-bordercolor=\"#ffe8e7\"]>tbody>tr>td,table[data-bordercolor=\"#ffe8e7\"]>tbody>tr>th{border-color:#ffe8e7}table[data-bordercolor=\"#ffece0\"]>tbody>tr>td,table[data-bordercolor=\"#ffece0\"]>tbody>tr>th{border-color:#ffece0}table[data-bordercolor=\"#fff7cb\"]>tbody>tr>td,table[data-bordercolor=\"#fff7cb\"]>tbody>tr>th{border-color:#fff7cb}table[data-bordercolor=\"#fcfcca\"]>tbody>tr>td,table[data-bordercolor=\"#fcfcca\"]>tbody>tr>th{border-color:#fcfcca}table[data-bordercolor=\"#e5f7d3\"]>tbody>tr>td,table[data-bordercolor=\"#e5f7d3\"]>tbody>tr>th{border-color:#e5f7d3}table[data-bordercolor=\"#cffff7\"]>tbody>tr>td,table[data-bordercolor=\"#cffff7\"]>tbody>tr>th{border-color:#cffff7}table[data-bordercolor=\"#d4eefc\"]>tbody>tr>td,table[data-bordercolor=\"#d4eefc\"]>tbody>tr>th{border-color:#d4eefc}table[data-bordercolor=\"#dfe8fc\"]>tbody>tr>td,table[data-bordercolor=\"#dfe8fc\"]>tbody>tr>th{border-color:#dfe8fc}table[data-bordercolor=\"#efe1fa\"]>tbody>tr>td,table[data-bordercolor=\"#efe1fa\"]>tbody>tr>th{border-color:#efe1fa}table[data-bordercolor=\"#fbe1eb\"]>tbody>tr>td,table[data-bordercolor=\"#fbe1eb\"]>tbody>tr>th{border-color:#fbe1eb}table[data-bordercolor=\"#e9e9e9\"]>tbody>tr>td,table[data-bordercolor=\"#e9e9e9\"]>tbody>tr>th{border-color:#e9e9e9}table[data-bordercolor=\"#666\"]>tbody>tr>td,table[data-bordercolor=\"#666\"]>tbody>tr>th{border-color:#666}table[data-bordercolor=\"#ffa39e\"]>tbody>tr>td,table[data-bordercolor=\"#ffa39e\"]>tbody>tr>th{border-color:#ffa39e}table[data-bordercolor=\"#ffbb96\"]>tbody>tr>td,table[data-bordercolor=\"#ffbb96\"]>tbody>tr>th{border-color:#ffbb96}table[data-bordercolor=\"#ffe58f\"]>tbody>tr>td,table[data-bordercolor=\"#ffe58f\"]>tbody>tr>th{border-color:#ffe58f}table[data-bordercolor=\"#fffb8f\"]>tbody>tr>td,table[data-bordercolor=\"#fffb8f\"]>tbody>tr>th{border-color:#fffb8f}table[data-bordercolor=\"#b7eb8f\"]>tbody>tr>td,table[data-bordercolor=\"#b7eb8f\"]>tbody>tr>th{border-color:#b7eb8f}table[data-bordercolor=\"#87e8de\"]>tbody>tr>td,table[data-bordercolor=\"#87e8de\"]>tbody>tr>th{border-color:#87e8de}table[data-bordercolor=\"#91d5ff\"]>tbody>tr>td,table[data-bordercolor=\"#91d5ff\"]>tbody>tr>th{border-color:#91d5ff}table[data-bordercolor=\"#adc6ff\"]>tbody>tr>td,table[data-bordercolor=\"#adc6ff\"]>tbody>tr>th{border-color:#adc6ff}table[data-bordercolor=\"#d3adf7\"]>tbody>tr>td,table[data-bordercolor=\"#d3adf7\"]>tbody>tr>th{border-color:#d3adf7}table[data-bordercolor=\"#ffadd2\"]>tbody>tr>td,table[data-bordercolor=\"#ffadd2\"]>tbody>tr>th{border-color:#ffadd2}table[data-bordercolor=\"#ddd\"]>tbody>tr>td,table[data-bordercolor=\"#ddd\"]>tbody>tr>th{border-color:#ddd}table[data-bordercolor=\"#4b4b4b\"]>tbody>tr>td,table[data-bordercolor=\"#4b4b4b\"]>tbody>tr>th{border-color:#4b4b4b}table[data-bordercolor=\"#ff4d4f\"]>tbody>tr>td,table[data-bordercolor=\"#ff4d4f\"]>tbody>tr>th{border-color:#ff4d4f}table[data-bordercolor=\"#ff7a45\"]>tbody>tr>td,table[data-bordercolor=\"#ff7a45\"]>tbody>tr>th{border-color:#ff7a45}table[data-bordercolor=\"#ffc53d\"]>tbody>tr>td,table[data-bordercolor=\"#ffc53d\"]>tbody>tr>th{border-color:#ffc53d}table[data-bordercolor=\"#ffec3d\"]>tbody>tr>td,table[data-bordercolor=\"#ffec3d\"]>tbody>tr>th{border-color:#ffec3d}table[data-bordercolor=\"#73d13d\"]>tbody>tr>td,table[data-bordercolor=\"#73d13d\"]>tbody>tr>th{border-color:#73d13d}table[data-bordercolor=\"#36cfc9\"]>tbody>tr>td,table[data-bordercolor=\"#36cfc9\"]>tbody>tr>th{border-color:#36cfc9}table[data-bordercolor=\"#40a8ff\"]>tbody>tr>td,table[data-bordercolor=\"#40a8ff\"]>tbody>tr>th{border-color:#40a8ff}table[data-bordercolor=\"#597ef7\"]>tbody>tr>td,table[data-bordercolor=\"#597ef7\"]>tbody>tr>th{border-color:#597ef7}table[data-bordercolor=\"#9254de\"]>tbody>tr>td,table[data-bordercolor=\"#9254de\"]>tbody>tr>th{border-color:#9254de}table[data-bordercolor=\"#f759ab\"]>tbody>tr>td,table[data-bordercolor=\"#f759ab\"]>tbody>tr>th{border-color:#f759ab}table[data-bordercolor=\"#ccc\"]>tbody>tr>td,table[data-bordercolor=\"#ccc\"]>tbody>tr>th{border-color:#ccc}table[data-bordercolor=\"#262626\"]>tbody>tr>td,table[data-bordercolor=\"#262626\"]>tbody>tr>th{border-color:#262626}table[data-bordercolor=\"#cf1322\"]>tbody>tr>td,table[data-bordercolor=\"#cf1322\"]>tbody>tr>th{border-color:#cf1322}table[data-bordercolor=\"#d4380d\"]>tbody>tr>td,table[data-bordercolor=\"#d4380d\"]>tbody>tr>th{border-color:#d4380d}table[data-bordercolor=\"#d48806\"]>tbody>tr>td,table[data-bordercolor=\"#d48806\"]>tbody>tr>th{border-color:#d48806}table[data-bordercolor=\"#d4b106\"]>tbody>tr>td,table[data-bordercolor=\"#d4b106\"]>tbody>tr>th{border-color:#d4b106}table[data-bordercolor=\"#389e0d\"]>tbody>tr>td,table[data-bordercolor=\"#389e0d\"]>tbody>tr>th{border-color:#389e0d}table[data-bordercolor=\"#08979c\"]>tbody>tr>td,table[data-bordercolor=\"#08979c\"]>tbody>tr>th{border-color:#08979c}table[data-bordercolor=\"#096dd9\"]>tbody>tr>td,table[data-bordercolor=\"#096dd9\"]>tbody>tr>th{border-color:#096dd9}table[data-bordercolor=\"#1d39c4\"]>tbody>tr>td,table[data-bordercolor=\"#1d39c4\"]>tbody>tr>th{border-color:#1d39c4}table[data-bordercolor=\"#531dab\"]>tbody>tr>td,table[data-bordercolor=\"#531dab\"]>tbody>tr>th{border-color:#531dab}table[data-bordercolor=\"#c41d7f\"]>tbody>tr>td,table[data-bordercolor=\"#c41d7f\"]>tbody>tr>th{border-color:#c41d7f}table[data-bordercolor=\"#aaa\"]>tbody>tr>td,table[data-bordercolor=\"#aaa\"]>tbody>tr>th{border-color:#aaa}table[data-bordercolor=\"#000\"]>tbody>tr>td,table[data-bordercolor=\"#000\"]>tbody>tr>th{border-color:#000}table[data-bordercolor=\"#820014\"]>tbody>tr>td,table[data-bordercolor=\"#820014\"]>tbody>tr>th{border-color:#820014}table[data-bordercolor=\"#871400\"]>tbody>tr>td,table[data-bordercolor=\"#871400\"]>tbody>tr>th{border-color:#871400}table[data-bordercolor=\"#874d00\"]>tbody>tr>td,table[data-bordercolor=\"#874d00\"]>tbody>tr>th{border-color:#874d00}table[data-bordercolor=\"#876800\"]>tbody>tr>td,table[data-bordercolor=\"#876800\"]>tbody>tr>th{border-color:#876800}table[data-bordercolor=\"#135200\"]>tbody>tr>td,table[data-bordercolor=\"#135200\"]>tbody>tr>th{border-color:#135200}table[data-bordercolor=\"#00474f\"]>tbody>tr>td,table[data-bordercolor=\"#00474f\"]>tbody>tr>th{border-color:#00474f}table[data-bordercolor=\"#003a8c\"]>tbody>tr>td,table[data-bordercolor=\"#003a8c\"]>tbody>tr>th{border-color:#003a8c}table[data-bordercolor=\"#061178\"]>tbody>tr>td,table[data-bordercolor=\"#061178\"]>tbody>tr>th{border-color:#061178}table[data-bordercolor=\"#22075e\"]>tbody>tr>td,table[data-bordercolor=\"#22075e\"]>tbody>tr>th{border-color:#22075e}table[data-bordercolor=\"#780650\"]>tbody>tr>td,table[data-bordercolor=\"#780650\"]>tbody>tr>th{border-color:#780650}table.responsive{table-layout:auto}table.responsive>tbody>tr>td,table.responsive>tbody>tr>th{width:auto!important;min-width:52px}table.responsive>tbody>tr>td h1,table.responsive>tbody>tr>td h2,table.responsive>tbody>tr>td h3,table.responsive>tbody>tr>td h4,table.responsive>tbody>tr>td h5,table.responsive>tbody>tr>td h6,table.responsive>tbody>tr>td p,table.responsive>tbody>tr>th h1,table.responsive>tbody>tr>th h2,table.responsive>tbody>tr>th h3,table.responsive>tbody>tr>th h4,table.responsive>tbody>tr>th h5,table.responsive>tbody>tr>th h6,table.responsive>tbody>tr>th p{min-width:0;margin-top:8px;word-break:keep-all}.pm-body-wrapper .ct-table-wrapper{overflow-x:auto}.pm-body-wrapper .ct-table-wrapper table{position:static}.pm-body-wrapper .ct-table-wrapper .num-cell-view:before{content:\"\"}.pm-body-wrapper .ct-table-wrapper .cloneHeader{display:none}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th,.pm-body-wrapper .ct-table-wrapper .originHeader>th{position:relative}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th:after{content:\"\";width:12px;height:12px;visibility:hidden;position:absolute;right:4px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg class='icon' viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' width='12' height='12'%3E%3Cdefs%3E%3Cstyle/%3E%3C/defs%3E%3Cpath d='M228.437 251.904L475.563 15.36a51.2 51.2 0 0 1 72.874 0l247.126 236.544a52.907 52.907 0 0 1 11.178 57.173 51.627 51.627 0 0 1-47.616 32.256h-494.25a51.541 51.541 0 0 1-47.616-32.426 52.907 52.907 0 0 1 11.178-57.003zm567.126 520.192L548.437 1008.64a51.2 51.2 0 0 1-72.874 0L228.437 772.096a52.907 52.907 0 0 1-11.178-57.173 51.627 51.627 0 0 1 47.616-32.256h494.25c20.822 0 39.595 12.8 47.616 32.426a52.907 52.907 0 0 1-11.178 57.003z' fill='%23B0B0B0'/%3E%3C/svg%3E\");background-color:inherit;background-repeat:no-repeat;background-position:50%;cursor:pointer}.pm-body-wrapper .ct-table-wrapper .cloneHeader:hover>th:after,.pm-body-wrapper .ct-table-wrapper .originHeader:hover>th:after{visibility:visible}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th[data-reverse=\"-1\"]:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th[data-reverse=\"-1\"]:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M2.677 2.952L5.573.18a.6.6 0 0 1 .854 0l2.896 2.772a.62.62 0 0 1 .131.67.605.605 0 0 1-.558.378H3.104a.604.604 0 0 1-.558-.38.62.62 0 0 1 .131-.668zm6.646 6.096L6.427 11.82a.6.6 0 0 1-.854 0L2.677 9.048a.62.62 0 0 1-.131-.67A.605.605 0 0 1 3.104 8h5.792c.244 0 .464.15.558.38a.62.62 0 0 1-.131.668z' fill='%23B0B0B0'/%3E%3Cpath d='M2.677 2.952L5.573.18a.6.6 0 0 1 .854 0l2.896 2.772a.62.62 0 0 1 .131.67.605.605 0 0 1-.558.378H3.104a.604.604 0 0 1-.558-.38.62.62 0 0 1 .131-.668z' fill='%236B6B6B'/%3E%3Cpath d='M9.323 9.048L6.427 11.82a.6.6 0 0 1-.854 0L2.677 9.048a.62.62 0 0 1-.131-.67A.605.605 0 0 1 3.104 8h5.792c.244 0 .464.15.558.38a.62.62 0 0 1-.131.668z' fill='%23AAA'/%3E%3C/g%3E%3C/svg%3E\")}.pm-body-wrapper .ct-table-wrapper .cloneHeader>th[data-reverse=\"1\"]:after,.pm-body-wrapper .ct-table-wrapper .originHeader>th[data-reverse=\"1\"]:after{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M2.677 2.952L5.573.18a.6.6 0 0 1 .854 0l2.896 2.772a.62.62 0 0 1 .131.67.605.605 0 0 1-.558.378H3.104a.604.604 0 0 1-.558-.38.62.62 0 0 1 .131-.668zm6.646 6.096L6.427 11.82a.6.6 0 0 1-.854 0L2.677 9.048a.62.62 0 0 1-.131-.67A.605.605 0 0 1 3.104 8h5.792c.244 0 .464.15.558.38a.62.62 0 0 1-.131.668z' fill='%23B0B0B0'/%3E%3Cpath d='M2.677 2.952L5.573.18a.6.6 0 0 1 .854 0l2.896 2.772a.62.62 0 0 1 .131.67.605.605 0 0 1-.558.378H3.104a.604.604 0 0 1-.558-.38.62.62 0 0 1 .131-.668z' fill='%23AAA'/%3E%3Cpath d='M9.323 9.048L6.427 11.82a.6.6 0 0 1-.854 0L2.677 9.048a.62.62 0 0 1-.131-.67A.605.605 0 0 1 3.104 8h5.792c.244 0 .464.15.558.38a.62.62 0 0 1-.131.668z' fill='%236B6B6B'/%3E%3C/g%3E%3C/svg%3E\")}.pm-body-wrapper .ct-table-wrapper .tableHeadFixed{display:table-row;position:absolute;top:0;z-index:99;overflow:hidden}.pm-body-wrapper .ct-table-wrapper .tableHeadFixed td,.pm-body-wrapper .ct-table-wrapper .tableHeadFixed th{overflow:hidden}.pm-body-wrapper .ct-table-wrapper .float-scrollbar{display:none;height:17px;position:absolute;bottom:0;width:100%}.pm-body-wrapper .ct-table-wrapper .float-scroll-filling{border:1px solid #fff;opacity:.01}.pm-body-wrapper .ct-table-wrapper .float-scroll-container{overflow-x:auto;overflow-y:hidden;height:17px}";
styleInject(css$7);

function getScrollbarWidth() {
  const tags = document.createElement('p');
  const styles = {
    width: '100px',
    height: '100px',
    overflowY: 'scroll'
  };

  for (const i in styles) tags.style[i] = styles[i]; // eslint-disable-line


  document.body.appendChild(tags);
  const scrollbarWidth = tags.offsetWidth - tags.clientWidth;
  tags.remove();
  return scrollbarWidth;
} // 计算单元格的宽度，合并单元格时 data-colwidth 为：'90,200,...'

function getColWidth(attr) {
  if (!attr) return;
  return attr.split(',').reduce((p, c) => +p + +c, 0);
} // 判断某一节点是否包含在某一个标签内

function isContainsByTags(node, tags, bodyWrapper) {
  let parentNode = node.parentNode;

  while (parentNode && parentNode !== bodyWrapper) {
    if (tags.includes((parentNode.tagName || '').toLowerCase())) {
      return parentNode;
    }

    parentNode = parentNode.parentNode;
  }

  return false;
} // dpi=1.25是 表格宽度需要为 4 的整数倍

function formatWidth$1(width) {
  width = Math.round(width);
  const remainder = width % 4;

  switch (remainder) {
    case 0:
      return width;

    case 1:
      return width - 1;

    case 2:
      return width + 2;

    case 3:
      return width + 1;

    default:
  }
} // 判断是否为表头
// 表格中必须整行都为 th 才算做表头

function isHasHead(thead) {
  let hasThead = true;
  thead.childNodes.forEach(th => {
    if ((th.tagName || '').toLowerCase() !== 'th') {
      hasThead = false;
    }
  });
  return hasThead;
} // 处理窗口放大情况下的表格宽度处理

function translateWidthForScaleWindow(td, originTds, index) {
  td.forEach((i, ind) => {
    let width = getColWidth(i.getAttribute('data-colwidth'));
    width = formatWidth$1(width);
    const originTd = originTds && originTds[ind];

    if (width) {
      if (index === 0) i.style.cssText = `${i.style.cssText} min-width: ${width}px; max-width: ${width}px;`;
      i.setAttribute('width', `${width}px`);
      return;
    } // 解决表头吸顶无宽度


    let clientWidth = originTds && originTd ? originTd.clientWidth : i.clientWidth;
    clientWidth += 18;
    clientWidth = formatWidth$1(clientWidth);
    if (clientWidth < 52) clientWidth = 52;

    if (index === 0) {
      i.setAttribute('width', `${clientWidth}px`);
      i.style.cssText = `${i.style.cssText} min-width: ${clientWidth}px; max-width: ${clientWidth}px;`;
    } else {
      i.setAttribute('width', `${clientWidth}px`);
    }
  });
}
/**
 * 计算表格总宽度
 * 及判断表格是否存在宽度信息
 */

function calculateTableWidth(tr) {
  let tableWidth = 0;
  let allHasWidth = true;
  Array.from(tr).forEach(td => {
    if (!td.getAttribute('data-colwidth') || td.getAttribute('data-colwidth') === '0') allHasWidth = false;else {
      let width = getColWidth(td.getAttribute('data-colwidth')); // 处理存在 colspan>1 但是 data-colwidth只有一个值 而非 data-colwidth='68,68,68'的形式

      const colspan = td.getAttribute('colspan');
      const dataWidth = td.getAttribute('data-colwidth');
      const dataLen = (dataWidth || '').split(',').length;

      if (dataLen === 1 && colspan && +colspan > 1) {
        width = +colspan * dataWidth;
      }

      if (window.devicePixelRatio === 1.25) {
        width = formatWidth$1(width);
      }

      tableWidth += width;
    }
  });
  return {
    tableWidth,
    allHasWidth
  };
} // table中插入 colgroup 标签

function addColGroup(table) {
  if (Array.from(table.children).some(ele => (ele.tagName || '').toLowerCase() === 'colgroup')) {
    return;
  }

  const tbodyChild = table.getElementsByTagName('tbody')[0];

  if (!tbodyChild) {
    return;
  }

  const firstTr = tbodyChild.childNodes[0];
  if (!firstTr) return;
  const colgroup = document.createElement('colgroup');
  Array.from(firstTr.childNodes).forEach(td => {
    const colspan = td.getAttribute('colspan');
    let colwidth = td.getAttribute('data-colwidth');
    const widthArr = colwidth && colwidth.split(',') || [];

    if (colspan) {
      for (let i = 0; i < +colspan; i++) {
        const col = document.createElement('col');
        let width = widthArr && widthArr[i];
        width = +width;

        if (width) {
          if (window.devicePixelRatio === 1.25) {
            width = formatWidth$1(width);
          }

          col.setAttribute('style', `width: ${width}px;`);
        }

        colgroup.appendChild(col);
      }
    } else {
      const col = document.createElement('col');

      if (+colwidth) {
        if (window.devicePixelRatio === 1.25) {
          colwidth = formatWidth$1(colwidth);
        }

        col.setAttribute('style', `width: ${colwidth}px;`);
      }

      colgroup.appendChild(col);
    }
  });
  table.insertBefore(colgroup, table.childNodes[0]);
} // 将表头的 data-colwidth 转成 width

function translateWidth(table, originTable) {
  const tableInCollapse = originTable && originTable.closest('.ct-collapse-content');
  const tableLayout = table.getAttribute('data-table-layout'); // 展开宏内表格自适应宽度的情况 需要先展开宏展开进行宽度计算 否则获取不到正确宽度

  if (tableInCollapse && tableLayout && tableLayout === 'auto') {
    tableInCollapse.style.display = 'block';
  }

  let cellCount = 1;
  Array.from(table.querySelectorAll('tr')).forEach((tr, index) => {
    const tds = tr.querySelectorAll('th, td');
    if (!tds) return;
    const originTrs = originTable && originTable.querySelectorAll('tr');
    const originTds = originTrs && originTrs[index] && originTrs[index].querySelectorAll('th, td'); // 解决 windows 下显示默认125%的缩放

    if (window.devicePixelRatio === 1.25) {
      translateWidthForScaleWindow(tds, originTds, index);
      return;
    }

    Array.from(tds).forEach((td, ind) => {
      const width = getColWidth(td.getAttribute('data-colwidth')); // 将表格行号列转成真实的数据，以便排序

      const isNumCell = td.classList.contains('num-cell');
      const {
        isMobile
      } = index_js.getSystemInfo();

      if (isNumCell && !isMobile) {
        td.classList.add('num-cell-view');
        td.innerHTML = cellCount;
        cellCount++;
      } // 在需要设置overflow的地址设置 避免所有都设置overflow属性 导致大文档加载卡死


      const needOverFlow = td.querySelector('a[class="ct-attachment"]') || td.querySelector('.ct-status');
      const originTd = originTds && originTds[ind];

      if (width) {
        if (index === 0) td.style.cssText = `${td.style.cssText} min-width: ${width}px; max-width: ${width}px;`;
        td.setAttribute('width', `${width}px`);
        if (needOverFlow) td.style.overflow = 'hidden';
        return;
      } // 解决表头吸顶无宽度


      let clientWidth = originTds && originTd ? originTd.clientWidth : td.clientWidth;
      clientWidth += 18; // 原始宽度没有 padding 需要加上 padding

      if (clientWidth < 50) clientWidth = 50;
      td.setAttribute('width', `${clientWidth}px`);
      if (needOverFlow) td.style.overflow = 'hidden';
      td.style.cssText = `${td.style.cssText} min-width: ${clientWidth}px; max-width: ${clientWidth}px;`;
    });
  });

  if (tableInCollapse && tableLayout && tableLayout === 'auto') {
    tableInCollapse.style.display = 'none';
  }
} // 复制吸顶时的表头

function cloneFixedHeader(table, bodyWrapper) {
  // 嵌套在表格中的不处理
  if (isContainsByTags(table, 'table', bodyWrapper)) return; // 仅有一个表头不处理

  const tr = table.querySelectorAll('tr');
  if (tr && tr.length === 1) return;
  let originHeader = table.querySelector('.originHeader');
  if (originHeader) return;
  originHeader = table.querySelector('tr:first-child');
  originHeader.classList.add('originHeader'); // 不存在表头的不处理

  const hasThead = isHasHead(originHeader);
  if (!hasThead) return; // 已经复制过的不再处理

  const cloneHeader = table.querySelector('.cloneHeader');
  if (cloneHeader) return;
  const insertCloneHeader = originHeader.cloneNode(true); // 移除克隆部分的id, 避免标题在表头中, id重复, 无法跳转

  const titleInTable = insertCloneHeader.querySelectorAll('h1, h2, h3, h4, h5, h6');
  titleInTable.forEach(h => {
    h.removeAttribute('id');
  });
  insertCloneHeader.classList.remove('originHeader');
  insertCloneHeader.classList.add('cloneHeader');
  const tbody = document.createElement('tbody');
  tbody.classList.add('cloneHeaderBody');
  tbody.appendChild(insertCloneHeader);
  table.insertBefore(tbody, table.childNodes[0]); // 不将clone的表头插入到原始表头之后的原因为 若表头存在行合并的情况会吸顶会显示错误
} // 添加悬浮滚动条

function addTableFloatScrollBar(tableWrapper, floatScrollBar, tableWrapperScrollWidth, containerPadding, containerPaddingLeft, scrollbarWidth) {
  const html = `<div
      class="float-scroll-container"
      style="margin-left: ${containerPaddingLeft + scrollbarWidth}px;"
    >
      <div class="float-scroll-filling" style="width: ${tableWrapperScrollWidth}px;"></div>
    </div>`; // 表格存在缩进的处理

  const marginLeftData = tableWrapper.style.marginLeft;
  const marginLeft = +(marginLeftData && marginLeftData.replace('px', ''));
  floatScrollBar.innerHTML = html;
  floatScrollBar.className = 'float-scrollbar';
  floatScrollBar.style.right = `${containerPadding + scrollbarWidth - marginLeft}px`;
  tableWrapper.appendChild(floatScrollBar);
} // 表格底部滚动条悬浮

function tableFloatScrollBar(table, navBarHeight, containerPadding, containerPaddingLeft, scrollbarWidth) {
  const tableAbsoluteTop = table.getBoundingClientRect().top;
  const tableAbsoluteBottom = tableAbsoluteTop + table.clientHeight;
  const tableWrapper = table.parentNode;
  let floatScrollBar = tableWrapper && tableWrapper.querySelector('.float-scrollbar');
  const screenHeight = document.body.clientHeight;
  const {
    clientWidth: tableWrapperWidth,
    scrollWidth: tableWrapperScrollWidth
  } = tableWrapper;

  if (tableWrapperWidth < tableWrapperScrollWidth && tableAbsoluteTop < screenHeight && !floatScrollBar) {
    floatScrollBar = document.createElement('div');
    addTableFloatScrollBar(tableWrapper, floatScrollBar, tableWrapperScrollWidth, containerPadding, containerPaddingLeft, scrollbarWidth);
  }

  if (!floatScrollBar) return;

  if (tableAbsoluteTop - navBarHeight <= screenHeight && tableAbsoluteBottom >= screenHeight) {
    floatScrollBar.style.display = 'block';
    floatScrollBar.childNodes[0].scrollLeft = tableWrapper.scrollLeft;
  } else {
    floatScrollBar.style.display = 'none';
  }
} // 添加表格表框解决表格表框 丢失一部分或者 粗细只有一半

function addTableBorder(table) {
  const {
    bordercolor,
    borderwidth,
    borderstyle
  } = table.dataset;
  if (borderwidth === '0') return;
  const borderCSS = `${borderwidth || 1}px ${borderstyle || 'solid'} ${bordercolor || '#cccccc'}`;
  table.style.borderTop = borderCSS;

  if (borderwidth) {
    table.style.borderLeft = borderCSS;
  }
}

const scrollbarWidth = getScrollbarWidth(); // 处理百分比表格的表头吸顶的对齐

function alignPercentTable(header, originHeader) {
  header.childNodes.forEach((th, index) => {
    const orgth = originHeader.childNodes && originHeader.childNodes[index];

    if (orgth.clientWidth) {
      th.style.minWidth = `${orgth.clientWidth + 1}px`;
      th.style.maxWidth = `${orgth.clientWidth + 1}px`;
    }
  });
} // 表格横向滚动

function tableHorizonScroll(e) {
  // 表头的横向滚动
  const target = e.target;
  const scrollLeft = target.scrollLeft;
  const offsetLeft = target.offsetLeft;

  if (target.className === 'ct-table-wrapper' && target.querySelector('.tableHeadFixed')) {
    const tableHead = target.querySelector('tr:first-child');

    if (tableHead) {
      const paddingLeft = offsetLeft;
      tableHead.style.left = `${-scrollLeft + paddingLeft}px`;
    }
  } // 表格的滚动联动悬浮滚动条的滚动位置


  if (target.className === 'ct-table-wrapper' && target.querySelector('.float-scrollbar')) {
    target.querySelector('.float-scroll-container').scrollLeft = scrollLeft;
  }

  if (target.className === 'float-scroll-container') {
    const currentTableWrapper = target.closest('.ct-table-wrapper');
    currentTableWrapper && (currentTableWrapper.scrollLeft = scrollLeft);
  }
} // 表格吸顶

function tableHeadFixed({
  bodyWrapper,
  navBarHeight,
  containerPadding,
  containerPaddingLeft,
  isFloatScroll = false
}) {
  if (!bodyWrapper) return;
  bodyWrapper.querySelectorAll('table').forEach(table => {
    if (isFloatScroll) tableFloatScrollBar(table, navBarHeight, containerPadding, containerPaddingLeft, scrollbarWidth); // 若在展开宏内 且展开宏是收起的状态，则不吸顶

    const isInCollapse = table.closest('.ct-collapse:not(.active)');
    if (isInCollapse) return;
    const tableAbsoluteTop = table.getBoundingClientRect().top;
    const tableRect = table.getBoundingClientRect();
    const tableAbsoluteBottom = tableAbsoluteTop + tableRect.height; //const tableAbsoluteBottom = tableAbsoluteTop + table.clientHeight
    // 表头吸顶

    const insertedHeader = table.querySelector('.cloneHeader');
    const originHeader = table.querySelector('.originHeader');
    if (!insertedHeader || !originHeader) return; // 若是百分比的表格需要特殊处理吸顶时候的表头对齐

    const tableLayout = table.getAttribute('data-table-layout');
    const isResponsive = table.classList.contains('responsive');

    if (tableLayout && tableLayout === 'auto' || isResponsive) {
      alignPercentTable(insertedHeader, originHeader);
    } // 解决滚动条宽度使表格吸顶后右边不对齐


    const hasRight = insertedHeader.style.right;

    if (!hasRight) {
      // 表格存在缩进的处理
      const marginLeftData = table.parentNode.style.marginLeft;
      const marginLeft = +(marginLeftData && marginLeftData.replace('px', ''));
      insertedHeader.style.right = `${containerPadding + scrollbarWidth - marginLeft}px`;
    }

    const isFixed = insertedHeader.classList.contains('tableHeadFixed');
    const shouldFixed = tableAbsoluteTop - navBarHeight <= 0 && tableAbsoluteBottom - originHeader.clientHeight - navBarHeight >= 0; // 设置吸顶

    if (shouldFixed && !isFixed) {
      insertedHeader.classList.add('tableHeadFixed');
      const paddingLeft = table.offsetLeft;
      insertedHeader.style.left = `${-table.parentNode.scrollLeft + paddingLeft}px`;
      return;
    } // 移除吸顶


    if (!shouldFixed && isFixed) {
      insertedHeader.classList.remove('tableHeadFixed');
    }
  });
}
const tableToView = ({
  cloneWrapper,
  bodyWrapper,
  onDestroy
}, {
  scrollWrapper,
  headerFixed = false,
  navBarHeight,
  containerPadding,
  navBarHeightFn
} = {
  headerFixed: false
}) => {
  const unmountFns = [];
  const pmBodyWrapper = cloneWrapper || bodyWrapper;
  const tables = pmBodyWrapper.querySelectorAll('table');
  const originTables = bodyWrapper && bodyWrapper.querySelectorAll('table');
  Array.from(tables).forEach((table, index) => {
    // 过滤空表格
    if (!table.querySelector('tr')) return;
    if (table.parentNode.classList.contains('ct-table-wrapper')) return; // 为 table 多加一层 <div class='ct-table-wrapper'>...</div>

    const newNode = document.createElement('div');
    newNode.setAttribute('class', 'ct-table-wrapper');
    const parentNode = table.parentNode;
    parentNode.insertBefore(newNode, table);
    newNode.appendChild(table);
    const hasMargin = table.style.marginLeft;

    if (hasMargin) {
      table.parentNode.style.marginLeft = hasMargin;
      table.parentNode.style.marginRight = '1px'; // 使得滚动到最右侧能显示边框

      table.parentNode.style.width = `calc(100% - ${parseInt(hasMargin, 10) + 1}px)`;
      table.style.marginLeft = 0;
    }

    const isResponsive = table.classList.contains('responsive');
    const tr = table.querySelectorAll('tr');
    const trLen = tr && tr.length === 1;
    const tableLayout = table.getAttribute('data-table-layout');

    if (!isResponsive) {
      // 计算table总宽度
      const tablechild = table.querySelector('tr:first-child').childNodes;
      const {
        tableWidth,
        allHasWidth
      } = calculateTableWidth(tablechild);

      if (allHasWidth && !table.hasAttribute('width')) {
        table.style.width = `${tableWidth}px`;
      }

      if (!allHasWidth && !table.hasAttribute('min-width') && tableWidth) {
        table.style.minWidth = `${tableWidth}px`;
      }

      addColGroup(table); // 仅有一个表头且表格为自适应宽度的不需要转换宽度

      if (trLen && tableLayout === 'auto') return;

      if (bodyWrapper) {
        const originTable = originTables[index];
        translateWidth(table, originTable);
      } else {
        translateWidth(table);
      }
    }

    addTableBorder(table); // 表格吸顶

    if (headerFixed && !trLen) {
      cloneFixedHeader(table, bodyWrapper);
      newNode.addEventListener("scroll", tableHorizonScroll);
      unmountFns.push(() => {
        newNode.removeEventListener("scroll", tableHorizonScroll);
      });
    }
  }); // 表格吸顶

  if (headerFixed) {
    const handleScroll = () => {
      if (navBarHeightFn) {
        navBarHeight = navBarHeightFn();
      }

      tableHeadFixed({
        bodyWrapper,
        navBarHeight,
        containerPadding
      });
    };

    scrollWrapper.addEventListener('scroll', handleScroll);
    onDestroy(() => {
      scrollWrapper.removeEventListener('scroll', handleScroll);
      unmountFns.forEach(unmount => unmount());
    });
  }
};

class TableModule {
  constructor(config = {
    cellMinWidth: 50
  }) {
    this.name = 'table';
    this.store = new TableStore(config);
    this.schema = schema;
    this.commands = {
      insertTable: insertTable(this.store),
      addColumnAfter: () => addColumnAfter(this.store),
      addColumnBefore: () => addColumnBefore(this.store),
      deleteColumn: () => deleteColumn(this.store),
      addRowAfter: () => addRowAfter(this.store),
      addRowBefore: () => addRowBefore(this.store),
      deleteRow: () => deleteRow(this.store),
      mergeCells: () => mergeCells,
      splitCell: () => splitCell,
      deleteTable: () => deleteTable(this.store),
      toggleRowHeader: toggleRowHeader(this.store),
      toggleColHeader,
      toggleNumCol: toggleNumCol(this.store),
      setBgColor,
      setBgDefaultColor: () => setBgColor(''),
      setResponsive: () => setResponsive(this.store),
      setFixed: () => setFixed,
      increaseIndent,
      reduceIndent,
      setPosition,
      setTableAttrsCommand
    };
    this.utils = {
      isInTable,
      isInNumCell,
      isAllCellSelection,
      isResponsive: state => setResponsive()(state),
      hasTableHeader,
      canMergeCells: state => mergeCells(state),
      canSplitCell,
      canAddRowBefore: canAddRowBefore(this.store),
      canAddColumnBefore: canAddColumnBefore(this.store),
      canAddColumnAfter: canAddColumnAfter(this.store),
      canIndent,
      getTableAttrs
    };
    this.plugins = [createPlugin(this.store), keymap__default({
      Backspace: handleBackspace(this.store),
      'Mod-Backspace': handleBackspace(this.store),
      Delete: handleBackspace(this.store),
      'Mod-Delete': handleBackspace(this.store),
      Tab: handleTab(this.store),
      'Shift-Tab': handleShiftTab(this.store),
      'Alt-ArrowUp': addRowBefore(this.store),
      'Alt-ArrowDown': addRowAfter(this.store),
      'Alt-ArrowLeft': addColumnBefore(this.store),
      'Alt-ArrowRight': addColumnAfter(this.store),
      'Mod-Shift-h': setPosition('top'),
      'Mod-Shift-H': setPosition('top'),
      'Mod-Shift-m': setPosition('middle'),
      'Mod-Shift-M': setPosition('middle'),
      'Mod-Shift-d': setPosition('bottom'),
      'Mod-Shift-D': setPosition('bottom')
    }), columnResizing({
      cellMinWidth: config.cellMinWidth
    }, this.store), tableEditing(this.store)];
    this.pluginPriority = 'high';
    this.events = {
      afterInsert: afterInsert(this.store),
      stateChanged: () => stateChanged(this.store)
    };
  }

  init(moduleManager) {
    this.store.init(moduleManager);
  }

}
TableModule.moduleName = 'table';

exports.TableModule = TableModule;
exports.CellSelection = CellSelection;
exports.tableHorizonScroll = tableHorizonScroll;
exports.tableHeadFixed = tableHeadFixed;
exports.tableToView = tableToView;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/table/index.js